const signatures = [
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            2,
            2,
            1
        ],
        "address": "0x16B2E9Fb08cd0e2428c202f7A3D905a5fD34AAa7",
        "signature": "0xe5d2a39764147f096037a586995fcc40c509780611ad529151995ec754ed0ee835366260235610df3083aae490368bfcfe9c561131a64b902b493ff7ec3dc4371c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            1
        ],
        "address": "0x9d76BdB08751a6F44EbE626548621c56C5Cc6E9a",
        "signature": "0x1375eaca98738e1ee81b7581b4610fba9c08c56aa311b9056ba23ed5c7bc7467776673a3ef35de337d986093d2fa39ff62950351437e257e89302f26dc690cef1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            2,
            2,
            1
        ],
        "address": "0x6884efd53b2650679996D3Ea206D116356dA08a9",
        "signature": "0xb8269eaa467ba1f959201e638d92de4b22711035c3166554e050cbfed658690c6735ccfa9a1e3438b730a78ca729074c90abbdab037383266b0646b61aee78191b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xfc494FDbD08913D81a2e2437ab408E624611F2D1",
        "signature": "0xd89c2649a97239ca5b8e0cc8fc145e57666e48bcdb7af81fd794b201b05e4add0afe7e8fdb8cafb138120fb48e0c9e1ebed1137dd9bbe0f2f1ae3227cf52e1ee1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            1
        ],
        "address": "0xad9Cb67d6c95a4B594438da20Aa94dA26059e041",
        "signature": "0x0dd8fe117e41fb0e75bf0a4023bb71b2dfce4ae80c2a44c259dacdb1149872d63e3517d0b5abfa6affc6d4c475810cdd710945bc2b6d7ad07d82ba2e2d044a9b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x303bF10D05c9371028c5483673c9A6886C399b78",
        "signature": "0x137f9d04a5def070a66924377e314e2867cbb858d183ccfae7757c6c8fa64cd417783b1433a59ee86a12b6953ab8fa4e5789ac518c689ce15308c752bd96d29d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7f675c7EEe03065FdEca8B7402D2ED1Bc05cdb39",
        "signature": "0x954e6ca21926eaa1c595e38b36b91b83b10fead6e8b901680a8d42f40cd0403126bb2449e22eb9d3e4c78886982b09e6b00f4711728463df4d8d4ed5f2a4f2a41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x75Dd5f847aD20a5C8F8551C83cE0cB18F7e9695a",
        "signature": "0x926cc13ab7faf7e7cbc0845558036bc5acfdbddb707ca040a6cc346da6c7b4e319941f17be430a61caa5e4dba5d5143f43ba630b97624b07cf9ff670135dab431c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            4,
            0,
            0,
            0
        ],
        "address": "0x10BC2E81704086285fc701af155658DEa46b263C",
        "signature": "0xdfa63813a1f55f12dd93c0bb1b690c605de199398760fb904a1999e7e7031657404eff3f8458c14ca2dcf449dd9a6c174ec641f1e250da35e16d7d5a433881ab1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x06265c671e8D558e83050Fb2F671d2a119dd26d7",
        "signature": "0x28f745dca6967bfc4ea498e5274fe833814e886b50b0a2eedd44166eb0b48e417c8309d3f99c7e58516c6142fef40697a448e7be8a8685ad2a6e19c487f699e51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4745A40FB232D7dFa329BCdf4cA8d91e8A695245",
        "signature": "0x3cb7eb1c7857e9801a58eda844873e1930fffcf4e6658abfdc46ab9af8ae8a6b1e8bf6791979dae28476b57fd87ac94b00ac088c658a87312dc73ba15c9a83b21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2C4a1f9bc6558b7A669F42C3E26702C47Ec7F46D",
        "signature": "0xc3f29b4012b5f360a69b15bb9580174ae20241dc4948cca5385a918fd1f8bef4245e20390d2a4f962d07aa6bc82a3cfd8be3f1c9b426609bdc70f2ea36c5b9ce1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x85938190DbB48a46B912f54b04cb2854b86695a0",
        "signature": "0x2cebfe6f9c01c050c2a784bdcc8a9f92785de3be961fccf93d56b76a3b308b084f042d0f833c4a8db54c039ba55c102d280eec7152c4b880b0d25a3ec398371f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x48D2c986afDc1d07861941c267830070715f4C55",
        "signature": "0x938ffe9e53157d7a08cafaf2aee94154b3d59decf05a8b45cf3332395280a77b0073cf9027e6ff82afa55c7ef06c8e2c84a0bd9d42a8d62238d73050a6ef51ca1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x187e6DbB918eDf24d2B1CE255016E1EE1015F917",
        "signature": "0x8cae93499cbaad3580a1b43a37cfd9a4eb09221c84d4f947939b8c6fbc6db1e26c9028c13652d234d21d85f5dfa186369fdbaf238896eeca7863a1f29779e1a51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xD73AD3540603ea57B2686322B30430B9cF1fB778",
        "signature": "0xddd1b7fddb762d5807becb75f6858a59714084be630a3a733eac96366d232d1d7e764b9d76194237e48a44071760dc6cb85ba482c09d74f21ea3a0afd9d938441c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x14f24590efB8FDb61DdFeE51d97DaF1bC1A3AdD7",
        "signature": "0xd60e507e2bafcff6dc38070c2e5b04feb0d1b2a037d965aef860da243d708da2230c760e5f174db01a80b4dfaa3ef68fa2a0a199572825ac48abaeb97247a6a31c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            3,
            1,
            0,
            0
        ],
        "address": "0x290d737eFF3747e072C40fff58F704C7fdabf347",
        "signature": "0xf8c7427ef523f0a13be0c44550c04cb787959bf6ba6e6fdc426b6dcdd9068817525d3e7d0583e969efc77ab0991cafb109c9f58f82fa7f49d6c2267b6bbf67521c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x712b85a7becDC1121e307caA9bFf35A87C1f0898",
        "signature": "0x5944ffb29136668463593643250dba961f478159280d81fb447e7801fbcec1fd2ac7f0b9f12eaa39b1a7a983bbfeb410b0fc6b5e7447a25dc27867cb0b5e509e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            0
        ],
        "address": "0x620Ad930b18607872a2E68D09afBBd40f1090FA9",
        "signature": "0xb834934d621fd4651cb9202617b9372202e91b2a6b11d4a63c3dc8a37dbd63957044472c853b137b09f2581dc125d9c3e0682c154d3d6d6a85524f0ffa8831b11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            1
        ],
        "address": "0x393c817d28f6C520AaBeadECdef9eE985B8e1cd6",
        "signature": "0x9846ab8bdf1165acc6278706c85bf9f3e118ac6a78ea6264ed1389248fd196bf5ae62e4bbc7d9d7a02b21a155f722d90916ac1c8f04e3d51445bf23a8df052561b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xcF2c5DC9846C6b25820EC1fDc282FB078b43Ee08",
        "signature": "0xbb729bded2b10f596c7b95e08912a4211f2df9c322ee89c01c3eea905cc084b8381d329c10ba703f4b1d71631c1242c85158d8cafd9ecb6349adef16e306259c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2aEA7D25Ee6c0599283AAA982D7b8b0BF5E423E5",
        "signature": "0x368c42350029826a356a5030da419c16d83d52679adb7b5990b85c8ef765fe1901e8192c995e5f2b42a7d7b6d0555549cc1ad6e4ebc6849825a35152b75f8a0c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4fc8c8C77DCA94f1fEfB655AEA20b4Ae58ac1AcD",
        "signature": "0x93216890fcbc519feb8b4246875fb7392975531dcb7113f68541e2588e0f28022d276f7a568de7d5a8717e7a2f29319dc9a0bb071a67abadba73b143e65d3ad51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x448dCf3F7a9490aFB3c28e126d1d7B474b8169C7",
        "signature": "0xba98d3691819a15e471ac52b7bf052405c25fde39afe9c79cdc1bf75ca410ff50bde3224c9c1df4ef078aaec14d82d9591a025c53d2cfcca3ea4ebf1591bdd0c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x57e9FC344bFA9c37a0b46D0C8E9DDfE5Ee8e6aE2",
        "signature": "0x441708eeb2c14d2732d8dcd50bff80f1d303c1ef6f43395aa4db2d1306e2ad0c018d9d2eb49a37f33f431f36cd67f377c7c5672a5d43b73d2719c52cf59caf211b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x312639BFD9c41Ed2e6492565462F018d366359F8",
        "signature": "0x896ca6693b4712ed29a7210536f50c1d0565615e4af3f556b1d05d79f848e0c47337b16125809169a83b769abebf1687bcb004f89d8c6110544980356562b8791c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            4,
            1,
            1,
            1
        ],
        "address": "0x39F8CE19269357c5f3164f43e9Ce4496aA39485C",
        "signature": "0x69619b501c86ff0cdc475072474c963b356b3dab7f95c17b5b8c8f00b897720268464ffb22b850ec49429e6e9a028b925824acf9d32496a5ddc68270505543b91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1EB3919eD6BE2c1C2809945F36a34E3c82e04C65",
        "signature": "0x9b632fa6312b50d7ac8e9af20deec084fcdfe6156458d2dfe5851fd8b16beb17310beb5db89c3ef918580f190c3b14327a444afec7635564c890da84d17259341c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xcb3D67DcF14C5fA795928d97Da232522CBa25EDD",
        "signature": "0xf7c45093d3f63a1e2b514d9cfcc1584156462a9cb77aef829341df5e141458cc3da514c1fee4145db5946c37da23a62fd07d453583babfa2b4c2435d29e9c0611c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDBb17501AEd69742f2f28190E42BB101af3fAaD5",
        "signature": "0x3c4d1295ce16c7bb4ee957bd3ca4ad4765f5e90800e35f7b1ee743ecf8e243d320b62fa08590364f47b8888cea213c1ad7c10234784b11b4b1a0b7f6c4b89da61b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd932B0D783B2cABfeA969E6e569FF125B0761FE3",
        "signature": "0xd85acd36449e28d330ce27576d091ff403a9d27040bdd816ec6038a8b7f8bceb1c5d76908db60bd5162eb6969a2f8320cff24078a33b7a052445a1bfd745a0ba1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            0
        ],
        "address": "0x4d7d2eBE2724176EdD0cF1efA2dEBe446ff8c181",
        "signature": "0xe11023e2958f10af297b02b084c9e6b71f76f86b28f018572c5d3e65f4be0e470c08619f754e1584e1259cb39f6211c6ec40773c1432788ac7daa01494c47d6e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x05CBbA06Fa5BF8d62a7ca02BAA3FfD0e30a9132b",
        "signature": "0xaaa87c972fdd5824aa618724c8ddaa7b6f3381e4cff085878acfbae119ca054f084fadc79ea47f7550c7b6ad07dae8059a1c6fdb5b024eca7fbed239b7c4fa721b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8873156a5e730702bd2E9262592555e89f1307D1",
        "signature": "0x5f0bc5c4e86712a050dcdc992cca53e978494226d40febda1b8ff5bd17b5e6d808e1bf1ce4ccf8c74c7935688476fc28bcac0435b0b8d57250d455c079be7dbf1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfD52113512494df7C71eD32bA1D212a3888b07bf",
        "signature": "0x9c9e233cc8aba39167d0673d67766aa3a02d079926d8b8c5c1977c3d1820d15006831eab5a532cda9e9bce8ed1793aa106152ed4b46e90ff7d6b3729ed3896001c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdED2045354Fc08FFfb5a552f4eae345b02920072",
        "signature": "0xcd471e7f55e9a9cd5a323fac9147711d6feeed018e9208e2cd2164107140894314c555df72dbe1ddf4fcbdbe05833c5e8fd30cdd5cd61df5b3edd7093153865b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDDD2ecB7aDC95116fe7CDdec5D6b5662B6701250",
        "signature": "0xed997b5906796aaa115008f62651cd2827705d52f5bbe81cbd2c7f05877a9b7e3850aae9da33ffa12d28cf13879c64541b7cf86f4ab0949b60b3c0ded5f57cd81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            1
        ],
        "address": "0xd4FB91190F3b6D563826474F536b1a4B78B56B86",
        "signature": "0xe6da5e8f23f715ebad0cd85b80df70f959607dbd8736f81720b0719ae1d0f5701e9bb5522fe78a25e477eb78f082158e1f05551ab490ee87ee3f4dc47af653fc1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            5,
            0,
            0,
            0
        ],
        "address": "0x53ad9cF96f4fa5d4a35fF7F0e114EaBC7292D636",
        "signature": "0x0e0041deded4537ff286e46b42d6ef3eb77343d1dfaf43c8f18dcdc1be1a1c0f2288a62829d2acf4530f5c15336e5fa3d557fec80abce45f2e70fd76b8369e661b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8E283d8F738E2846d0eE3C0F60784F571e76D809",
        "signature": "0xaeddd1a82bce4c15c416a8614791909131b493272df35f7f18c0d0d64fbc73317b591704e7b2cdfa404626170c30f502fddaca51a1473c9d145330dd2a8b5bcb1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0DA87134FDCf2D9Fbb1137A89E6B508Ec5E13160",
        "signature": "0x8183330cdc930a5fa7e14afe7e6f18f92f2f8e3a4bcf70eb1a2476c54605ebe03c5fb7121a0f1861afd98225814ebb61c1461e6d1a7d5f6e8cb1585577449aae1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7091ACD1F964e0CF695e3D56919bc3370b0c857c",
        "signature": "0x1169c13027d96583e496f1b909f4541f2f5b8ad13c654c88cebf98b40614fe0c6e2e0c1ceee95e675c0748f2c9e85f431e20ef2f4cf8efa5ec4609f27d5173491b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE26AAFc7628A3BDB0a32C667F27c15ED9aCfCE31",
        "signature": "0xa036dbea71c0a7cf149ab708604543eaac7af3521969646a2539df0dcfbfb07913c7befed3b34deafac5a9ae8a99010f825283383eda2bd9135272259bae14bf1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x17DC592e5f02092939C021C6EF1e2DdDD6218813",
        "signature": "0xe4db32a94f643fc822c7e608726f03584a2093ae430bda8659f9e0b768fafea51aca2e0bc08f22d85dd0ca5082859c036d0f3069d80c51f3270a878212d9e15f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5ebFf0F0358CA9ef630c9Eaf472d8e2c95bD5C8c",
        "signature": "0xcf90fc4388a65ac9bd5b22fce0e0bf251f0f7294b7e145887eb45fc8d4bd7b200770cda7bd009718d55ba80ce859d04e8ac7777b5f5688eb1c7c2847101304fe1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6551fD2175aF0Afd5F65Ce38B32be49A093e34cA",
        "signature": "0xb43cec278ce2d2fb70826869dee7903b6eca5a322aa45ce47f2ce77b8326c07b7d944565d3cd1bdfcb907ecc6e9fb79c03cc04f40ca390df899c22b8789f95261b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            4,
            1,
            1,
            0
        ],
        "address": "0xCccfa0bEB531D83863c3328Afc455931481968B0",
        "signature": "0x8d649cb42198ab9cbd4737a9a08d62c7aecbf8ae8838f67e7813d527514d604a258fe74b8f0b2a0deb3b31b7b1bd7ac41730066b06d3b523e35eae04dfa489371b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x62c8B6d8016beec9409A7bdD29aF62E0794427C9",
        "signature": "0x004ea5914dd7359f22f09f4d0c741877cc6b43cf02e26e57e5a28b36306d10ec1e944c2ab778f761b3fc7c7b7be7b99a5d1bab6cee0ae2dbec9dc4a99ca296991b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x39Cb7893fd476612175F53FAD340a5C37C0355e1",
        "signature": "0xfc4cd328315453c417ff7914af86ef34857c8f141438bd1ae23f121047faa10d47616ff5cad5214436b2ddb7308f5e1ae4ecf036b3502040bb08a1e9854125311c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd8fC63Ff9517eefef693520EBAF9d68ba9f7b2CA",
        "signature": "0x85675033e9b6c3690efcaf2927395e85ea28dc63f54e3a4d89574e2c7135c3ad53d0799d9197f24fc5f50a23c34fa872adab0f906d921b87a0c6b900452aa4341b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x6f35C2D0C6f46cC68b3EaF526457AEC4A6af6789",
        "signature": "0x249e9da04ecad3f21113d6be8277d18aefbe34e6f83ca25d806262d33063a4447d9996e2c46ae3ce6b3bec91e1a854533ea698070eb52b05bc2336a0f61e95451c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdE81b7b76c9aa87D4EA29c0C1A00D09E2fE4e034",
        "signature": "0xe15170af64f07790493e0beb616b9fdf7339e897c49ebb4c4e72680a17f4811c085b5419e6c0615b669cb4c3e4ffd18a973765da3e1fb454f0f336251d2d4b0e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            1,
            0,
            0
        ],
        "address": "0xCBCbB480D7151551035442CbE7AC85d2f69f672b",
        "signature": "0xec7902261d91b851b1a94753cc27c62cf8ab20ade49ddfa275140d9b1efef2a445b5aef3692949a55e9b8cf531bf5ba7a3218c218b67c4d1a6969aa204db03d11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc066A76701fD2Bc6b6c052F51d71B63275525B9c",
        "signature": "0x8487c034d75cf20fae7d5a403822a82da7de00fd2d938b85a8205ef56b18fdd3169b9714485e35e76b099d07ecb8bec95ab5789e5308603a1fb8524bf5dfe85e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6CCc48fF8E31Df0aC144341ecB49870c23da3462",
        "signature": "0x9b8881f8f73b6775c708fcd321435e663f6974718c66580b5de90eff2820c83621cbcf742e1809010631646f6f3bd108a85d10ba2e3bb0488f1c3400c5f6cb781c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x42723163636a5Ba05925F543BCBfB5DCCACC81D8",
        "signature": "0x308e06b44db546f528115d5dfa03bbe71657fe0ab1bcfe6b7ac9ad611df58f1c5e30a8e0183b42687b3dd3e370f8faddbf200d2737e16cee9f7620d138249a3a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            6,
            1,
            1,
            1
        ],
        "address": "0x4c29aCD2C67337d34936A268e4658Ef945a3c068",
        "signature": "0xede571ddb28ca6f09892c45765ed0929157af706415d6cb6ccd2547e7c66198212d08f99adee2cba6bf41b78f4e2ba3725d34500f225362786dcab09fa6c34af1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9bECf684c6c457510FEF7C3FE645edcbf3b3f475",
        "signature": "0x1a10f0e3365d08f54a72bdee30d80d78a1a661dea89bacbec72da68b3a1d36b6430fb9cb28c1884217bbc66f4eae9e2bc7dc3bc91e5d6a9d88862253a9d71dbb1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1c0D1EEAFbdB90F3B54ac401a577E3bfc551B16a",
        "signature": "0x182217bbc342bd6e733c39d571f38f8158d479356f423cce926b1fe4d3f47f194acf1a77e3aef290f30c0bb420d7acecdd95afbde683852fbc23f704e5638b131c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7bb028a57900C55806cEDd0F3fb404eBFF3FcB89",
        "signature": "0xee4e0af7c69873c111d283060fa1bd24a1d134400994e47f97020e2fb3b88a6451f5e30cb680a0ae9218e7b70c10f557c6bd9ca275d9850bdaeacfb7f88be6ca1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x380F9864daDa67b1891302a53A67A82cf8500c38",
        "signature": "0x3e5fa9eb15d240b981195bee053e96c331d08e642ad846b3cf3f46cccad133e9657328cde3b931b6abbc2724dbcce57d7816ae6093d59cfe13db8dec6c0b46681c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xCaE2152AEcf94B2BC6D81B72c43f6a46FC11740C",
        "signature": "0xc2ad0917706a7c37dcecc08b28f94c4d985f0c6212d2a93bd3a06a8302df635775a37d8318cc54bed23ec91a5ba2d50813c52f893c78cc1ab611d79596a18d011c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            0
        ],
        "address": "0x82708FfAd11058A6c711a5264CeE790326ff01f9",
        "signature": "0x6e56de07c66a74db4fdec68676321bae013c6104e80f9346f4d1d2cdebfc73e36d3973c08198d0069d6e004cf493058af39eb287f3e03553426c39e1750104f01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE4E6c519Ad54DF0E205973C561d09bE418bC3D40",
        "signature": "0xf93151ff1c33a831298e8dc68a82479e0b9939df8e88b482e1454ccf38f2fdd423248ef0cd01e4d69573c3bf10aaa3fe9b172a67c31009738aecbf19a9b6488f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1B445585E8E66363f2D9F001dEA4D130C21Ba2Fd",
        "signature": "0x47932964fa5d9c5097c43f8be6ac56377f62a7158bfb4fa47d5ce0f9a95a499c4cf6100d7bb3f783546ec08b1cce8dfd1fc4f0957aee3073bf72322ddff13f451b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdA3Ac99c8b71C21b8701255499446767ed20e0cF",
        "signature": "0xb2c91f22f40b30f05a7548cc063ef84993bfa176e8f28278c67e6e02f87a01fe22adb520102288359c0ecdf8c5d1fde09236deea3e373bc8efb0f507b492fd701c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            0
        ],
        "address": "0xa6D2D51ed8656891f026D9378E166e5b196d71F8",
        "signature": "0x78783bd40b8a71404a9d223a902df0497c2f5725d9e7964f5d3bfb2e2d9b86ff739954fa35ebb7a25caefbe3abbf9f5b09143b3273b0e4b9e97739a93985df4c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x61D17E397b82ada7E578DdDbfa943AaEb3ad93aA",
        "signature": "0x99401a2f4cade431149b80c24d92a410991e7c0ea8adcce0c56037f2362280c12c719f28c0b8b3ab553e808455ddc96febd91c40ca284632cdc81aaed85f07061b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x00F006f3968409c6072299341eeD38eE127eEbF0",
        "signature": "0xbb8ade86fed867b8587ef7795e4dd2eaa5c213e8f3c530776d8ea83d514e991d3fe02b70165de292accda4fbc921745aab583facd0c3ec53eab6c0c31e28d0151c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            0,
            0,
            0
        ],
        "address": "0x822511d3033f0D6Ed7b85F8EE1E62db290E54571",
        "signature": "0x238b67bdad9bcb84d1384b47fd2bdafdd1b8486ae6a84c08d5270b18c750a0a501c33b23ed839ae586539982cd2b2dbb84740c80847656eed7d9a817b4b945c81b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1cB70C4FdA9a76315dA01D6f5fd1AE029686506A",
        "signature": "0x20fe042831c67dd4ff6d9afcfe3732b100af8624185b2811076a5333b6ac960b6335a036c54f0af63b9cabdd836fc41cb5b5e89ee45497a1600b90b16d37477e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x56769D3Af5DDD4F61Ff56F65cb737da78D79bDB0",
        "signature": "0x180d678b3f1c5feed9501e6602ea2e414fbbc73b3c0a08aefed2d5305e27a5491eb3bd92caa27e965a00a340ec2949428a3a2806d491966d4d109c0cbc5317b01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x275e80704B4ecdD3CF5792F16Adec4cdfdBDD736",
        "signature": "0x5f5326ef8193741756d9d9cffef930951dc43824aaa3f283fa8efd2a89b0326f0ae481fc65d9161677eec1e652eca102d37445088e3ae73e14e4c7c6ba0be55a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x420fbCF054b783287A4B043C3236b9c4805440fc",
        "signature": "0x2a0a080947011b5fed70fbe1df6d8d40ba2607d1dcc59de9f10b502c214f2fb22711f91ecd5248039b107db48c63377d7f0ccd524b0587885f96c66031788b8c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            1,
            0,
            0
        ],
        "address": "0x1cd18821Fc3c5de862C4BF4140AA4516C826e8b2",
        "signature": "0xd92931e10de38572bddce570bc950d27e21398894194911980f7cd67699021d0787f21ccc880fff7b5ae067f6ae05134d879f1a5de9a31b8aec7d55b8ae2a8091b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB5Eb894BD51F53848Cb7D42895a0EEB051A25d69",
        "signature": "0xf9868a8e91f83785a036a4359af0ca5c74118adf452133c8ca10621f1d4a0b3a688a4d148e07a39f60cf3a90acab7de87c236d2733fbfc08b31f979307db57181b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0aa0f38De976e2B58A3A170eDb83A2A23D52eC5D",
        "signature": "0x368f9b7010697235290f32f93f18c38ac4052d5eddb1fdc7a0dee67dc551f13422f6c830511abc66775173c3e97c724c88822523e32b41cf0905abee70df23041b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1d52f101B0826815a96B892Dba99e7865796996c",
        "signature": "0xc67947a6245416041e76106e1f73b52bcf576e65b1f39f662edcedf369d46e3278506de8b4f75294bdd3bb4fbf42d812c50de5cb80b3845361e92f961c6ec5061b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5b1E416f52FCF9D41dfE63A65aec5750c456aE5D",
        "signature": "0x5b746cc1d2e5ec9bbd329e4bfdab93434040262f5d0948bf8bd940b974ec31b92449bb8b918d7771610d77c94d2845c9f6ca78ff88bee05ca4c83487ffbb9f891b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9C347C95fCE860E4670211551C88A4ba46940c6F",
        "signature": "0xbd44aea631096b012981bcfba57c6e3d57db6ae9ced992ce10d5d9aaa614b6667fd01a394608fed43c166ed340c98d339dcc1de74b23faba57c7a67b10a5da471b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5A7b9B92A32A760f6AD4602b53842D3a2447b4d0",
        "signature": "0x8359dea6c377657f2e926a992a40e029fc5c70aab2977ae6571ac8196ac2a8fb0e2f47e8568706d5624571478c4323886061c57262ff13edbc0276fe54641e431b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf893280bdAe39a0a8Ad03B31627786D1B7720D3C",
        "signature": "0xc887448ec10a252ec73f0ab24d15aee98a41dc906e651e64138d89939b9204a965eb0ab63836b44d79433812de675d5a842382e08dea2c864e79fea2c91938381b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3BC33Af46550DF6aA943387b0022E249B43A67a7",
        "signature": "0xa3092a46de4dc7930f53f3e0518ac4b41889376c09f4cb4cca384d209077adac08261cc2deb0e6f38c93c98c00505fe3fe4a28a2a83cdb64719387aa8f2bee371b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf71C488E14d988e6e5E3e85999ab6a9C44598DC4",
        "signature": "0x743d3882b68ad8f1d7dedf9566ec15dad48b7f340267b0e76ca77d45d75a026e484e137485daea32c5da8eb57681f3faa4bb1b6e8e8a72c2d958999eb55efec81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            0,
            0,
            0
        ],
        "address": "0xD7F74549615603e4B1Af6021Be9163a9988E928B",
        "signature": "0x0319162718665f5ab3083391c20158dd165562ec3ba64b57fe7a657305a6ecad44a72b134d057af3d7eaa61ed54cb1d0b8268ab4f145d033493ed2f10dfd49701b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7E3BF166ccD3DE68Ca47a26dc13CcB912A3Ca46F",
        "signature": "0xe43cb6ee47b06b02cf33bbad71b8ca03f40afb2e0360c6717074ad44089075506d27cb902c6f579b38d6467314e2f46ee41c477e966d4f23115041c0bec5ee5d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5797D5a7668BB71061Db93C2C6C5b744C6B07040",
        "signature": "0x4b50d5d57b249be97d26a607f547d7be8ad3f59b696e62d18ba5c4626fb30f5565548efa42cb78ccc9c8017784118de672e3d4944aa3eed3b9ca75a3eef40f841b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x2532f67a6FD6d053fAfC9aD0884a62168Bd30fe4",
        "signature": "0x1b0f028784e4eff4ca038ef5450929caa436523376f9d927cd613312171b58712c8516340cefde41ad34aab3ee011b3582c82f1fa3dffa7e484af73ba295d3131b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x851064FA64c67b79E7f8695bFCD55fBF38e7bB4C",
        "signature": "0xaf332cdc031499625cab45460b31333080c14fc2ba783fb51339b1fa8dfcfd295928a51d1f9362f3e38f11f71c9ef343c5040b9cdbaf3c04a928055bca94c2581c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xaf0Efe8911439ED665e43b45327ea1c25C7dCD74",
        "signature": "0x579eee1c09175e5ba96bab3798b85bee31db9f2158f964430954fd371c2ec6451543d1b319a5804fccf9ed3e6740c8ed9d513e231440e5fc0d7ec29989a6da231c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8F38f791DD3c23f5a4186CaEad6ad71860721536",
        "signature": "0x36eba3363a26d33f6f0e9a73b467876fa2e6b438019c64f0ff1b7194bd2bae475d1973277987a0cd1202931aa050d04f67f743f115eb2a7c49b3e2f1626ac6441c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xBbB310273Fd41750907E4C5d6C74a4bFFa79ea0B",
        "signature": "0x46c233ccde3c9ef22184e1f53a14706ac01bf9e930a1422b6f6699a808791d99436ec8083b3b4df7974c9f74adde96404aad4df4e31073e1ffda40c2ad61979c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc6004789c2170dFF207df122Fbf30630Ec492082",
        "signature": "0x5dc0584714240355f701077be8f1f50b095eb89f036f4aaa689aa5ded496b4153028dbfc1468b43cf06ace32b1c7decdde84c2575d63ab887f3a60814dd45c911b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8C829C4Acb474F6AC4ec766e4bA8E141dC316278",
        "signature": "0x6ac30456eab3780676d4e9e9f66a247f0988624f530c4be4474d9c5745bb4ac423d000ae4706ced05a2b3cdfb3d062a534c6fb5628200a906611013c984c1b721b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            7,
            1,
            0,
            0
        ],
        "address": "0x7bccD45509EAaCaDaE1274d77696282b6AaC56d4",
        "signature": "0x7216345437cdcaa49c82c8f9fb2cd03e1c31258201cd041e929e89088a4d90895d8361fe45021ee16237eabb5b4b345457f093b2638018274a3dfda6dcf2aaaf1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC95DBB35c338F05e35EF45B014b2EaB8cfbea78B",
        "signature": "0x9749f92f38b15ff6f917bbe7e57be00942209b0aba425849f6a01e6d61c603755999a1d972074fb9e291df37b0e31aee658969271c5f10c01a99459d106066221b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdC9B111802370c1dbc509291aE35e6511f5F16F3",
        "signature": "0xa2e630c22b152a25e6c4440ffe8ac4f3b7766b4fecd0b1bdc73c42b5de30f02a066d384ba4d4dbd058320eae4a3cfbfc9ae3243013eac9e6145abf1944df56f61b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xcF77421060Cf173949B2E05754C13056C80E4F3e",
        "signature": "0x0470d0b434313b154910f548828d459c1b633002fb3e4cfe29fd3704d084bd815fa21ea687db3268bb9da6a0ddd1b758da8c8f3f0883c001be242cc2deafbcb51c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBB5EF2f294020D04c9Bd1466AC38e5c38b3B533b",
        "signature": "0xcd006d0674a24b3da6dbc3483da9e61c70b7d5c7852ff77c7e0b7e21cfe695c062edd29c6360a9b9a78e1e81e5ad8e5ef197f45e91735873b50ce4bda4caca711b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5f868Ba7f7c61521Ec0634FC87A0eD0eDdE18AB7",
        "signature": "0x8af8fd45c8afab40215bfebc4bee79ced7cbdb6f31eff6cae2f5c376c1861e307329040195653d8a341889fdfd540496082648d990894af1eba1a892a8c5d45a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0BFA60732e64c3ac31f53E00b0De9FF3F581Ae3f",
        "signature": "0x9b514f0b2df93182b8c1484c08c0c2a35e0673c95112f95baedb0688c545460b79805d17dd34cb20341b21c8aae32a3d5a71aaf5e4fa1e9c534cfd69f7ffc18b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc61b17213eed55723a4c97c8F1437129f92961C7",
        "signature": "0x9c3f89b6a0c1fd94e58734a7247f6cca2b9db1bb9650fa669ea1e0fc69b61db520140e7b98111f2b54319ef4cbab7acb9355de3be6713296a7d227ebb5b72aa01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1A2C03B612C91f6eecf8Beaf67ABe214d8b86d24",
        "signature": "0x53f067104ce9baa5e22ccf12d7078d70a98f161ed8c92d2e02b404fc574a6df24c86c7cc9033871563bc960676104fdeacfbc8beec4315fcb84f0575579736be1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb0390D99Ec1C321AB7fb354F4730aBDE09AC81d8",
        "signature": "0xbdf2b0c2d3ec71777b8b0468eb4b97154faa4d4db6cfa2e0133d04e7309fb47c616e3ef0fd1aa63b1e1ec0044e7b7739f00bdaa3c8557fcf57ba01c8266f82dc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x75bF9d5a5eD2b3ce08817d221F4D2103280bcF60",
        "signature": "0x2c52bc73b138a91bf9f4a1e3bae18f06c432914e962c6ac86f3173f8947d6e94455b492c26e4232266ab4f3a788d86c3448c5a0f895405d131179528c0ba80721b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0AEaBEcc5383D9A690188571b1515555140C899E",
        "signature": "0xeb500a5a915f1c98351ba2d9443ceeb6ef85930b12d4037bb4dd6add408c766a479c94542246970745bae622301aa6428b703f2726614c70ab10ae308f054d651b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD7cad0ceE63c6A496829C19d5f13B6d7f8E0564F",
        "signature": "0x178f22a2beb7c659655f8494fc9e7e67e8d1ccba5db917df731925009cc5123a1ced0a65e10cfd482c99a1ef4a9379c5160247280e007b4a56886702aabd5f1b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3Bd2BAe6e587873254FC4b3332024592C341Da38",
        "signature": "0x9214d726f27fe56c396d641f468322285e9e489f265b14911edc160f72e02e141351826540dcc888be67ccf5303f05feacb5969f3655d98f4877f22f5d5ebdc11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xca44ba3e1dcC5855C2c864BC76D503b05B74293c",
        "signature": "0x2c25c2b2988ec25a11175a6c33a2809abbdc5faba99e382e73dfa770ee1aed805e3e92d703ab9748d5fb8458acf939e9a55b08e56aaec13567faa3ff944661001b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x111534f6F164eC56226Fc6403316762d5de7F827",
        "signature": "0xf2cda794fe151509dbc06fb557f66cb0b70b768f4d66326ffe39d790cb27526f0d76183d3b892dbe80f9a964ef49a4b763ebb56b282fd4dcba13acdef87d8fa71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x787E371945fAD4A346E305d4D7C3375070f906E3",
        "signature": "0x63186decf332825c42571ee7772791586aa708baffe61d4b93dffbf47074dfd51c049e516e4b6309474eafa2049e791ff36213d98620196ae29e5b9979a6ebbb1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8A4619dc43b816fA07Ba8163Db4Dc45bb0c46ceB",
        "signature": "0x5a2a8fcfe65a35455f7aa7bcf0ae425ca8dc43d70ea7d91b5ab71d117675da4b266d055a02357b645d466bafef48b7ce3ba1d3c480083434493f11cd5ea989591c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            5,
            1,
            0,
            0
        ],
        "address": "0x245411Bce8ec0bc3ECE28148Fb03958FB87391F2",
        "signature": "0xe9aa4c19085c6d2f28a7402b2e6db4e88bacaa66a9304b212a7074fc112b4b891c03ab1866a17c1d5ef4d68f52403b462e026c7c850f42c69cefcf0ec5186e3b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x947bd7212E0F2791A1A44A577367D0559ECd2673",
        "signature": "0x4040b4a95682fa5dc26205e0cdaa6cb99f815032b4dad59d00ecc971743a00700aa6c32cdcb9f927f56c9bd43f00f163ee702c1328d06d0c6d2dd4082f63529b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x2B6bfA1157f4c7338B0842244fDa0e97f71248D6",
        "signature": "0x5126fc51721bb9e11d295c9652deb1a1e995efa720ab7efa5f84664590fbe52464fe9b6b5a06f9d807bf751b8be34ff1eac23827bd07f939bec216f376db931a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x662100D6942Cb22A36386c175B2Ba932935E31b3",
        "signature": "0x328cf44c7e7a6b913aca813bcdd2b474f54bd33755e7a86b0e22f7bc5930a95e2ae39f80dc23ceb4f76762f24a8894bc648e4b06f69876529b9346be3bffa7821c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe6EeD51eD46b8a573D9F1924070433f63A329333",
        "signature": "0x8f74f84fe03c814a0c5b76de5694d5bacfeb26be0f22656800d4612e0524cf206cd3f07049654133d358881bb42c7da00c449ebeacd7c4d7e4a05ad9a986e4691b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4Ce2C4835BDceecEe271BB8839f8871882Ac7570",
        "signature": "0xe664849ad62ff56e100f38290e36ba1e9d2a60239ca1faca2e80dbed236e04dc2cb46cdc52abdda82c23766a44f4d58cf593396cac534d60c7da8bfc75c7f2d41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x78F1e5b227Db1352451933b88E7B52E83848BB4a",
        "signature": "0x9eec18bc5ac7782710e5342366b3155d0fc197a6dee1b4bc778084bd72e4a8cd4240c3a81e94510c5fe1df532a53afba7512a7bbf8ed95e1208fcee79909531a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9D05eCdfDA8b52B2d515eC00A7Ad22402b332E1a",
        "signature": "0x8fe694dd3905e277909905f3caee28b4c123123afcf791e97cf0ff6d0900a3ec1929bd5f8b32333fd41824651c8c753488f20c251fb45cd57886ba366fb1cca91c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x555a5BCD996A2166b8AeeFeDB560E5F3CE2a8F69",
        "signature": "0x1b95145f8b56035e1e87c1bcefc40cb34623b6991e49f6139b9f4febb396a31e301b144e37311151e8cf825ac86c20f06ce4c7ccd8d1d7e8ea45be37796968141c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            0
        ],
        "address": "0xA01Cf2daa257d3B7dD3e4Cd4D57E8a23c0c313fD",
        "signature": "0xdc5e436178ce3e39e1db5e6bc939a504e94ba9a0f8278315ffc6877eb46a7b40502b09c35539e4ecda4fe2c60feebdf63359413fafc6bab12a3bfc9dfd31e49e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe9d4Ac6d5206A9d753497939344A827C0c120A5D",
        "signature": "0xdade2668f78ef5f7bfbd895ff475c8150b585b9a0ab51f6305ae113ce0248d551b0905b510503094c7213091096dbd9a078f69707846b2c911a9c128b937202a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6aDEaEC045cC0F9e742D58204aFec7334F799849",
        "signature": "0x82e1a7adb0efbc128cc645305907384e63f1a4b5c2910aabde25c6a0a33ab8ef43697c657a7638338259271edc8e45e3ba0824a50d0f491d9d154802aee577a71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x51A51f458b785bC71d6e2508615D1Eb2baEE86eE",
        "signature": "0x67487c079f2f30d2860883dda6ddf5e6eaeadd6aa7121d5f9116b1d82073768c2bca133a5ad07e955fd632a5f3455a7aef1c0810306ca72af5b3bab4d84aba161c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA0319F181F0dF97d401450F86Da08FcCdA05994a",
        "signature": "0x87530a6471e504addf63b58281377658221a0d7dd5bc3a4279a1893e3d70fa797518dc5ad6ff7aa2fbbd7d22822116a92792e6016b11274b3504307b883bc5c21c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb191714faF67c7Be67fE83c1Fb86eBB5aE00768B",
        "signature": "0x1f2e4dab35db03e6f18b846e7adc12b0125b396585659ac3284e7fbb0829aef27b3e494e05f9caf3dd71e2633511c09afa15a04640c27399b2c61ce78cdda9bc1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF2596085b5727763C2460601faf6Feeab8a838EE",
        "signature": "0xaebd88bda76dbc5adfdcf6fb61c0b0cca3a6c552ceafa9d407448ee6d2ee421e22dc4e3d9999a06991dbad894c378f12b77f0640cbf9fad86037fb76dc9f3c3f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5554e2dC99a9dBc7348d4446A19853e655509980",
        "signature": "0xa02ee46c4f2ab3dd08ee9dad2e7916fdd724134689e9ab367419d1cf9e83d4e154d7f507919a15a95d81713bafafebeea776447340b0f16b52ba39c0cb3f9fcb1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xF7088B8C2CC7fae86f5F3C0CBE38871422B63645",
        "signature": "0xeb61f43505a60f8bb3f343382bbd01dd6bda2f7a4c3cb05c6ed3cdae1315f02f456a4d6722b015076bcd3bc8739590fe81fd1ec5f70dbb49497cb03e662b4f621c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc997B792bc03f357f0168E7Da99011C052df2836",
        "signature": "0xea4611cc5f237e564148ce7f87eb4b7337fbf583ac5aad62d5fc84d7a5139d807e1976e6576f4e7fa181c1259796744a87fd914f927ee85804197259c418e2001c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            5,
            1,
            1,
            0
        ],
        "address": "0xd8c76D50Be9A0f96B2fCe6ff4dCAA8d15031a698",
        "signature": "0x8e4fba7af8e9a57451908ef19d592b5022b2021b8fd815aa9fe9baac4f2050125a254c34521138423b78f958a8b0e6bce1bfac0e06dce716b2d54192b5cf202f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF830d26C454d835E6D21a802ffB9e9FE1Ef3f768",
        "signature": "0x4bf68ae3d7a05521e02835c5fdec0d9674c0186d1ad2628d4e5a80dc3f4490f077b20b06400a7c0c3fd0b71f60487ebe87af7a662647a822b3430af53fe5e1521b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x99Ba9e63bb174Eb43f107263791d20af22be8D73",
        "signature": "0x3e987f6001885e89de431acb9ec62bab603c0fc41596abfbb32bfa8cd5cca5270e819ee3f715fd9433eff3e0785c781658dd3df1b8ccee8b7406e1e7b57fb5cd1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6950cB7e837F05577be5F0db10FC10269FB1680b",
        "signature": "0x3722b651f0daa4264280176d2505631b032ee4d70d3ae7e565894a8da787f574699742e5457d04e12a68eebd98ef29fbc8aff7be4953d1a574ab9a2a503368f21c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9F144080A274f127aB58b0c393D49B301b6283F9",
        "signature": "0xd38fab6038ac4e0c48ba5e1151de0b76c497f39189831cf9b432e8381209cd646d836c65fe74d099bae97dfe97af4737b977c7984ec80692f05d146ee6f464331b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0f06da7aE46fFE6823dAfCc84C9Be3C8faA814Ea",
        "signature": "0x4efc5473a50647abf3e62117caf04c8d467579781636fd8efdea66fe384155e6109dc57d93dc00e8696d2014830a9010e8097fdb454bfa6199c45dde8be8e4461c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd07248db8030126d11C0D6EdaC59b11362e4b45a",
        "signature": "0x0a847b8db301a1bb3e6121ecaa5350d8f54d925769114a08575d5d9e2360d83a7a14fa3c0553fd82e65953d3c55bab6097bb722eda7b1ffb43c07dcad319af1a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1f9dDE8381e702F3049e0Ca63b585dD55CE1087c",
        "signature": "0x18f0348243d8945e6c672863ec12d6b07305bd9b4a65822503af5cb02f6e1a75026f15fc1ee65311fcfad77565f1501e43043534f1a260d16ba4ec73574460f61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x08cF7aA6E314c4e5610E310149197457e123E1b7",
        "signature": "0x07acd5c2cc487bd8c9553f45d371cf02d119677a9fd20e7c8f041ee885199c7b53e0efc7d0d21719574fe1392e69f3d960727c217df3aaea7d472732907f5c741b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc09143dE9420750d7a23d88442AfB7b898D4E776",
        "signature": "0xbe2f6968e2be3ee3c69f4f7071615aeda9be8fcbd49d6819061f7229fddae5ee10ec19ffe3ab9d4acca48595f9ed7c2f0815f0bf2e9fc44bb34c38b86083cede1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x92B2A318a6F7490cd94419e6835D817a39ba0092",
        "signature": "0x2df44789411d6e144d26fbf866752a9708214ef8e9e5715fdb7918cf1e3875845fc502c46352f138942a4d5712acd9e54d318b4a930f8c69fcefa6ce7d8320541b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6F03190a19ed23a77c7Ac6648af940E83Fb49d26",
        "signature": "0xacdb16046c1a544c9363496bea7e8775f17a4333b2b37fe801adff14daf85dd8497fa3f481f634c6acbf144a781bdb43468f48f9f23a024fa02be079b24455ed1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6Ea1958B6e1F65bC2728127EB96a2fCCf7B18DD7",
        "signature": "0xf0a3c16c8d03c8b132e52365f90e4305179a16188210a4eda02b6683f8c192576f95451b99da42be76915223a7b7a61b095912a0c40a3d99249e869b3b4fe8bb1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x09d37E3B837C593279a275D11a2cF41f69ac90B1",
        "signature": "0xd1aca20fc459d0d2e6339c340ea1b1818d60c526a812ff09be10091176af1b901e9d03c3236e79cd08aa8e7a4210b0a7d3db3b856c57484ae9c3b84fed3e267e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfaeEDb37f1CF0E973F346A0864d335A6137727e1",
        "signature": "0x668d6351c5e3630d90cc2ee19dac23f7c6a30b23ee01e72d864d9472e67c4647536f79cfb102e50c926b5a96d09fd8b1f8b3de7e27ce5e05901262c799bd5b8a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBe3F82034778fbF474060f7D4a032f592559ab4d",
        "signature": "0x7db5b1e614a427b675adf0034447dc3827f410af328d53636aeeb8503c2dd1c44934bcf173e5c52410da848d888fd4a9147630e7876ea669586c3f253dd011031c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xcFB0287f845f2EA7406B6D38474377990c003546",
        "signature": "0xeafae6524e115f9632c0d43181857521f7ae87b31f2d3d23a1abcbaf9c338f4c62300f4097ba55b9960f4d905ae68199f778b52ef5734742cf12e3eb010faf4f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x15260EeDD29aA07Bfb57fB6bC0C6A26363b1590b",
        "signature": "0x388ec8aef554391be0b0a1fe7a74fc84351021d90b2348141b0963d4858ab4994e7ca83ecddcde785c150e9c9abf1f28cc02b9d0785ce8fa8ef609ecbbbe6d541c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xaf74fB9347074B9aD3c9b29727d477FF4137aC9B",
        "signature": "0x85943d3b27101272e31c8dc936796ee6525f1618741832779d895c5d1783b7e64ecb60b7952f81c507895b9b686a502f224df40cc88c0be3493587b276d50dff1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE572f8Af7d9486dB2914ffa58E2E3890f1D70A15",
        "signature": "0x54f24e3329c8694f61ad139e6bc9207bd3915a1df9f6435f5a0e9bd63a5e7f3671aeceb8f9db76803270d2493ffd37c15562ad5a2e31a87971544869141b18491c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            0,
            0,
            0
        ],
        "address": "0x924dFc64278943cA0a70e766eA6a85C4D384c008",
        "signature": "0x832d2d478d01c0b1c5217e48f3c7eff02c92cacdc022e50024e588728891610749bcedd42eddbf50bab3d14d0be10c34f7b0feeabbe068fa800f18864d231b681b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xAf035e8fd7749F09324116600c3D3A2A6f7D7E1E",
        "signature": "0xab79287a2e204a4149b3f3db3c88c7f0bedeb229c80e02887d3c1e126a79d2ff396563cc804f3a74a909204d86ab31cbdf024618f2591e576069080bcee0cbae1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb9e0fC5e523CCBC006da041ef2cC5810237e3b0B",
        "signature": "0xc22fac95fdab3421c3b7e956161509690b2167643d3104f478eb0aab251bd00e06eaa3a5b1cae03e6aca2d6263301ac21ea9d045be1bad003d18d96e35a515cd1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x39d1865b59003693723327BF93e83CfA101e30d5",
        "signature": "0x7325c89a6572788ca5886a836a22b10520759e3a3b8c2f9c12b876a6805a16a56532843b6ecd1326566bb7cab89b7ceb2a7ce985b9ef5189eb263a1e82f8e6081b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb152FA1CBBC91c59f7a8A9012cA14BDF5Dcce77c",
        "signature": "0xa7612ea68f44cd25505e7e8fb673d43a124cacd17cfe8ae640b7000d7e18bcd949e6b54279da7607027bf5b6ba0dd1642a5d565870219d3866fb609a6e7ba3c71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF630515F8a2c4947B3E9ba76a4f3489eE8Da8beD",
        "signature": "0x6bfa7617bea52a0a03d75f882718176051d1e6b8bf5c84063fc3df20a41440804712f7cd0331148ba0a8739e124ed2bcd121a72f6df4eb37a33627c594e900251b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF2e380CdfCE6185BDb27FF97e8f563E394fa2878",
        "signature": "0xc270b59276fc021dbcd28628e36396c8d608a18e8e26f9358ca9d0f9a392e5c1535eea3059fe7d6624cc189bd306bcae61ac4b626ac3fa566c68e5b7569a83321c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb5145D6e514F7f27EcB19d64bCBC4cb8a8f9Cf88",
        "signature": "0x9b53071fff4f5e7120c4b72e4bda502d6e02860f878c7b9af134f2d8e6c8b14124d00fb74da9cf5880df43e1156aa5f2b9d543c4d30b8b3f4ba2e3acd5c9b53f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6fd2662CC6d80bFaf3C0Daa1A173452ECa9d763a",
        "signature": "0xeb9c855ee390647ccc5884db374dab6185175c7a5baad9683d06a5bbe8a2cf9e0ebc2e2d2431741eb5cf0d04e2a805972278e18e0fd9ad430b6c07c0251f51511b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x703BcDd351D5A07440d53A099384615C3c9f38B7",
        "signature": "0x6f500e7e6d54452be3f66b2f4e0928ad92a78c06218e26bd150b352b7c1eb3280b91138beb42aecc4c16564d86b9be2ed5d77230f7d1728d2ab68b7b8252529e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9163c4C8afa247c2676113F8379b4c3916Ae3304",
        "signature": "0x46ca72aa471d04dd97f622c825eddd2ac8cfe0eadb5d58931bd93f51f07f42347c96849ba675304841d9afb239d175d9455cb04768beb8ff08de8c0ff86817981b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1497350e2Ad5849816e103CD30d44a82D8735fD4",
        "signature": "0x5e140585509e2e79e36ca411dbe85156aff38260a5e431cb31b69cb8c49f3b103f3fcc37502aae56f9030b2d12f40d128682f5742faed1c3b1c93f5eaf9772a61b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x531E98b5E1aD1b29ec0CF81fCF7a650438394599",
        "signature": "0xdf70e4828bf57def1d6be4225292d9a093b58ec243efd604c74821ff9b2cede17345487c24bade72a43e2de3c3bbba59f7c422f0164247c3b196fad05b2215b91c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6840523B8510E65a56650Ca981B710CCF9626a35",
        "signature": "0x6fce1a71e29a1f51ae31656438b3a8d53de4e8a0c2251a6a23a9f0eb8ced3dff57aee7cd51de84bb6604a402be0019f855eec057eadc64618ba3641629f197a11c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8fC4EC6Aff0D79aCffdC6430987fc299D34959a3",
        "signature": "0x122eff8fd717e58e601038193a7b17d55a052670ca25f9e3cde6d93fcf00cb311541bd7127f2643f25eb23096c3d315ae4b79a08a6b602bb512a7bb2a9598d521c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            3,
            0,
            0,
            0
        ],
        "address": "0xF01a51aF3415D08130dCF4D7e90D11ABf21a78C7",
        "signature": "0x637fb3afbfd5ae3e2a0058d5d8cd9e92d1b4c29ced53cbcfb579c4ee66619ad07690b2e3f4c8a54b7631959b35a86312d72cdbc79373ddc749b74af37ce356c01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x936F1AbB10008eC7755a3A7613e800E3dd3b389b",
        "signature": "0x57a48459ad04b7ba705e2c4b31a566a3985d6f7562b77d7b44e80932d9bfeb466c0bb6ec8b8d4fdb9227178f57d4097b83f80b420a186b4edc627e0427cef57f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC1C5fe4EC4f751e0A3AbBCb29FD1010baC11AE05",
        "signature": "0xbab036f0be27b65751fe8f0940a27d91027a743c70fdcfa55c0855457ecaf7c77666001c7fc211940f09c04ab3f3ed4f21a33772ca6d5cdbd1e3502016db6ef71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6F62B7fA7020C33a985CC86dAB4A37c7839446b8",
        "signature": "0xee6741848b864187e9901e6a227090e8a2600f0f70e9957e71e85a624c44aad872efd5ffa502f186a7597f2f837432eec05f7faf752a7dad7597a76b95feadd81b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x77c7a230bcF26FCbbf91342892d7b564AFEA5257",
        "signature": "0xef2788f68608c887cf33df2e2fcc50065863f3cb8f41bab8ecab4d8b1862545b7a7afa352c631176623560e2cbdf5e178c91b6a3f1cbacda8ca8a11e86f6802a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4c0dC614AAEE3E1D6A2Cf6b4800F56f1E16226bd",
        "signature": "0x3a83ed47a2ec336c3f34db370fb4cc7cece09a655fef4730afd7aaac37d6319f6245f223c26095338aabb2c52e5d2fca5458dcab48a601770942c1b00b7ee1dc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF34DbEf3dF428DC8Ff0B88f71C733A4545e7E3f4",
        "signature": "0xcfac0f38c98ea70a408de4800d28eea08dddd4fff0994eacf9395c3e5529ed656c5cd9cf710d36b08ec35a912a93fcb6fd04e95b8a033f30adb538106e4794e71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x944a65941029635245924850238F36758f30224E",
        "signature": "0x9a09129353939b749bdde5a1edc5ace7172a36eacd91bb24770d2cb668a479af031dea43a127b5fb53dec0bbd1098c2b3be0e886adf07b2188c1936eeab3b02a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe943e90C9DD5c3dd1B55625B60C4d6A4E98b81fB",
        "signature": "0x61b508899b1de575360437a026e37c328c8a406c67c86e5fe35427623ac6a7993c9c32ec5f84835fbfbd8222648c522cae4df2d7136eb3642a05b3a9948ea12f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9FD491c9B35863849e546201E4dF8b37b99b2ad0",
        "signature": "0xd18426c96faf509f9f0738cc3fa7e49c496b5226e055174af7d36c222567897811c62adc903935df5360dcd98809c805e8a601dd395a27c25be7d4efea42f95b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x335c9e2dc8745527BBe6ef9F23E2d2DE24B7937d",
        "signature": "0xe063f36ec1426206715f63a3192314cc63db6d00e7d803e11a4980d5883fa8fa51bbba4c3aaf1139abaa9b10c68cfe96bc0e10164ae9dbe01e512a335699bb671c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xACdb8af8d64852cadd4E128327BcbD3DC92AFCcB",
        "signature": "0x634e6670d24498499b616a8a0517cf39533af2287632d41c64d4cb25591334d624dae91a0aade6ddd7fcf3fc1f5fceff915d396c6b02940a449cc14e53b11d551b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf4D2D9f3916792f0014179682F19b7a4314433D7",
        "signature": "0x62375339d15657ed9833a3212329705accf7bafc041200391475eec58958d8001cbdcc1473828f05d8c13bae489cd0bd5c1f6038f3e91f874c431b60d26c763f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0a9a7513F160EE78CeE87942239B81D08ac86AEB",
        "signature": "0xb3cedf92d9b28fd94907e13285ec818cc3846329f29306963a9d1373f3bdaf7504c455fb58e42c06692fc39eac340caa6b7b2689d149b663897c5b4552d516f81b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1b21A4287CBfA8F81753de2A17028Bf2fA231034",
        "signature": "0x658b6545b1b870c755ca50ed2c7c80524dccc20e1d36515eff2218a4691e519d0b37dbbdcfe463ae3ab659a6fec90dfc7b24282642114815ea72c8fc1a17fae01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1F1Df9a5B9C07e4433f9A8A17A6041e2738938a2",
        "signature": "0x48b4eec02f08101231c97ae92471541ae3e14c4db80520e8bd055e6b631fc48e2745f1c0d888e392ad39591ca0781bed896284725cdc7a8067bc60680487e2bf1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc23b65A17C68D7Bff17C51820Eef974555794903",
        "signature": "0xa81322c394d40b2d9ed32ef8200ed4e5f4696b56bf4c49f77f1df83f782b30bd406a357cdead83a008e6cb73cc32fd7b299dc61cce9e5debde89db03cdf669f51c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x20761627d7Cc9320B0B11E2ac0B2E76FBa916178",
        "signature": "0x7431573416e0a0ecaf8ef18f6117108fbd245ff3e980043295b87b55773ea88f3e7724cf214166255acfe0cdb64783e50bbd07ceaf73f858968d335b1d01335c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA8C45547E7afDDFB729ef49d974e0FcCA175443C",
        "signature": "0xa21a0fc7081e068cd17ab026e521fe5050aa1e442f4ef90980de5ad19a615e6d74af68ca3c0747f0b82284240b51e59690186e506d4fbac83b8c537a5def4bab1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9B5DcC120b0Aea44Ea7db167d230826bD27da08d",
        "signature": "0xbc5298a84b5fe18fdf518694cf3f5127e1a76130a3603235e9f0e15e83c15fe62d51afe7de4b839d0f7138c122eba4eefc63c32c92883019b8b364fec7b487a11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdd88D8EFf7D8B267e67a7952A55593e6D7864231",
        "signature": "0x85862709b1fe9014d14ad2da9faafda316bbaecf468e8a6ecd5a47f177f2a62306bf93246aadd4c568632dde1ebd7005a33d6ffeed9e25f6459d5be7509df26f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x592975a846727Cc6926A54A2195dd45eAEFa5631",
        "signature": "0xc8ace58f25c3045093aad6ed4671791db7234abd5bb5b5ebf582be0df1fd3a6b23923bd5171fe5196192e7519f371e3e70cb3e689e3b085c972a7830caeb6a301b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x60BcbFCCF1Bcf99dc80fe1D21FbCeB1070C43363",
        "signature": "0x09f089f44c3a8cfb04722c997d925491e164d52194d014865146fbdb58d4857406452c09a14e56004d3c1894cfa4467af00899391ff58e9236705489e30bbb1f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0B5f5c5Ee41F49DFA674f501b2a45a3449458D51",
        "signature": "0x726c36d0bdb0001a8aef437f3564f8f7125a25c385acda448ea4b96ed343e10f678ff62f01751c1e9233281757c9edbfdfc45fd0b803baa8d66aee5aa42e86131b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x699f3727fa358202aF950df76529aCdE6c6e55f8",
        "signature": "0x0c80d7578e6a5033461a40766eff7b5cf6df4ddb9f019f04da9132438681ff2b62c3ba95728149b2015cdc5392672da6c7c83cef7c40e31855974e9c58fe9f3f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x99E6231F84Ab72Ebb61866272d0547D4458ECdBa",
        "signature": "0x1bb4727098b9c1e00f7d80d9b5aa52a1083d5921fa538271a63563daffd76ae3258fa0579bd1d1b7fdfbeeb415ad7edc387ae3e507ab25eb82878dba798e447f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x53c3d9F2e15EFdEEe20AC78A7AC4672B757bF7c7",
        "signature": "0xa819c873854dda4c25558b4973b9667e27c9553851da8fc921487df9a880113f67bac1892d6a7fa94f80938251aa843b69b6f485ab786910d46f7616ec92a5021b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2Af0F4125285a67Fa865B5aEe3bA0c54c68491eA",
        "signature": "0xbd6725b024b3736f8e282d1afdefb7088d941f0f8c1d26a3d865b5f1be90a1a073188191434013b12ad01ffc92a0e02cf82172c03312ff44051b61e6c580c3c81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA06DEdAB653C1A416E1fb89952049813dA6104ba",
        "signature": "0x596f04ec8d8c653c38fc46b085da0199fcde76217c1b52b1620e76c5827477c14937e018a563a8a47bcaf5b532bb7d1af22087c33d1ce9f38fb6956d850af9481c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x51e36e423dD9894Fb7235c7bC050176f78Ba62f6",
        "signature": "0xfe7b065ea89cd5812e82bda95cdebd80e41023e35f6af419adddf385fb54a18d3df8eb53ed056eaa881877bf260b3584907e1373262982937655eb256c1ec25f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4450051da6051Ab056cc3d3Af2Bc65f6fF10f542",
        "signature": "0x77ccd16d370482fe3d25178b64e6d7ccfe601745492ea4bf46f884797f1db48a2370b663c524071308afa5e12fe4d74a0852636da721e33006ce1a13a4ec8b681b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xda2059A37fd3D322D481bDb344181A10f2A3567C",
        "signature": "0x05f955b2d325c4d117f0f2f46624c6b52e55729d403ea26b511b39b46f9a7eee36c55038fdf823f51f4c26948ad08f921a9ee2c341ab3af3ece9e9bc36eea81d1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4E4b4323A3f3b849c4f6996FE06d48F1C7FCD3cF",
        "signature": "0x2a6b64c883bb8224baa520de3051670b35905a9fac34ebed1276f15173e6ea735638b70022054b9edc1db0f9b6bbfd0a28e32aa722473ac34cb9047c912741bb1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4C35ceFE291F8440A3be6EC6C53B314E8FaDa709",
        "signature": "0x569d477bb55a71ca8f7e3ce369e902a7a16b612e517f6cc3a8d10c5057bd8e604d069635f5ec84ea66ff412f52582da66664443d479630192a56ad51d6dfdd351c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x388c6c51A74c8C21Fd1193862f4544C773126185",
        "signature": "0x6967ad5d6f0be4ea8cb5ea48bc77dcec92408fccd4d679931394fe66d17bd8785c14a3fdf62ec03797ab0fb34b0bfb02e3294ea6bcf18e92bc8d0309066b096d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF3d7eAF99428E8b5d5BfBdd0f163A0AE4432cBd7",
        "signature": "0xb1a8d9145409275ab1439519d506e96203486a7a4d1538a4cf358e8021aaa8c71cd8f3b9bacd10ac39cf7e3bfbe67026b7e0d45e6c2f97e56893ffe1e5e6acea1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xa5B7c4f4aD91D39445fb52fCE71aaCBED3EDf8f6",
        "signature": "0xb11f5b7497bfcde3791fb81a0bd0442121b3f37aff6d5e570ba9f6c70154c4221c424c9872682f72fd11c66781f4e742a8eb93f4dbe390e60e370961d65db8b91c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x506cee7EcfC00B97751Cea023bbB964f514820f0",
        "signature": "0x7d867e16f22ba94da811bf8e72b681f8abea8de3c33a85e13fdf1b71257be62e285d4cfbddb77bc7cfc6efeacc0d463c0ffeeac1dec1123acf83215d884e02381b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2E902dd240b471B1E18f101eA86B278863d0D0f9",
        "signature": "0xfbda4e9c3ef0e4d8805618956b06a3feb4b6a22566e7f9662a5e3d0e8c207e7151bbdf731424cbee575a0e7b6f1709709a0991fa249e06ac30aba2917e47a7ef1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x83D0BB7f1835C110Fd7329182a71D27cdc1c82Da",
        "signature": "0xc7242995a9f1d12e069e3390016016e594a3a7461739da7a92ebd14606578c5605b40ebc910a6f7630fa908eae100665683a0cddc77d353b803cfc4f999885b11c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xEeBDd89196dAFc4FCC849040179161642bE3dc82",
        "signature": "0xb60d396374a6041710ff96834b323ace331b525d98c32bee27c569fcf1d139881af98682e8f80be4c71654e4b00618fe90df9e95def21059bbddb6dc4cabf65f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            3,
            1,
            0,
            0
        ],
        "address": "0xAAaaaF5cf4333FF2aD53BF027BCc2ad8927512c8",
        "signature": "0x76474abe5a34cd5503f02a7d2733935794e9f3f61cee116047d8f0950f76490026bdf7e0aad94dd9239bcca9ad88661e7e8cf1f090d68a79b13af52ae62027b91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0Ee924f4dd90f741b9320A01CC85e075009398e2",
        "signature": "0x62b055ca62d1e887dccc862241c603bd075c799476c7e0017a130d2ae223e4104dd15706a2e634c1fa21ae3e97a9f5f6fc4541b7fb9740d66d588705468f0f421c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDFAD717A3C2abd69e606B9453c5BA4B706D76dC6",
        "signature": "0x106ebfcb90a37f68ca06004f0930f4b9cd720642f00c4e61467038491855a0bc4ce84d407a4007fbb83f6a14891cf0b142bba51608acc1a1d7a909641cf3ddb61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5E0a85EFDF3AFcf3992BC295C4a83440b9d0aA77",
        "signature": "0x543222a42408b08f2d05b552a2a811feb59d92e6fe7286e854a5f89108e3bc6e109a9b9414398a4a2e4d677e2744b8e551a4c0d3727c49ba4c61e6e033ae196a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x72136e2627c8Da0d037ff773D1702f26991C4F26",
        "signature": "0xaf5d16280d70a522598e63ef2773a63f23e7f3ffb67a79f88d64b7280d688c610315f22613130f9536434c30c736586fe6bfa37976d4dfdde5c1345255f0820d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xcd3b3B351dbc28982Dffd19f9D9Fe1606e72A6B4",
        "signature": "0xa02b4956e79fd89dc01f09bfeb495abc3d99214f2ace6e4849f8d438eee3368f0952290c298329bf67924188730d05493415830a7bd216239b45ec1aa8fe20f21c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x80b80C4c85F5fA51633aC7059B3889BF905E5C9e",
        "signature": "0x1bb674076c9d6ddb602d66dc9f75ed9e6da13de5f4ba8cf7e6581664a2e6abd51fe43f70193fcab1889bd4dc122b2b1f13ef710ff8119445b69d9ecbde7b82271c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x76fD9c9E537A6B2F2DFDa57bb3556A2275C10756",
        "signature": "0xbcffb6bbb86409358273ab73742e23baad4989e13482f4efcd74ad5c7e49d0bb0690fc5ca69574e08242ed681cb0acdf4829f6267ab69300cbd7f349dc514c3a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xFE5FEa252A9F98Ed8c686f96fB14Ce4881267A24",
        "signature": "0x18752813ddea5bc430a66fccd9997bcbb4d2379fd718babf006c8322309455ac6b2df1e061737c504b08072e0b384541ca267b406cc0c9bca6bb8e800e24dd4d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0991ac1c1A1226743d62719d69811b3Bd32c2aEB",
        "signature": "0x85ce29220f8cb3fed248b1516943cef538f4531e461a45719d3735889633687c0c7b7c0ca3bbca56bd35eca32574a6eb8a22ab15d1ae04c37bd62b51e14ee4381b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x52fe5fB6746a993C7b931971C084272C35e7DB04",
        "signature": "0x976cb8f7044ecf46e6af7dc0f0ee69f7b1a9ec83041039ac8e418b45d2f0a8835f4b950348fddb46666783add7088f0a7a8e1d35d9b455e48a08ee7f7ced8fdb1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4f8a09c8B3773A6b5D863b6808974a891081Bd3C",
        "signature": "0x7fbf81f91d06eabe2d890b888202196a93965b70ffc9da477273fd4e134405fa5073fd08f517a70dfc7c712f0a798ed444d8ac6bb5d556c2785109d14320c1131c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6Eee0ae8caC4C52128399f64Cf502996856D8C7f",
        "signature": "0x699a880a23800210ec2325a7d78f34ae5acda3c909a6f7960e06c49cf2df449471f943a5cb5094f99f94226e1ea029e95eca5a8b6d73e0c8c7d9715936462f0e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            0,
            0,
            0
        ],
        "address": "0x956fff903F2F645dfBe65E32B46fF7BA9f207e8d",
        "signature": "0xbb74dd52c13c35ff6615fd8368e27041140633905acdcb3d66f0ad2ba05756c835d01a2afa813c85159d7ac4628a460745a3b8d88b6da1cea540e9d4790c20cb1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf6E73FD6648bE3C451fa92143c8E164cd31a3528",
        "signature": "0x398d5dee77cf1d60e0177e099267dbdecce5f1dc61f64a51ce84150c5bd01d191a8b61d516dcc6287ce1e5ed0c68f9c2b5a3115cc9f82d6ca0a2306fcafa61651b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x65d6Ee507540D8e70F12AFC9f90f22f4b45898EB",
        "signature": "0x00eeb625b385c0e9840df3596177640973ad9d317eea8c62a45b5735fb5ee3374a7a1ec6fc8a5a6261961a5a62fbff80d106c67f0e5880b92475fd83549fb4681b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xcd297f6fDd72Dd615A6AEb871C625D3dcD0287F2",
        "signature": "0x4a3a39fc477ad562f5679be1d26e30437d5ea2b4418309e9c1992e104611e31c270f7dbe8e529a9f86d69bf94d9ec9b25602fb55a2b7b1e3a40f28b2265387571c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC8A203cA37F4d6be4D2123262bb6367C6eab61F3",
        "signature": "0x7981de7c7543420b6298cc5ad07ffc7aaf3356ea3c7fc9e3d8c849d88acd32482fe545d9e52d3a98907f3766712a84909b71670cd2950cae317cd1f3765ceaf91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb42D2e81185B5AA1DBC437F8Ef12D3E56f8dCd69",
        "signature": "0xfd15e60dab76b7c48ef0462bc9986a03fdddc65fdf15d5218d9a0799fa0251c22553bd74576922412c893b93a81fb8c5c737970249baaef0bf57ba62dea7060a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA69C9931E7f358Ed6467864EA7958D72d296B8A0",
        "signature": "0x667f395ecd9ea35129db5b0277fe5081c426d68d4caaf3424c7b780acd75361b3fa925e594110bccff7f04544374742a9bee76acf124d5d360ec42681e5b45d81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA6D3a33a1C66083859765b9D6E407D095a908193",
        "signature": "0x65b503a4016e661f999925be073740562084c76900dd909fc43e25e21ed699a470d085cd136893a4e406aa99b378b86ecaa927f5c2c0f5d88891215c445551721c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe34210e4618DEc6B725589a6649845B21002e444",
        "signature": "0x88c8a3cef065125f629eab5929b0c1a6e02f4fb7e01032613ad8a6b190a593d02753701eea2e5def5b9e8a26697b7282a5bcd186d0e4da9eb0e881505b1ce6611c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2075A6ee0fA4c04cBA26606aB78959B928bE102C",
        "signature": "0xe2148d7c83df6bb604a5f1fbe931660a1024d95708cd3b86c0eb2ee715d01794581bfae19f2cd1e3f5d0d79d91512095bde4f2008cb25a6b886e775d6c3831871b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3b9465705d714b7B586893Bd3c18FFE43bDD5CfD",
        "signature": "0xce8206f91707decc90e8952395269672815ba8d58783d43b4db31e54034d70f36cac03b8bc9621931de862cfce09bfecc0bfde51da5a3323030e320e8fb8f6a41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xAE97C014B0a0184F2b37409B4C3E1927CDEf6775",
        "signature": "0x4c6a90f8f8945afbc067df147f67630b726e223add04d2755e05351c69f7696f5313fe2eb7e3e29462eff3c88fa97804bac42878862108321b7a9e89141a1cd21c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC1d4A4EF157940E2c655aAed5682faeEabFe0D0e",
        "signature": "0xc9bd6032ba68aa3f107079c782fd2eb1c67226c2c20ba5a3241bb91d662e03be4f74e11a5b5e900de81c80bc7d267424432066dbdbca52d0cbd3583c79ed6a921b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x66CF2Fd25e89eed3b3d4AF45ECCC79137D8dD6E0",
        "signature": "0x1a6cbd92e71891507cd956b5b795d042caeeea888bd47a25d56c93a63ef80da547935d8fcbc0d84c41544f528fa7a765360abfca0cc85c4afe0113ffb6f4a8901b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0E4bb40C29be9d730FCC45F694dC24881be6b71F",
        "signature": "0xbc921b96276d68f27dfc386dd8fcb496914621e3f92323e567e21300ebd9fd8571905dbc0c6ec2328f2677c0181409bcd0ec1a9ce9a2f22a1a929b4700ff6a0e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x635CC6aB29D040831CFD82a91C160dad9B56C8c4",
        "signature": "0xa99f9fe23e58bdad522fb4cea426c6388195bea6d22867e7a1c2037834555fcd76b567dd7027a9223f7ba6bdc817cf245c4327f91c766d73961166779282a8b91c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x003765aeD7B7b89BdDa8BD7811C897142e58C3af",
        "signature": "0x874981cb8d59567a51c55d66e26eb5220fb0db11bc371195a5390528e6dfb04e6b6e15d35c087f7ea7036e00f46712b15322588d6b6fe7ccd1355b7d287e4bec1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x6986beB61ac8cbc0fB679c95c8BC61704628a149",
        "signature": "0x1e15008fba288c8fbbbc5b5176f691299183e9bc7d98650a685d70790f541bee6c97c50489066727cb1db1b1c7a3ea42d1f33a7f5b950eced9afdf62b2d80bd01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            1,
            0,
            0
        ],
        "address": "0xAc36c85D94f2e16Bb6fF82e6345079C5C65033da",
        "signature": "0x824ac3707ab0757283b9690d71ba71227d17d4bc94e5accd05924e96bbd6b463777fede051ed59e77f6a840e7e376dd7210bac5bc1bae400e7102dfb62d4ade41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x56B68F8Ef65FeE453CEcFD79e8f9d06163d46B7f",
        "signature": "0x3e8a4e070be3e234b20ef5098eb63ad6bd376a0f3bfe0449d489df9f64615b9f77b2fff3608256341bc1ae93cdb088431e0fe76f802c6290242b73689df743081b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb65e74D4a0ea7eC876a52c4f3E7Ba606209239c4",
        "signature": "0xeb0e5e2577edc7a8bf3b29ffba969ddd4a756b22df3a47457061ff2e3bdf80d9004f0c02aee2752ba271263184d69d5babd748c9b410800687a2aaba5cdab8441b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB8eE941EEdbdD4022b0dDd044BA6bb66079242B8",
        "signature": "0x67913292754c0a8ada6d49f8b41ebe64ecd0148af767a8b79f8329c43d90f01b5c27b879a4afb97a0ada52bc9bdee13c19f520ee808db0d33b4befcff33cc4cb1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0206c3418B0504b8413f61Ec5af57D3caC814e21",
        "signature": "0xeb410464ffeea7b207f21ac7b2c620dd46f262856e2c86169d80c760196e3c966aebb0ab1b841b3b77fbb9d6c392042b2895fc57e2a2cb3c66dbea6544a733db1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x01601c6310FbC0b0d44EA6bD50d1E6cbBB6988A0",
        "signature": "0x808cb4cc96f84addaf99f3163a29d393b76d3acab47d83f0acd7af42e7b272c273ee9767d3027f85d752744ee6f2eb7b7bc1774fb165b781f9be890be0b575b61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x11dF5A9B6Afc257c8297AEF1085cF2e1555540eA",
        "signature": "0xe9367ba7be77082fe3da0ef8ed1d8eed3731509fef0aae70e0bf46be93b264373df6ce1cfba92d4c598043cab36d532614def9d25e3a17c2ac36a7ec61d028181b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdBABd10a5dF72527de4A1B4eaA32E31550c204C4",
        "signature": "0x6364e194dade61339684c96ae3bd08e57fbfdca2a84dc92027247ea62eeb65c36fd5e2aa6060f22d24225ba3e73bf851b1f0685a8a33b128080db7f95b37a24f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xCB1329B8F915099fF623E2233A86A5dCA6517fBB",
        "signature": "0x091a93c0dcd852a286199022eb1b15c3248f91acda008c591479f66314d505284ef9b4e72fe21457db4d886876d7cab1a775b9c0b3095e402491a0e01c6fdcec1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf98d9e0d7693A547E78499C55906A99595c46532",
        "signature": "0xd83f2b439dd874ca1dde3061fa651f1f6ae4f355832548b886ff3d314274cd4d6ad298c139c4a94b1fb0cfc038943f34e5d4611a63b6d71b8b9e584101ed26631c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC652efb963D0FaA80c01810315F47C12E1b6f942",
        "signature": "0xcfe698b2fe58c8d7f23b04972a94f44468ebde84b4131fd9f22a41aabdfbcaf623d53535f9babcb21a6c4eb0c7007fa128011d967b806a4e51c291b17e79c0671c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x57981eF7afdf8Fae71FB521093086C5beDA68838",
        "signature": "0xa2b3fc9a2bc63aff26e5aa1652ec4a9127a6939165371c8a47a2a8d4ba4bb3ff4c7ead848e982ac33afcfbd466777f7d07ccbe417913c882f680bb78a72b7f851c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x837B9DF474D544B5F36E2bB029D85f6708a793C3",
        "signature": "0x8145ced6e6744e438589e2ec0d617bab49ce551807529cceba536ee109620f7f2a9e34e9a734b14924e2d2f78d99519390a7c0744d43f183806775cc0323817f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x53422124eC35A5A22cc553DAbB252E38CB18f2aC",
        "signature": "0xa3364a6df62569ccb2ca3356519cbed43afb97199d1406f8b7de83cd86b440326d306c9c6e1ae3d531e97a437a810bbad1ce52465bb8eaf91418168a35fc9f261c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xa170aF88960BDE5beB6FE52d6441Ac443E57b40D",
        "signature": "0x7eb96f9cf89cd2efffd233d74311ce6df66f007490abf2b61475d58ba0fd03bb578779d4801d3f2ae44c5705db79c82acb03d7131b844af2051f83ac1df65d621b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0A1436E65978d908c32fEB83cDFdc707392C4F5a",
        "signature": "0xb80faafb9dadc25d9a184546ce96f6d4b3c5773b36e9da23b1def1ef7b02b38b2b35e2877fd2aeb1e43829952d4a817c076d75a7ce613f5f7323d15045cbfb051c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6B20b72eC5E027c3CABcb75aD06C844e1B0987b9",
        "signature": "0x232efd10c6aba78a20e91e88baff1a400dad34ee79c2d04346e23a753a71cf1c2164e76617387121b00bfee7cbdee3d557697944e715c933eb3214770033880a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd1548075C1D8d6D91B0eEf42c0Fe5722736a89eA",
        "signature": "0xc1f4af7a5e065971df3952f2abe673d65aca1f4059ca2c6ea7af0d437a36b6ad0e5ed060056e104b5f1137dbc92012ea81582c3963a4b1ca31ae3203c22ea7181b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbe647d95152198E49143516ef0A219e947ad214E",
        "signature": "0x8d745442173807acb4f3ed56f26c23fb5745a4bc712108d857af9b4d8a87158c67fa5b250901deda18d135311775c7b38addfdb6788bb250900b2642beea17dd1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x91dBf88A555B38e723903db0E6d7bC57a8824031",
        "signature": "0x5691f5d17666c5c40dc264e390658be89ff76cd285eeb70c1335f3b6fd91688869175948557e36b84a1f08fa5a4219e7804890f22806323fad1b15bd64b3d0d91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc508669b05B9aD60F117EbBF966F7eB47fc942B5",
        "signature": "0x1947b6c3de1905222f7a53be7d12704b6b543304ff4447bbed0cef0cb4d215b11b570e96b3d9345c4bc124ff7c7ec902a23ac4721d007f324008613a659d88e11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x95DCb470bD46a27969319429ed2283e1b045954E",
        "signature": "0x9fc7f7f01b58eacbc8a5e427aaea9335298b436475df834e5c8cc337cbda22c85d8fc1480e7d1da5e029253dc89e5c6dff856476a869178bd6f062e638bd8ced1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4db1f9725c2e65fCa0F20a399e5A00c2D1dEC84E",
        "signature": "0x259d910462b8f04bf3f19bd42a054694aa3c89fd908d3064462ad4e698a068ac0fecc770e25980849248255bc145a6de0d73a910a9e3041559740ce8c15a51981b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD87a6A7E23b139DD274696Be0d5e724DC21a4B89",
        "signature": "0x61802376a8175862af69c5ef921e3b2c7af811083adfb2d9b68b416842aaea7d4fcaee652a1920e1297c775992153f599d5a063e52fe4089371afb48bb6592351c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc27d4334C26499D542a4A9879C9F78aFD4450934",
        "signature": "0x5271f37d415274bcef4e14d57a07c88cb831e3338c245be491ca72cf2b324f816ae7ef66716e4aaa3cd248a22a800e43565a703aa317edecaf9ae9e1c606a2201c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfC5292afcd0e54858Dee54f6921f06590Dd1Ec81",
        "signature": "0xa9f433c8ee7f02db6af6ecdccc3990d53720c8381d195e0d8542d55f77a7dbbf1d0826aaab3ac68a9b9dc8822cc57315479a1e78453db87dc63a01a18e0ce9401b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x25765B22fe93A9bC9E9589113236fAD01794D658",
        "signature": "0xbe8a7a3bf769c548daf6a7eddee8b50e461b22aa1c4cd3620e9382deb7c5d0d91204fe357ea55946b414af3c30afcf2bd19c9e85231f2b07a6b6643a2f52a41d1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            1,
            0,
            0
        ],
        "address": "0x61Fb956770ddc76bA2AD084CA5CfD3B68B495fe7",
        "signature": "0xc3f787e39dc325147f2c24b651e4a8f07e761b7aee5552ab3c7235b621cf3e85596a22fd1def039abf7c18bac3f3fcbd5d5f5c22cc887be77b286f352676f98d1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x406FA3D78f7db672DecfcD17CeB3A6de7C102D95",
        "signature": "0x1bd1a72ee31e76bc689a6aab37cae2deb3b01a2688c82167e32b8961e7a8a3024397211e33bfb1c69b2b0a6678607b5c41ab5a3270f3294bf4100348ac3023da1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe7E6f80cE16c5f8A0e3D8873b376307d1F6C7126",
        "signature": "0x205992ad3123200ce0462290e111771d47e64061b7b1de8b258860d0781982c1310ffce64607436eb4df27ad33cdf72e488d5743e1b3745af320a02927a6c9f31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xeF73a6DbF856A2aA03cBb754fCB960f3ACe5A2Dd",
        "signature": "0x591d345be1ca57029039e3d21cc1551322a2bb821598118680ddea7a31383757597f8bc41e87fae50948e7b49844190ff11e7b086a4071a1c8b4496d32cff92f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb4A4f96f5677a0Cbd808d46A9b2924674d6c6Dd3",
        "signature": "0x155ac1ca64acae0e7bdad53381aaa7ff2436fe641ac7eaa18b63a99208dcd14a5d2a42eed30b1db077ec356e29ce371c1f7c676b249f4ece6dd95629bd42de821c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x47CD24493D9Bd40D14FCbb78593dF925Ed3b9Eb6",
        "signature": "0xad3492ef0ebb5d6465db0ef55ef960d6e4161e50a57d5e7e91b312998c3437595e3a93e3ad5b18f58bc2e496847d8506c74e2ecc2b77efa30f512227771ea5151c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            0,
            0,
            0
        ],
        "address": "0x5F353710f6207364D34bE9328406e23Bea5c7191",
        "signature": "0x8a5b874db0ea63731e5f9033da99371a387802041309f0be2e125c52d5571b5b5953fe49021a699bf7ac712b08855073506be63c63d2302dbe040e15c921fd6d1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x51Df4c7Fa7160167d4be55F4E7E64ea444f8592A",
        "signature": "0x69977c8c9648422a6b2b97501f4baea16caaf4a774e1639400eb433685f04eec78de71543bb3a84b333dd241cdec917e0e39dbdc2eb9b25b221b711c36543b6d1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x57c9792876247AC751EB7f665E2e365dDee2C4F2",
        "signature": "0xb0aac4ae5b8b701bb18a0a292921363c38c8196f0d4e4f64d035966214c7f4f325bdcc3cb88125f782639a4131b3f1649d47fd3af8ecb45cabad3d042540f0ee1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4f8cEA6743BE7AF963124526ebd577FAD85DA286",
        "signature": "0xff9c20debf0eb8f50ae0a426e5d9246c7dd9d47ee03185b6178e12bbd7dd9e4e7ec7ab39e3464eb12fc2c92683f3f2f73afef69861af5f893d65a82cb85dae621c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbc834be4CB8615dE99C222F40565D01A9329449d",
        "signature": "0x95fe77cb9ee70a013dc507aa0e38cd15df210b4274c804ce8d665a76049d3ecf4083d96c4c00365401e14cbe865c7abcf71df42694947085bff00af53e09cc981c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6ba7e96eA3887Fa6B478f6DdF60f43CF13CCc9d4",
        "signature": "0x6bc818b8c38150fd185e6bbfbc040ba1a931190fb1a4e0104dcb617a346ad87a40ecbfb5a1d17a75498df29182ec0508f522f82aea709b4c2d36c08ed08ab7771c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x004E89DDC7E8E0A9be2735d06Bbc7C7df22f80b9",
        "signature": "0x16d066c8ca4ea53c6d2424d9d0d8261dfd6b3ccaeacbf7ac0cc65303fe7c407f307bc079a8b74a386a48314ac3fcc18261aa5fcebcbb61ccb4287daf7775ec841b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xCBf581E4d6b5BDBf724Ec3201C9a6aFBc15DCa55",
        "signature": "0x8e6614dfaea0336519ae0f3943e957b5799c3c0d5d6100264157712f4772767c1d5a68ef419b30fbcae5ea2d9831fe86adef72f3c42d9e9535db4b60871b1b7b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            8,
            1,
            0,
            0
        ],
        "address": "0x071af604BCdbeb03BC69C738C863a8e1A9AEe115",
        "signature": "0xa4b5b574798c7acdf6702eefad4408ebbfe6da4c8da80d29706e70797f80136d6c4df2d593fdf483c9a9cb55ddc386cc319559eac482a6f26559d6bba7afa7f81b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x51e2376a12AA212b4C157d4D6c52c718450AD96C",
        "signature": "0xdba21bda8bea39fe56f7bb6ce0974b75662a1b2fba26326f3fb6fd925cd2fb8f3a3c278d0691708f9ea8277181857a9a635d29debaf340d62bffba6b857a110c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8fE0f0649E85645C8e4FC4189805a6bAe195B1Ac",
        "signature": "0x103150b6233cb83d8c352078e74908b1098e3eb42ccbb26fb7996b040694c8a3127eb789570c55e79e2da3cda1d750ebb703de4d187d58ba03e157e37b919a1a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x74C1b78a4f1e1E8fEE3CFaF6d5f53526f03363e0",
        "signature": "0x1b385a81dbfe55ccd177daf4f1bd903e43e65c76cf08e0ed63abc9407e21ab003e826e56c78e29cf967fa6fc5aa55147117f9000d97b6bf8c9492a0d9085b6691b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x493A577c98B402d67987B35fa4159Fa9A49F5ca7",
        "signature": "0x4bc3bb966ae2c223cc7b04c8c585a82fe4ee7e7d4e859684badfacff578b32f66acd467b3c008a13c9bb8316a237917326daa8079e213c2f092f0ddbffef23b41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x81462B5C1Efb473B793bDc96C5ccb341F138798d",
        "signature": "0x7c79a8553fbcc5ea8565a6156bc48b1826323f94017aca6483ee2eb235b4044f74951f7f7101957892d35133b24adcac9b81d86b1bc169aa0e4eef147173ad021c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x294C2e8f94Da0F5BdCb2D0240511ddaB63522418",
        "signature": "0xd9e43d4c6e6a1a18a45d4e728af2f126cacac8e29769cde26d8ffb6179af068a7aca2d2675c21669d2b4783bc538f3eb78c57dfa9e050fcf9ab58b03a32af6c71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x69d8AB085601E3cc989D907F5937B96c2A9f0C64",
        "signature": "0x142cc6b3bc783612e540e5976c47a0a1420dcee4b2b3f798764610520b22d0ae578fba92bdda4445bf3135fd1a24eacca1f2c8e8732ae6034eb5fd286666dfeb1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x837F07C2B16F4eAbD4b43E2ea61aD64Cc09E796E",
        "signature": "0x8a55f6789ee75d09d7315259b9a7c4cc74714bde0c9a974e2ae7a1a14580b97878faabf32fb58ee33ab7e5bb483ecc28031fe64566c7e0f33cc6bf3a3129cae81b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x278663A1E698fd30A20eC6EdC7Df43930B676638",
        "signature": "0xae891c875bda88e1ab3b7dd02ddeb04240befc5446434624df555a612fcb210758a1fb56cb8f56c580d27324f75366875c99a95cf3fb688fc4b4ec1dc184792a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfF5e812a8738bf2faE024785a3a0Cc1e67507a9b",
        "signature": "0x2ca3d362be02666ee5e0ac91ae224ede4bcf59ec73d35bb783329858de72b9be4ab92416317e3811ff36ab008afe77bd3dfd16683411ad9eba29cbe47df1967a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x08596f61Ee11d720f3e3c7E65F2E119C2B1cD658",
        "signature": "0x78c11d49345735d28a25e4cbb18a9388d887a5c255b1739610e2a5702d3e96920fe368568508677ed5539c0d10c167457e0bb51ed4c22cc327c90a215e08ef651c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1bbE25384b7A3bFC70B18aa6847C56cd26063Ef1",
        "signature": "0xef8fe2e2e3c6fdbb862dd90c5b945979340d2122d6f236db4cc6878fa3d7fcb55c89194c88763682c8bc49721d9aa9a7d5418e32b1678a1f32af66be961b53bd1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1dB1B9798611c771C658302A7CA8826A889c84e5",
        "signature": "0xca2c3a734cb0bc98fa293cee4dcf093507c29f35577f5e030235a7c7a9c257e925d045367e4d260705c3663589b3d055911a1eff299b82dc547db428bfee744b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x62feB7E56162eD960E1259069D117C5fFE710365",
        "signature": "0x3570139a14825428441a9be85a6e167f1a0eb6d7a3ebcbfd00dfcd2e9abca1b52c414aa6f180f4948a03d4414b677739f85b8c0c8c7286a510e514e6bb07fcda1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x30139d32a72850c482449cCde3007FF32F553255",
        "signature": "0x1569fb8f70d99bdbc2097032203f57c4e0fc85a410f65bb6a78ed41bdeb8a1aa41884e23e61b9536eb8fb9a16314137cf2df60c9b2914e7942f65ca6745fd6371b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x98f8aDDAED8634f4b86e9b1f4d88e10D9a640Cd5",
        "signature": "0xf9554ef438690f45724edb9733109d8808a8d31b9cc71982fc0dc0c9a19d280d78e721eedbf94040dd172b0d0930cca11a4a65edc3cc14b20632ecc9ca9b4ad61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd53f4375a1059a380D8B192dE13E63452D2F9D6A",
        "signature": "0xbcf11177493829c61c28708f8e8a6a51c18167fe024e4e34904b7f6b4b5c13d469f1a35cd05ff0b6432008bd3af6601290f58ab298af59e4d417c985386e689b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfd2B82A2bF47EfB513c8a8593bbF5ef706f3007C",
        "signature": "0x4e6dcf9e2f5460ab86c2d78af4e92a8715ed9c2931d83aab3dfeabb90823ce2013a203a5aac6a06f79128531fc97124f6882d216aa30def50a72382e3f44652c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5Ed192d79564795e86f628442FF1BBFe4fE13545",
        "signature": "0x68a052cc61d0dfcf113c61f08c4fdf4a903de6076b4ae45905f25bbc518740672ff5680fab9adfb9a7e3980d68a4043fe36ad123fcf0d1c2a6eec00d82f6f3411b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5B5C3DB87164bbe927FF3db8Bb236721eD3b893e",
        "signature": "0xbbbdc34404ae8f668c50ebcf3a0bcf85bfe988a7235a46599a19f0ba806352ec1b6f9a6462b8760fe327e3ffa2c958ab0de3fd5f6d02f884c1a27e5232ae5a2b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbDCF72620c9e9F3b598273847bC0E82Ae526aA5c",
        "signature": "0xee6a1ef33167b6a149ecfd69da875c1b96924f1e99d16194a831c2ace7a570186de6f9d3c1ecbca14047e0825ad0acbd657c337f1274faa8fb71d7534748087a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9d7a70ecF5815caF0DB44f7bEb40c597C4FF7096",
        "signature": "0x445b31ece4a6ffbe68c8ec2c862014489c62a2d101291057c48b67fb2d2aad160b52035c10f0bd46c83e5f96ef0d4bde9c688146af38388c136d29241d41c3fc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xCbb801fB1e0495678528F228870585132720F438",
        "signature": "0x86b55ba57b919ef5619c545acecc4d56f752c2a932341b7f9cd3d1a516b6401f6380ec86201440dcba472975eddd3794493a9c4976752d0fc4f5891a9c1e6b821b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4A2756fb53904078b318661865C6Ab1091C38b7E",
        "signature": "0xf389458cebb022a3c72ebd90357c69be133b6899cabcb29252f8673821c8beca2ff59af4104d0fc7f77e4585c1d2c5ac1ec00636678c741520672103f0679e2f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x66f9c856b9bFa9da40b6c1B9502e92FED46A25ab",
        "signature": "0x5b895d43556f65423c9a8e546b94d84b9369459e0a1198995fb6cf0c42b67ee258cb579ede3f1d9a0921a11514709b30a0cfdc7e9ac50f69e8dcf45260b84c7b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0C14b6fda637c8E067DaAE3e01D8079E6113A60F",
        "signature": "0xfeee08fa20d227af119837584db0c384ca52573db222391ed76144d44a2bd45a7ff75554dd49cf64767fbc79180b8f2d80f41b1770782a1c1e424b85276b02f41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3de78B718DD4d9a8eED2845B84513Ee08A8E488f",
        "signature": "0xc5e29a294ed66519de1dce6610f4e12bbabc2b17162eb9f5492575e88ef22ece22407f8eb65983f955de117128c395784285bdb275ae12e74690d1746ff1a1741b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x75C8df45efEf2F02dF4dC11179f8FE7b3a19c24F",
        "signature": "0x9a886eea0676947773a0411e7787ecc6d0476064023e5d01ac3735b5b400049502407a76a0f4af66a5c4264e24f851b2e101ce7fdaa25a4bbab409e24a53f1261b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe5636D672df88FAB180ae99A4a93feabAC6a4f00",
        "signature": "0x4924aa9aced545239325dda3044563f5cdcb2346aaca46ce304370cf9db85fde537dc13c8b333ecb69bd328c8ab4a82e1f20e3404bb4e5e857ce1ceeecb5fa4b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xadA43Adc9337cC847C1673015E8800256d555950",
        "signature": "0xe8100b6f4d07caf0b4eb858566c78958c3667489f89b6417da1f1e66cb0276604c4c14421a36ef7d0ee5ecea08217dd3516a03d40aa68e4024020d49a6838d901c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC71000b155aF7A3c0D30Cff0927fAB35F913919b",
        "signature": "0x5aeec27e78139e73afb710b14008ebdcba7c076332b3e13cb191c5e5ac7d9be761070c482f9ea03e96b3ae853b1584460bdfe09ce00917b4fdcaf4a8a123f3d41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x101462789de4EEf8AAa1D2d81251da76327A7895",
        "signature": "0x3e827b20ac683ae82dd4bed04391be11ac2ddfe86b8e2acbf4fd6c7e2cec700d63d9093bb05e687b2d75d7fc0265c372697b0d02d7b4e89c9ffa0eb39fd86ae71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd6523af552399D49e4D869f7B714E274D3f4C556",
        "signature": "0xa28a8b7b199ec8e382bc49b2fedf2fc1cb5f613ea5a3b0f05f9d15ca8dec2008223d02ce13f081d6d21ad4da7c38f713ff1c609b8f5ebe63010c222302759c8d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf3eEee17F666785A00Fe3a05131676711D789df3",
        "signature": "0x1697723d518a549f20ed3029f7ec3fe9abda8a61cb0c1c251d44677197133c567d2d0becb55fda999e2ba981444b574c8e7671655d9fd84686973e230c99f9a31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd2628b911B5f4a179767bdf78AE23300F6b8e412",
        "signature": "0x0033d3ef89403ea3b3fafe3d52ce634aa87c78f5f1d1351bb833d3dfb0188815713d38e882104d97e1f53c0ae55df4275aa1ad1dc5a0ad43d9bdf0faf72942131b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x93cb5cB6860F6268e77C740B3178b6A29890e736",
        "signature": "0x0bb0a8b6b6cd7826520039974b696c23cb13e5738d25a6497e1c955844dfcf074de3cbafd731f3d2f24daa1fd685c069a70e871b07bb491b7e44a05a9aea25611b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbA1223842F21769AB8dD5E285e354D419394b9E7",
        "signature": "0x5b76a32f0c0cf71c059785d635854f62dddf8eb4a64b80d9d002b5e3e3af03ee20397ea541aa168f473883f310dd2e01a8cc912cd192dca3a0725e72b45bbf611c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2355aef310F30997C047F252aEb801BBAa23D2B1",
        "signature": "0x1a223fa0fe2a7b42a8995855c3a7fd791d77c12266b5b232c582f1af5db191c3727ccac9575a39e3e064abdea569e9af070dc6d85f56070c0d20d9d61b2edd471b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x231D9e82a54D9Df367F39B89cf74DA1A6e006A5B",
        "signature": "0xc983bf8ae0f991b9f8465544e0ac0a00e9bbedb5eac98ab7b46f3fb50ec245d31d83a88f6f8f218f25ff9456e05565806d90caa78de88eb35e9eab16dccf58291c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3F1D0EB035a2f17233521D6Fb1953E9dE75bEb6b",
        "signature": "0x2fd75dfe92ab6854b2367675f4c2d6f904a39277ae526ce6fb720c4d51e708c67406ab06d41ef6d117d13045d42a5b52712ac650e7d638a62c9041fd4d69c0191c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3B6966A723da3301c05BDB2778a1abddB3340fd1",
        "signature": "0x8e1f1d0524304c2bc3615f79bb9cb508c20ef577966a3e206dbfbc672eea5069483f5c396c1ea647c717fec650d398f6a8096b862034c49d2f879cd09dcf710e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x31aF641A1bA80B5f5516a2aA4ac1187CD55E2113",
        "signature": "0x483fabf9de9e9ffd1aa6f5f27fe372fd14ad0d1dafa3a5dd2d4f4e5940167504491abaa3e9394a7155d012702b08de53edee53ac3f54e27ac8d05160c965f99d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x55Fa702C37E6C3b20B340533F540A057BEC979B5",
        "signature": "0xd2df8a77cea701426a9d189d9ea2ea716a7ed7f1c25491e243efa637bc8097247839e2031c690537051baa5a0dc163c9b566fd8eceefaa817fbf33330bdb05ed1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf263a6552D912DF5BE3C869C492FfAe9c720d04E",
        "signature": "0xf1095ebe0fa61a4aa6c0fe8c3388387d02f66e7fa13463a1538c449abcabe27353dea78f50a185c9980237bdd8f8b1ec97ebea2b34a05fd3d68154fae2d46b821c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7aA29272F386eDbAF8Dc7ed478563d62F361568b",
        "signature": "0x31b7950e5503f82f43cb96115893f5e213454c66d0771f5dd8f0edce8504d1ba6de0b140d32ed075b6b398699ba14ab31b1bf47f5a041306d34f1bd12bc897261b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x435405348024E47AA9398cC2bA575a5F4Eb4448b",
        "signature": "0x87297410b04fcd0e417b40cb0dada9eb1e48ec3fbb52c613a50f2770890e7e9c14010641ff39336f2d7aea9e818bc7ccba3739824362d105e4116410b78988f71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb52deeEd776E18783Af80B98D7BB0f067b9cEdb4",
        "signature": "0x146f7163e52ccf1a0ff0305b2221339b6940b9809887560d965e6463bc5e25d32f199ade9e490969048f24512059d3fb6e5d87293a0b827d4d5742b924a302271b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0982894513198Fd3817AaA508632C429F860c3eE",
        "signature": "0x67b5486f2e45af28d48be8828be84a92725b7f9ce624ed9a53d0c8c75705e13838e4ad1a8cbf24e1200f6ff7d1c7b0b6ea584d1a4d39cf2f43a1076efeaee1801c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC14Fc8a55e9d2D3B65817C4ddd9b077b3173B753",
        "signature": "0x585512795dcdd12341bd0426853e6d48cf0f99e2229edbb20d733fb23570ba9e10c5f93da09e7fb434b85f471071095bebb647328d4a8ca80bdb1fd9665295951c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x05eC7df74A953c87BDB24ccea31AD75e3F8C2160",
        "signature": "0xacaf480a060b3efbbcd2fd1ebe31e2f28da300b29fc0ad294db915790f35d92056cbb0118e6312da9d417b7df3545fbdef5f5da71ff68465a90d3a34e748ebf01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD0bdBd5aA006130cCd3FF41338136Fb3FF6f977a",
        "signature": "0x60f562309a9d53ffab6a63bb3201ba25e028f20ff59ec6f768cbc8a89896f0914c5789819515757d74689aecd51ac230ac7667fc1acec9cc137fad6144c8bc911b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDDB56D432787F304e28Ea8157c7d9E46c07a1Bd1",
        "signature": "0xc374f558668238cc187114e7d7fdf24092d06cf13bcd584b3488ef97c341b2db4994225780c9e275813e8e7243350db95cafa16835d2d7e4dbc873377b3cdcd51c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4dA0beB95afc78D9F594686Da21d89e33acf34fa",
        "signature": "0x1970deb8b687cce139fcdd2f73bf1a47b2dab64c3e401cecd869a97234df774d62822600f652d19bb4b899e4f780a3dc81e53323919ed966de1e17c3a55acff81b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xa49166FcdA6f847f11E58Ea54Da1A96c2e60A8d2",
        "signature": "0xbcd1a2eadce10bb36cbaef1a3c9d9404fa37bab4710df296d226b7df02b7a054596025ae2f749bac12312697096a49afb2c46bf6da877688580105df7b11df3c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0F615319D7CeeD5801faF6b13C9034DE9223a3eC",
        "signature": "0x3c3072b7d73ba40fb395dbf7309a434d5b7977df272db4618c8d572ef5bd76343511c2df7edbc524de56c0d1413be00a4e083a562341d7a85828a633eadf6ef91c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x076a668c87Fd73aE1EcFa72b0f5D28d8c78d92Ef",
        "signature": "0xca6839c8427969a4fc00bcb55f6548e04b498bb25bf3b3b9766090633c540a6541579e0a8f960f956ca4d0de51de196a5dfca965d9435e97ccaa6cdb7946d2f81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0A27E178239a38f3D91609F70E17D4f337Cbb97E",
        "signature": "0x8e2e1e873b409a39d092a4b7e95b46ecd0476367986db87044e797f3e2d9bcb47a90e69841e4d9f4ce09ebc7652cc3e73c163de051b8a13f6ae93a1ad09a46051b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x03b7FC43bbB0Acc6D704EE6728D252E3B09B165b",
        "signature": "0xcbac6d7d7506a6dbd0e0efc72cf84e732382d5fa66cff16e94cdeceeed8ef93d0616fe341851b7ee3f05fe9b10e65532ae673380464e5958ef0022beeb618f8a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x57DD905C17456f1df8A776bcc0fc3C03a1253B69",
        "signature": "0x24ad4fe85ef1356743acade0c83431c155847c72c1a1fb9228f2361f0a6857e859a2c568ef1ef9ffa8875b9d3b60ae528d707cbeff638b2965dc465cb33bef9f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA6669c0eD5967b13f8ff78DFfd8b92c454EE4385",
        "signature": "0x95c7a45a0ebdd78fc6de5c25d8262a045ebd238af5d4e237679e419e2ddf6755036adc356a3758b3c7489d2242533b64edb57069bd42f1d76d77877c82c547d71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x02DA29006aEA0Ff7c885556b883bABdF43684484",
        "signature": "0x3c40d0f056d4332ec2a899a3c033b0efe7e71e25fccca79c27909592fa846eae6960b94546d6d6270bc6051ed4b301053c46eef53d64aa18b94f96559955eb6c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xEaB43e754097f866Ed2144d32E6c238Ab6C08f90",
        "signature": "0xf41df718d2ba68d293175ae47895f9a52c7747ee3753d9c421eab1dbdbc48bc35ad5a03f2e87087f787a4da15708ce31a3cb33906be6b86c2881ae450063e7d01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x61CC5e666Da2FB0FC5f2a5F35F32Db9E07E5260e",
        "signature": "0x51c22cf0c8f7015e9669afa992d9e5302c38c4c7b5a485c15ef49a9175bedcf84df9cd4407f0c01797c6aa927fc3ca2985f5854fe10abc74c8dcbf45be3860671c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x43Dd3B7195895cA14A2C957623CE04c7ad69f51A",
        "signature": "0x90b5c5ee1c249bf1efbb6afcc5f98c9c232d9ce6ae8f6b38ef72ff65fdae386476294b81ff4432e509971fe49808686627922dc4a0597cae52375cfe544e771e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x47c6d86bC584AcDF72D8d4CdE7419895Dbb14a53",
        "signature": "0xa247481b48c6d2cc5da4434b7095a6f61aa6b55b323afa7a6ea2c8614b190f1531fa4396b2fb01e512c72bacf05f0806858dd8df292aec98b2c1bcae75210b051b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xcebf92F18d17d5ffE08873E4b191eef39B781849",
        "signature": "0xc07e1f652d4353e4402501c40b6a9af762328940510cbeea3a2596eb15da834379c646cb28f000e8a36a52874c36a9ee4afa638dcccd78a028088659bd61bc8f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x000000000000000000000000000000000000dEaD",
        "signature": "0x621363eec5f4ed664f9eb22d18fe1dcefeaa62bcaaacee82fda022a30354f8c155c1314669ae93ad8f049813c990f2fa31c1f9d1ae91a2e9bcc5617ca5dd6efc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5EeA80d3952F879c46b2984A9302DdBcEfDD76F9",
        "signature": "0x13d7692ccb3da01564acbe186514fc063ad6d9cc0e6021ed000566a1f13f9a0e1013d6458fafa1d2b587cdcd8c973080fcc7ef2c34da5dc48b9a576c95eb1af11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC949a464aAb8a6AA9fE148cA191657c10355D70F",
        "signature": "0x967e8c61f76d2e6711475e4001f5f268246a36b9468f166ca1cf25867696699c2f341223a2e07c5830d1cbc27f663a1a54e4fb694dec18b8b1ac78bacf7f2ac31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd9a6808C0A073656D24041a42E232C2C76dD169b",
        "signature": "0xa2afe63ecdd6e87378313f55b564bd60b08773c05da12efab1c3d2b2da3f934f2de36fb9898ffdfa8b7444937d445a03269aace4ff71e97456dfec35d4c594ef1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb0495377794961171D02778ad2355164e28CF7CB",
        "signature": "0x580eedd72d3fa2223562736cc848e96f1853b32737f13f9044bc02ca9e0640e6335bacff7356784f0607ce6d241d076de4370082a6c59659b585f158e51a78f71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5C5630D3c711131256EB7a5F5566C3B3845118DD",
        "signature": "0xd98bb71dc11959e882fc323f862bc596765fb6260be29bbcfdf7b459347110bb228d1ac62813f0a6ba34db7e22fe02154c2ca2da46ae8c3e88bddeab28d47f851b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            3,
            0,
            0,
            0
        ],
        "address": "0x64f981BcCb2F38980286cF7483A45E00C5D7C22a",
        "signature": "0x6f6b2660c00d52caa041f3811cabe5922a1fdce759024e82293e8c020a2866bf2f2c1d680a80a0a4ba510a9822fe8b7c91f98801f274cfadc08f3278281ce9711b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x39A0D1572E1E48209e8D9aD808eFfaAe0038A604",
        "signature": "0xa0c3bbde4c7549e1a6fcda65e9bff3e3cd08e597363aa81a0c2d412b45869ec50224bf9682a9839d5e32a33612622d48f1b4b6cf54606a83b7105b6a96cfcc5c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe62f5fe2A1FDea41151308AfFf739a3D9781a761",
        "signature": "0x89e3448067e9548bf98343da351b0d2f5d5032b459f29d678d3bdbcde9e3dbc14f5e1c4ee94769a683bd0bf7f5d401511fbbe0ab024bdcaef06b145c3be27f771b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x47DCE0F88D6263151Bd43B540fA3672eE2d12129",
        "signature": "0xdfef56b65342bc4afa732e38b370575bfd725b563f59beae2a74bf376b2d5af373b8b06b5a8d9d9d19970e522042f9f9dc7cf768121fe78fc586129fd92e70051c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb6aCc9C5E4467DFA3d8f8114e494Ba26AA93374F",
        "signature": "0x9efbbb84b7b6ce3f785ce5f7dd5c28b16af7414d8fbab24e74364053c90e2de602cc99e761ddf12c7216a849200805bf157d806c50f55ba20c80e5b037c9cee31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE4cB4bB2f2B3b5D81DCd3Df8a7E1c0036Bc5f453",
        "signature": "0x79b874e3665bf6485a46aba7fc5f0560051db3cfefcf338e15030ebe83a825425795fbf895dc061c8ffafc33f944a7cd727946cb29032da6760ad5a3792981fe1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc4F8ddDFe94B59E050eED97710565967733974fF",
        "signature": "0xe512ae7a11044b017d6be0c8e561c2fb9e1b8ed5af94f6ce3a4d1368ac91c46f5857e90a302d1b923c7c61de614783994c0af22f8bff3a92680985fd7e6a65ca1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x22E97fe51252721c72A1FD876E6A5d180e67a491",
        "signature": "0x2c86ea36754536cb5d50a1fe3b245cdcb6e2b05849ef1ed267588c44821e988356f7de62ae087457001fba02228ea98a2e3494353d273cd815c720eba453f7981b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC4fc92b0cf993b4FE0895aaabF4Ba02Ecbf45b50",
        "signature": "0x85ab38f29910f362c610e85f9067248d449c4b601c028cd45e67e6473b34ec30385aead01626a995644a55ed8d404728110a7cbad48e593a11942b7d7edd8be71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x93DaC2680ED5B24CaCFf6a823da17ACD80185957",
        "signature": "0x33ad85a4b02eba7c3728571d1c37855a6601d92c732fcace2ffee74a1a201aaa0cc179dcca7a27c3234c1d84e25e8f3652d74909772c58c0e3126a458e4150ba1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xADDc675050F5Df2ACC12dEb45586b21228E2e14e",
        "signature": "0xab7e9d6041e6e9e7b1e8b810338ae386452a9814706cdd1051a30e79a1c4642a5d7ab1ec4833213e817bef120eabb99d0487fa1c08826491def6ef13949d9a3a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x12532d17938DB01f312F1996F03Cd4e0819F5bCB",
        "signature": "0xe28677f72f78a217d8503b168990db6e9a2a99654e111f2274dcd3299e2122bf21846694ec83e6599a3a272040547da5623042e62f5554282f120b40026cc2ea1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x196d5F27c57a0344bAF65307e3f79Db75429329e",
        "signature": "0x2a4130df8b6ac2918ac9cc8cead8ae22f8d8a2ab433c065915f7ee875e275e812d3c6de303444903497d777adbe9a9c89ce88e7296138100db1aff7b16a4a9a61b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0bF1BC06E513192A67E7D67F99f49d427051F4B5",
        "signature": "0xf3891d5fb59fd7ba4714574a64b63acb7cf606a90ed790ebf0304d43ffe7bdd848ef92867a90037f0803eedac17d8020e7cdd3188c18c6ec7091a1bc8b7b3af01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6F33ac2209a6d082cD370f1d138E9De60b419813",
        "signature": "0xb9c206594d3dd8621323985433b171f90ce834c5a9b829c8c2cb750477e208c82160bf8a35768f0b1a36eca1528cbc465c9a5e32826a1bbda4484c3a35945f021b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1F00F8977880EAA33490fbF2ef88990e4137983B",
        "signature": "0x192c7e37a7cb807e0b557e46e58052b8daafa32291c35c49d120dad4c312cdbb2e3fe436bc879a31f2e0e57211da99d8c6c455e4d64930372f24c313faa3a6331c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8a069Be739464c59F0be56b53820E00c299Bf440",
        "signature": "0x81c73e02e16f751498ccd3eb098e85e47b4dc97a898fe66553c3a75308b1d37003054853c4a15ff786b075bae6efb29cb215d240bb69345457b72845c7cc09361b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5d752C35789BDfD1287971972091bA47aFD3ac93",
        "signature": "0xddc39ed1cbc94eef2d038b0aca453c7b3d7352326e380c1b09f62b6a2cdbb3151f2b5ea2647b22102ae1a72e9458b4138c922b5482cbcaf4e64524cd54e0eb381b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x149Cf5fFA2faE682EA8d4b3abF1Bc319e891Ab0D",
        "signature": "0xfb053689b8b395b0182b386274d7c85c49002ddcc2355eb1e740006255af79902376d4884ab2a723b11ea3b73643c8cfa29089843d7fb60368516107d36b8dcc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDCeCE18D4bC27831b6Ec5aA28DC1429921Ec41dE",
        "signature": "0x391591f5157ad69f175a229bae37913a0786a635eb261adb1b965728f7206ab67d839e89cfc293b6495d066575138d57a0305e105f1016837d10326d6c8fbc401c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xeAD2326FafB4FA846545567E46Fc3625732b5866",
        "signature": "0xcdcd9baed47de130e28563eb53fc164b48fff985ab317659fd4ebd151aa4df203504f87da02cee1509f97670313566e8a6036fa0831c9cf24b29ae3ae5123eb71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x171ABfeB938383696d0C9A1cE1351183545f8145",
        "signature": "0xde7646a910b0dbcd4635d3380986ff7a317db7e9e86f5795454690f56ccfb086597b4e7fbfa8a43f215c483fa13029477e5c900d223ba831f90fa9a88eb8c4ea1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE765CD6E5BF3eff37e5EAf7f836b8C0Da6FF5Be4",
        "signature": "0xa73757886aade14c7f7dad5bd197018519a6f1bfdcb86429acd536b5687565d040763e47bada635559fddc619ec317282b22f212150f4e7b8a65532ac8aa0bd41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x113058f194C6ACCC6a803542942609CEcC59F82b",
        "signature": "0xcb78d62ab8431c82a70e1773e380f36b382568ef163ceefb5c97f5db5daf2d9444c4fddeee09c6629d9162e2fb49360d3194d49d671174df303be6061c1c07081c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE475935Afd544F4a78D5b5DFA9e9BD674bdbb71f",
        "signature": "0x390a36ced3873095f3e40d690b6ab627d013ec8c0f9840cef554186d3537746b7d31b67b1553f67576c3a414066eb28afb295dfbb9c5da0678b81cafc099635d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9E464192E2c7d4cf6a8C46191c5a5b8d9e674497",
        "signature": "0xb7498a87ff70522b89f1fb89714b0cf931c6d6ac174022c7c23c176e37fd583229d3e485b9ce6806b986564b4e43ccc39402b6f20e54c3a88e4bd1804e9394fb1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x65fDbfd7F0305aEdBd074F592C604C092782ECCA",
        "signature": "0x00eb1ee88e69f2bc13d0f2c0cdfc70ac65c17d6b2357663edd024fc3efb1379e2a1e9dfeaa77ca46ce2f0d2a07a779e3af24dbd8047cc7af19889539b02cbc801c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbf2c346eB7227091F89e0bEc8857542D675337CD",
        "signature": "0x19a166a9c3feb9d3b6675c9fdb2715782f9fa5a26937b5e6c20253cb77a1ca1b2dfd5f5d01f309f49a75e270eeb2437179b6d20787ea84f7dd1d6d8f4fb00d5b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb014d53f5BbC532Ce2b7EBe1532322d810fB4523",
        "signature": "0xb23f33132a461f0c7afe68d07778790210761bcdd3e76b6b8f95a8905d64661c40ce5f082845ff56fc963006b1af2c4bdfa2c7dfc62ffe6a4329762cb61bbec41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xEBEE5438ca873a46b32071559F54E616671abf5B",
        "signature": "0x710a9ceb9f8c52a324d66a08af2ccfd75aa827844f52173a0531c5bf902d8451030721d8df8ef7b0fcb54b4ac5784c60db9c020e57c5001c62ab9bdc2a1ed1201b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc8deC3354Ad98694FDc90fDcb0D08A220CA9641f",
        "signature": "0x59f20492a660fa7ca37eb6a4ced1fa7767fe334b70ac6baf91b42a60bf8736d26441c1a76fb2cd0edbf7159f1450dd4a5766dc6162ec47dec33a5bd5e14b5cd61b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD56b7ac6345eF5D7B19A134ba187af77e4Fd9170",
        "signature": "0x82a0321a4c3316db1611dc9f0537d38c59ad58e33298c791c476717b7f0e15ba16742f2099e523f85cdcd6f86fd7990e77f5f13cbc25fe074649c67df98ab52b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x28fc5a85Cfb6151bf19bD5D2292Ba9b53C110C00",
        "signature": "0xc5fe373cf2fb7ec2cc13aa8501400fa878f6dae99690424ba53c0d0b3c20cce7629d565de90105a987ce47abbe427782b39c6a96139465b84b4f501dd02776dd1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD06a2A13843910a7e3547E73db57232f19F41038",
        "signature": "0xf3e89ecf4be2b9ac49628e6297ad77680edf18e72eda41158d9f21f491c00a085dac08591d2345b066b9c9723690e6e2532893a17040f35fe6c5f4aa269e2af51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC6d2a7aB061be473eB0677DB7FDdf828b81cBbc0",
        "signature": "0x0701387f0f31479f45d9debe6217d250223821a8df3aac0a8f5319767c629e7b63b71ad4da55042b51ec78a499aa7861231a956eadadab08d9ffef48854c0fcd1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xAc646f85dEdf86EE9DA33BD52cbBE092FbA134A8",
        "signature": "0xfc612d9b61351e4b4f5c3795d53343aa749d96484a1fbf83291f42be214d704f60c6bbc0517c58b2111febe8f65686c8c93ca5ba94ef03e5b98c135d6c3ca6451c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2aEE547b78408F64b8A91CFeb462D743EFD8bF51",
        "signature": "0x7910b888421202ebbca40c399ec1169d66f4cc47138313ff0d3e2592697a8990330e2f180ae436cf1a61a1cde7ef498dc475e61a17c382646ee56fefe29cdbfe1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD1b61961815d5ad693D30206d4cF7757Cb9d98D2",
        "signature": "0xa7e838d12bc2e6106f81db8095ad89fd74d46684d73bc529a97f140669f7a89c22b55e5083106d095c6275d51786a24cac5e4b64274ccb1e3714aa4fcda67ee01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x77c439595Bd80356d3DA2D129cdf25ea1e8567Df",
        "signature": "0x8ae9f207e097fe03326f144f1e99acab09a35bc16053e3d6c0d633cc16a4c7602984de37b5bc12db3390aecf7f1f5970c4688037347c5b2fbd9a52b72b614a5e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0AE6B05BBFb1C8dF45c6Bd8e13f625f9f8f6094b",
        "signature": "0xec84da9bdc7f35140f0e92ae915cfd3ae733f837c19f2d0d3eecddd3083e7a7b1a76f46c278f30d0d864417895a26d754246b522ca87aaea7d87cdde8f97fe741b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7AF22f790E9449F65A61A625Bd379D418e57CF2D",
        "signature": "0x561b2bf9f0bffa97c660e68222b7e72470993535a172f6558405f756a3835242027f9a58e66c3d157a30e5ceed522d1690da8e44208fbc7ae8019be081bd9f2b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xCEb83e305aDeda3238cdaFeF41dD3dc13b69c65f",
        "signature": "0x564606016d11ea03651f6b4d1f1c5670d5debec390a2284f67385d7465e7209658734471d8b627dc8241994319e7b6a6718a324301671d45e064e40e12d0c0aa1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDdA3fE56EA51217fC83Bf4e062ccc44BB3B4F9F3",
        "signature": "0xb5af0d14e6376289bb68e652bed286bbf79123cb9ffa238ff37e0be586aef97e097f31ad2d09ba771b0d53dc95778051653d9af191b29828443b29feae8357b81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2E169A7c3D8EBeC11D5b43Dade06Ac29FEf59cb3",
        "signature": "0x7222827c54712034b707ef2d6446b4a44d1adabae0e709bb3b4cde80f7ddfaf338a1b673a3be4d7c688a8ecf1f890344cd07a475e6b9a3525bd49918b47b94321c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5A23B306e11762E30d945207182144039Ab90E49",
        "signature": "0xe9f3c0342cd8383e3e3caabda8f72b596d77d06ea97c9ff9be9721922db6e4117cb91c8031be1aa12a00c2328a339b673192b87bfee84e1355127ee5a2a8f2f31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x068A01C9c9E6F0592D9F36311242E6Ba3c89F806",
        "signature": "0xad3db71e7ddf82294aaea6c1565f4f58439ad5f50997c5c609bd0addc572726a52aa62f7e2c057451eecb63594dc9e7641cec1d0be25b4b48dd4f845ce73c5af1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x334356690F38519439ef3B7340346a5Ae37F5f55",
        "signature": "0x26d88bf7590162e537d606cbc82060ffabe97aecca4a7a019c4d8009f183b28d6c98b36e733fe36b0034dd8df156a0e0503f5bf4715af24d70d2c5001d6654901c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x936008FBC011E324F91A3A7B40ffc94D6e07d5fB",
        "signature": "0x53e97efb8fdd46cda0538129b840022471986ce977eae07567b136b1a8b91acc6ba4e93188ceb8e502865ffe696185353fe4536092b12fef239a3046fc3f85da1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc842754B98254803cF9A3594176f55F2eF407EFc",
        "signature": "0xa3b53f80a75c2dd17ae78629f637c348c6fd8be1be1280bd8b57a52f4559789548ab3ad92f75d13135e96877550d6a24f3ef733197413894ae28dd6139be288c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4CFeaE8Ff622162FB3986fb6b84e98b4345463Ed",
        "signature": "0xeeb2440f02f9c549519bd1e329d73fcceb216297ef589a703928cee6d845502021ef6a832fb8c2a58e98114f36609d53af6d80c0ad97cd8036ca8872d46f80ab1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBb1e3effFb7B4010c5231ca093419868da334FFA",
        "signature": "0x2b106211e39288a71993712b2b034fbf3e8678221894a3bbc2c61093aee6dd892c2b12c210bab65851bdb8a8842c7c094ae0b82fb76e25f9491c0ed8c1762f291c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x34Aa8012210137C6109FB644117124265479eCDF",
        "signature": "0x6c56a175ed87025122214614e9707dbff06359db1f7e12da8343d410db4a04ef3b7e8368e1d4cb7f2bc61f43538b8a31c6a8c0ce0b996c0ff74a4128fc32f7271c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1423C0e1c6430AeB0F03e8b7F83e565B4ddAAB29",
        "signature": "0x216d6f140514d20656758daef1f9a2b76b392179a29388570f204c2a70cd48663e3f4ce54186f5c370a093a8f16bc6d6f7528ad01f7c3000eb3717d133662f131b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd167Aa13Da755E055f599557bd8cA9E385A874D2",
        "signature": "0x7976f17e33072214bc29541d6324be7c1a1d18e7b9ba2e7d7708ae103afd16972da1345154b42f74da6a2bb277b7795e421f55207247608b833fceb31217f25e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe8bb833EDC9E3A229575617ec8E0e16c244F1EBD",
        "signature": "0x9a738ffa05480ade5c764815e5051dc6ccc07b0d96dc7f79c8203a311263f13035411f998732b4ee79c0c3ba72a4f3bc1981724ced045710a989e00933bc7e521c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1CDBefdeBE932dDb95690370482D406542711021",
        "signature": "0x33c9a56f3f472c9b7c4793a53d6049439b8189a25f39bd6087e92d3e57a5ce7a0db0780898d33c46efa263cd053dc0c0a04e71e4ff5c0bf802505c64eaa489971b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE157E8e60f63732f01801c14BbB9b322688096f3",
        "signature": "0x6fbe9907beffc7f660b4fbe9173100fb4c97f34ae001b1f759a6caf282364a30594a300fcdf95b8e6a5ecc99817827431aeb8829ba47490fabc5792835b855071b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x35B50A5d0936f964337b7291f032333542f2769E",
        "signature": "0x149812cd5cadafdb73f4efe312f8948b807922baadcc7eb2007e08c1608d0b5515deb37ae4b54350f6158580617e45696fd50152eb0b774a590ffca2b29265cd1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xCf57f4cDd8047e0693faa109BAa7BA72d8FF1b69",
        "signature": "0x3749b187564d709bbc96708bab7d60a61765568816319e4ed1ffcd0621d444fe388cb23d76505cb92a485524dfc177976aeb3eb198c17136044e8a68fdb4884f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x49dd1387e8961Af34547D201cA753fC8B58a2925",
        "signature": "0x9da3f3207cc1289be1321fc4c3380f9bd166c2e497f3907896d1d6cade62b47c11a2f122736f10994f2d901e21cefb7fb368c08d56aa35299f9350235cd637c41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA9E49bE913c9aA6CFc150ec5C6baDeFB42cbbf67",
        "signature": "0x2dd57cdf0b2506539aa6016a1a870c890fbba8c86defcbf503862145dba34c3e08b91ab132cf9f189a2a56411ec209446cc5458db9af8594ffaffec9a0f4089c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x907B47D908c407C03bF7306D608B949d4053Fe71",
        "signature": "0xd39d92f0ee502afb3c34eee7f48bdbeac7c0eeb85004fa363c8fa51e06724fba2121801dba1e8b05341fd669a4129b9ccf18c7945b4c806f882dcf5db01612421b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x411631787B0132b3225DbAb61c031FD12c0524A5",
        "signature": "0xd6eb9731df12317cad970cdf5644c4dbdd7ec38ea2a74cc41e6462c3abd7a3c41322b35658d898c9522c512c71c23548aed710aa970957536b9f64d7c0e969d41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfB9f14A69bb798140F092069A6621269C9094924",
        "signature": "0x680208b43258b11edb36fd9372f6426c341a3011050e569cd41c0fa2fd3d4831338b8d5c10084e62bb0fc8e8be46c59f83c74dfc950f213db109d36768ffee251c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9d76BdB08751a6F44EbE626548621c56C5Cc6E9a",
        "signature": "0xc2d693a5b7a3abd981bf6b50b66bcf48d6f361088b3bda8374bf1273b04ee7ff7cfa075519136e8455c29847201126faac756dab1f150f5d47f8baf84c771d7c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC3583F378d96dD03223f48D460D04FC7C935d0bD",
        "signature": "0x9c89ccfda866d8b3ebfcfc28230e78cb37c227a75a3cdf7e72ddfdb063a5c5282f8e8298dd35a42816719be508c9486b0afbdb4ffb0de3fbef1fad4357b2d01a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF9e9c6eE774458c11eC26fc0B2466298A63AB2eD",
        "signature": "0x74d6f6058ed9107ccea9a2d1e36633cf814702ae098e4d88e56baf4852be299851ac1a1ee23e97a7fe5b8d14974ce62d27d754995d0da423c27b2d4f7de008411c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE5b5a97d23a249C76A13eE8642FB005F8609EFAe",
        "signature": "0x78a7ee7bed0b7e2d412d3ed948e6cbf8a11f4eb394887d6f1659fac135c1588a253cd51d71c6d837c7872099df2ee796e6f9a3546acc87a3ff6343392cbf85821c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0DbCB3BBD706911714DB8B805c51f37E4B6c5527",
        "signature": "0x38fdec22efd04ce9adb854e30f220c31bd50dc26f5b8d065468778dde8d0e2c16517b3e7b995b3d72cf570185880d40fbed2ec7a39f21742b6ea7fc466ab27e91c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0f00Cf3dDcE711D7DA6A1CBD66aBE814f5e74919",
        "signature": "0xbdfa14339531fe08b990511dfe42a0ddcc2fbb92ad40735574354cbd4d383562222ab0722be568353282f41f8c705ec1498ba31ffaa59133bf2107757425d9ac1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0Dab188bEd69dae83d332599B8444Eb0A22082d2",
        "signature": "0x3f03ee3118494a6b5cbb5fc4637341b623bc0c41c7ada74fbcb98cd462ed64ab6e29bade4a0469bb226024ea4d40c1458911d962e546b964b175db043bd861bf1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            3,
            0,
            0,
            0
        ],
        "address": "0xb71e58F32F756527488BB4BC2E5414b69bb3d565",
        "signature": "0x2ee6f784abbeb1a3b669f73a17725d4f820bdd4141109a43b23e529c1a4cb879361f87a4a4ee402b99df7c7a6c97dcc3892b94325cf0511d4d2ebd097ab97bc01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb55D003E6042E3867E6e27e8dC44103d3d98bFbE",
        "signature": "0x7c278ad897092044f7e8f95888c119a869f2e76b429365adaf1e47896678e9c27dcf8566fffc8c67e724d151c30ad4a186d61157a8cf834d7ebd1b0fdbd634451b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x12194c8E03A2E8e38B3a0cA634CD71E08d7299F8",
        "signature": "0xc6f828ec5ed475c1832166b14cb5386aa355acd4ca254fadd47c849b7fa7807058bb50c5cec6d3e36c02c7cdc283874f0399fa86c7f89728847ff231947b7ec21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb45b20A2fc604934293B3C99D848CAa0Fc4Fa47F",
        "signature": "0xa5c27d8dac0c0f99913183788a17a4fb6b0ebee9498910b69474a37a31e143fb0d2563d8632d1247cef1ae8b4fc0a3986c328a380c101fc05cd62b4e42ce0d1c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x39EB577C329De42B2e61191420Ca022C0F15c580",
        "signature": "0x175cc69c3caad7799400a6b91b7cc4ece34248620e4f00e0260a60a9652278011d07e8ec72763212558030da077f8b7e99c9649a30c1c796644ed174fb2a407e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1915a723210cE6aE6B29e8cD113595b55b854067",
        "signature": "0x890bf8fba6d1821b6c1083d401638dfcb824566599bf2a300f810e652ef477832cfc717107622b848482a7b61057f0cce18b0cec76db36253ae42db2f252d3831c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD900F0c6C6cdfD16858776C6b717e77cDe6a7392",
        "signature": "0x0eeecf512dbd254ef8958fe00b69cb4d56187c8a43df08faed138de28bebb8ad48a4befe656844dad813af43d969a94470e42d7f03208a55b77111751d95d9161b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9E9DF20fea8Df3f8ae516F4a06a2e47E0C3BaE07",
        "signature": "0xd50bbd61dce1ab094099547e7411829d02a5981a360759bc438592ea4089a1ad07b3a03094bc0180ece27f0e6f382998690d0066cf61982b255a545aad22fa181b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x21161E4d9073Bd75F4E8fCB391371C609a8CE98E",
        "signature": "0x7153e7aa4ccf8d32fd78a0b626b336613c587cc2e3ada62af1aa9969174b74cb32a8d527374c70413d204db122b90762dd355a302d6360f68ef8a059194ea5ae1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x31D13C80047BC118Ec5cBDb0d4182b0cEE98Ee6C",
        "signature": "0xe33ad9dac7436375a523c8e5db41ac0e560d86e2fba8ab44516a81202405ed4702e60f90481f185bff2d7ea32caf3d525b1d9c1eafa93e46d18a96b3913d88081c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfd33306661d25eA7d0feCB61a8Ad7394BF749928",
        "signature": "0x06f2eea5deebeb091442cef2e0a7e8dc0c4b4e29b5a0aee05dc8f8089742f3d769cf783331a599dbf0f39c2dd471c0901e666d6060ce603af78b025867dc68361b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC1Ac911F9E9f2C3262FfCE96B9998E4A0c243EF4",
        "signature": "0x2b5739dd5daa9ecd9025298a9d9af3e1578b1ef48d7623fca8bdacf17d8304fa104301ea7ca6c8e4b4f771fc20d14b5e3231013a8f4688009f33d4b6b69f7d1f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xCB1358c9f967B205da37f8D17770E73C50764EFF",
        "signature": "0x50023ca4ae27f1359c2e68aa128e830775aee4983281e47afc569d20254c10d05a9a2a78b737b933ac2de1f9977bf3fb5d9001be83290e5a86fa98c7e704359f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC214aa503175DA303E4cc8248362B2eB442Fb8ee",
        "signature": "0xdf6c70da9e2da124eebf689b250537032cc18cfc051710eaabc4e3a534759ae64fcbf608b84ec6077dcd24b828d148a5ca39c015f0854a2b3c62327e43dde6341c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4AAa0ad4Ad0712359B437927c17d88CcF3b2E6f4",
        "signature": "0x46c34f8635503a219a9f6e9373f6bfb253d6523936ce62c33adaaea9a7ed7eea28590441bd9a0d1c45eac64e4455e79e661325d2b75894b3cc71e4c9394f1ac41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7700997c06861f559976d1A21A9468EaD068E3Cd",
        "signature": "0x2d62cb9d865f53346600ffe89a86603eea14c29e5b33895383bb3d219ec045555a3c0bdde5955a0deaad9d8ea286dec9a27b00fed96a1dca4c63d5307c40cd291c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x75b86B7E11B2faF72993718402C1b8Ab4233cA75",
        "signature": "0xf8d8797629d10050704a3df13e3ad5370d16894753405507b1a7b3d3dddc81fa42184a6202461319276991dbad30496fc8943615a04ed396d3a3d9cb91dd0edf1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8Bf7697C2b597A611C98785D20524334F28A7F75",
        "signature": "0xf8bbbea2e400440a969c5520f86c551f56a8b6e1c989a97ee84f3f62750756bc3594ab58184b31286732418e9e396f6d2f8840b6490bd6390c22671ef23525b61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf5A1e78402E88DB5bd62551B38f51ac139b4C3A8",
        "signature": "0xa9a3ff0a8f3c40a0ab27cca9558bf5efe70b9d3081085eac63109d8c6142c8ea65d5cf1c7c5e359a8c117806b7ad18688fa6f3de534c5b512a38c27f1a425d2e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x747F6E7f476EAbF62C28a5b34209F53aEf8530F5",
        "signature": "0x9072d7f5d65f13447a3a64fa034ac93b46c4066c52a87349413944c3f55427f437d9ef85183185196fbb25de4f4abd07a99df5211eb6a64b95377e8b40d5b0171c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xEedc6663E0437A3A3B0085cE40856454c99B229A",
        "signature": "0xff45c6d9b2f7028a6f0a14dde6f6c0353f75617e2084aa25be3c3116f2cb8f797ccaa2fb8e84b63f8a7ef4de6d9460532637fd7f28b84b5aafc4e220fe2dcc851c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xEFAa227c83B53b667431A4e871A915a6589ed048",
        "signature": "0xbb085f28da189c248f522c12c0ffbb1002180951371d7441e9f0fa10e5f160ec405ac3aa082fe87b4ce37cdc01453e5245402bb2d787f9912c46c299d09c91c11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf4Cc26cE716a04d073a7E09F6446f60Ca691A1Ba",
        "signature": "0x732cadb40e8e0c3699d813d3d3e3a7abe5cb69f078fe1f72b80a1410c633f8397403202ebebd9de3a685bda233a0a72ac2886f2ae88d81915290d524eace7bcf1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC702bdC4630900A7971f35AaC9097bc6639f30a4",
        "signature": "0x570cb8209ffa15acb20b83938c394d6b5023bec6e5a885d0de8708644a9649fc14d660e7dac51c5e7e8ddc6337296eb14edb6f5408bf094a2038a3f6e04480a01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA29CB0ddCcff64B4bF3c5165E75288A736A5aBD6",
        "signature": "0x050d48d2399a560ab7146f6c91128fb28f1b73b3e015d985014822fd3b50a18144ab2a06bce33fb2af744ed60516bd5c9ca399fad562f2a22b16b34351d038261b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x18705539eb88ACEcFe154Ae5522cf21Efa14572d",
        "signature": "0x714b109bbea249d88706a9c5c0b35613df0ded3044b79895a2c82a57af4d323c24e39a6cfa4293fb81e63c1ecce4a547b5fbb8077260d53ee0fd2ae33a4e48f11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x83792Fc1cDD8eb79209c6347C27CCAB0fE5aEb6f",
        "signature": "0xb1d112ed341cdb8121358b8e38b5ac734eef127d1264599dbb31116a41df812a6afecebf6a63dceb15564990091eb1293b75fc220cef70c187da0823beb98f021b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xa11706a22A0cc6fED7858E2f807c368Cd2A056f8",
        "signature": "0xcd73a3fe07c06b6bdea27a8aeb5a2c4328f9ab28375fba88d41aa2e072d046650d8256fa60989e20f8c6af5818267d1a1683a7bf1344aad66b1cf61cd21837541c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6649DbE20481d89487a556772ae9Dcc8453ED092",
        "signature": "0x7b74d479f6552de31baf89596fae28af45a3aeeafce4e4356953a142e31430fa0d5b6bcb90bf4673a0d5e9ad37c09f648bf7257ea63cc336edad577e324add1f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD9B38742BF0beE25fFE739aA2ce67C053602C5A8",
        "signature": "0xedd2e0334f76d27627bbf03ad525832f283ed6f4a0ffd22c781b0d67775ba08612f43def7f8183f603773244b061c341dce2182e9b0bcbc3783ffb104875ada61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1F7c784047804F2725b8D24d353e24608fd0eD08",
        "signature": "0xe93fc9f5e674c802b1e8da2e5e3ffca686853b125b94a5694e9f66377401ff0d14354a1a4339433311dd079f69edd3a9979dfd0a74299f104a048e15780386ec1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x82E4e5829b75fF58849324a519d05ce6fb6375e9",
        "signature": "0x17decd8c6aafbfbcb27d998bd64f728221323fd98f7d83ac48dfa92554c5af8f73193799989e86132322d59fc84a91c888d240a690360bcd7835cb2c700aac121c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4B22e3A8c2Cf58c118e298adBD9AEdab5bccFC3b",
        "signature": "0x18e8cc2411c7168c225d64093d54aa9b3392cb0a78715dc7bf9c0e81e0108d7b1bac6565d0d47e7f9cefb5db0b37a16e6a883d678d0f2874323ccfe70402e31a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x49c1D54D3D25c4DeCdc974bF82b0F53f9f78C1aF",
        "signature": "0x72047965b1fe25fc9e73735cf834075b41bbca3dba998fd9621f2ebcef60e9264663549c448cf535c1c0ec4f7e7bf00235dcf62e7bcb7841c6d017d9282b48051b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe95050Faa16a6A028Fb3e79EB3FfeeC6232A18fe",
        "signature": "0xe8bd03814e8b82b27c4de4827b37a4262aca6924ea8bcf8f7c23a7da504918b771f88250d315fb357bf2e14788169eb3cb784e29d251883a567d6764113c67c21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x761f531cDaAE0c7d0729491dd4B2263ccB87A3E1",
        "signature": "0x1a5c6876c511c28466b5390cbc221fff6dff4e8871c1f605afa8be939eef79602599f0b84e2e237065dadc47930756129bb9ced2c50141d1c2a7a2a2b8e34a081c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBb9914618f2d9C17EE5c33Cb2B10f4310fa7570c",
        "signature": "0x0d86122c751aa634ca630192b797d1c9201ef6122a8a13501422e700401cbffa643eb2f0493b2626e2f5915d715e2ec63704bd0bd62e24fc92f59308eac840d51c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF6823BC6FAffd147d9be3F5d8d7812f0768437A7",
        "signature": "0x726c73b484963423b44cd9d8e794a0ea640b5b4c2fc86311805140370959095e270f220b413e7cf92954b0c92c1a4ecb78d89c04db190384cb3bde33ae342d401b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD8BCeAc63ec57CCc996Cd7B52d202d77C84BB5cf",
        "signature": "0xcc5ce68eea0f05b737db0248f910d6aac1c66b736f7d1f345a0a1780d2f117046f091fad73d6777a98b150949b7a2937fbde1fc05aa457e63acafa35f4daffb11c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf9c2F322398E58dad8532716D751a7447AB7e299",
        "signature": "0x1541754c0b9fde350ee17231030080a668a941591564df236e51d727a500edfd3d12434fb43155e510763809a5068127e35cb95d76b050dcd38f453e38c8b2301c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBd77480bFbd71A1b82B8C897A13947A1058EfD3c",
        "signature": "0xce8c8086288a04fc50a74bedac097e5188e14311d8076497c34b9c3d349b4b8c2f77863ad3214978f6c820d826598614680da36d312efa95a6fda1a85fd4c3d21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB1C380d23A99C3fa9FC469e0139070B74E615e4a",
        "signature": "0x5a52f35245cca8b55ec19bb58e6d936300cabfb83f90b182af0ac737e71eedb91cd823a9e16539e77eaafaadd0cd081d3d1c189db616e00ba007b2b5bb3310f51c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfafCf7e87087C5b5EC90BA7c6E02482Ee924C059",
        "signature": "0xabcb137b9a7349c826a31955185fa99c4e4b6a0e11610e8fcbeb1dbc9c7f35f044534c79b4ecdfd52e3c8141943216c89d9c6c6232d291536edaffbff251d7a01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDE5D587e5103e29B87550d81F206Acb3F6fE6F10",
        "signature": "0x00efe7cd8ab0a59d82a9ef2c8b411ed7dbab0b55c9afe41c5931fa169a1e8cc02863e58740065c1cedc59b30a1ff4a370ccf647211adb0660e4599e2cbf513f71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x03DB4A211490eBF038b4C20AFf30273D350a91Af",
        "signature": "0xc7003b4686149d3728bc310272c11c02de8ab1ca1eef23388468ecd965488feb45631ef9dbcf5209e7c65d336cb16e830698bef12a23cca27d2ac0ba8e73b76c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8C164ebaD843d994AF9b762a75D4bB711C909FC8",
        "signature": "0xfd24337a797741cf846ef0f92b03fcc44937601938fc18c2ec77239e2414397c5f15a42eb068f4b350d69c758e1bffde8d9565e3c67a04b7c50ae17f542e0acd1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1666B1bDfD001e55E3A7b088bb11D6a5CAe74aAd",
        "signature": "0xeac0c0db40c9c5e9bfdbe46c362c5b0353b7f867cc6eec4dcb02831eb6f6a8680fda3ace9a28105b686d9cdb276ac665a329b27ae7c97ac76f0a9cfbeb0fde651b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF69e69a939D71252F48299c847143d126Aa16E1C",
        "signature": "0xa7e2998bbfc5acf7c40b665ece2d544cb456a0e90108e2737f60986422a171df135dc83f11ea7d21ffed030b3ddc7476bc7ab4770336641563ca2326d77ff0731b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x467d976487580d182757fb406480A5971F90dB43",
        "signature": "0x348200593e81aee7e5832d417dccb97250d87c320a9af9f3d003c0969acb432532ba007714c29de799445c808751eda5afc8dc517db0f0c4b5d85d9827fcf27b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBF235dbCe08f9642C35c1F6f29e8C2DbC5B275Ec",
        "signature": "0x8e8f127c53e98d6e89023f14000fcf20bf83fba76408b2bc69c01068ae7aec96347559d4520fc3ca728666a556e9e3377604e184fb4032fa6b9481e91ee7799f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x80E646bE3EA7baBC0Ab74F196a7863593Bff9889",
        "signature": "0x5cb4d9889e3aee5f0ab80d6adb8f0959d9bb1a2c74a8cfdb532f0e44b50d0169593c1f06a0447513e10863fbe39858f482b8fee0adaf79fef689df4082ded51e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe34ecbB21220ceb0ECE6198eFf3c54125F9d0E36",
        "signature": "0x2b2252f305fbc82955acc169f2b8a91faeedac25b80330ae59dab389ab00f3742a70691812bbb878c87f57b0b117c8cdd8254080722f903425e422302efb32c31c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdDf1095aF298Ba71eb950A4Fc945acE3114B25dC",
        "signature": "0x73745af15a90b1b7e53efc47d9424fc6ad6d6238db46743e6b59a810a516f6013873dbc752a529599d6e56711222308e50a0c96374e5af8d334a4769562aaa951b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDFC2E3310F9Fe89714Aa4f8D8B62be1fb5c570FE",
        "signature": "0xdce82bba58ad82a5fb845e4226960d50050a216739936aba0280717be502e75c4f0d0327e336dde38e4d1f273ca77a0517e71608275328951331d3256593a4011c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5e2bc31F87Bd4CAD29274286Bcc2B9690A33FB05",
        "signature": "0x4f1652a3bad328134a3752f734b9c4f8b7f52448b73fdee19636279d7cf172580b65c3aa6697496be1f1f2d65f6f19cbdf4b1425ccf21c25b711ec99b75fcaf61b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB57B33D408D1cacb2295424b69E325A7cC3b5BEc",
        "signature": "0x4f7d2aa6e1ccad1eb38334521b58caa10bff7242338a820110a131590db06c7924977dac095d2cded34c81e26564bad38626d189a9123b00e84b7dc214335b4b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            0,
            0,
            0
        ],
        "address": "0x1688748bdFaB699D2bbdEaE7252D1707E52Bd8F5",
        "signature": "0x7a883876c28bfda716876d6e3e78f3ebc70d0aa3719cb8f474e6fb18d1e1b96546234ebc433c5d13052a72fcd1a8474975bc23870d5e050e082d340b691f024c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf97Bfe173302f244E39dE9603557933b904bbB74",
        "signature": "0xa19dac3367e4c345f671a336156bf9d4203f54c25821434e4eb74837e813d14020063f68b5fd331e504c15fa77d6643640f9fad292aa3e4fd6d9e23301b51db51c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x12fCcb14EBB0F79E89F1EC3CCB5A079DC3439eBD",
        "signature": "0x56c8bd7a95e6f021392174ed912b39282c48cd84a28ce698ff5c9f9ae92066460339854c8be5877d342aee0dba9ac2c6f8faedee8883d7a7273a7ee6b278e3381b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x753639F455877441117af66c726ba08e593a27f0",
        "signature": "0xa172f554852ffd078cf42c3ec97bbf283eabf452397d3a140c791206b1bc92675b300599708eb3b034396050d3220ee2352a4eb93872e65f584fa700054c5d891c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2e7b345273d72793C8115bf315af5a37B949f2B6",
        "signature": "0x23968ab04f5a8192944984c63013ce6e20be514a58879ab7640fd987001a8b286d50a6e7f6f51be4119a27f366d2abc126f52c6fcff1320fffd780dccb2824f21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x63fF29F380030182e71750fD6e64bC4686388Ab5",
        "signature": "0xac1a1d4fc696da64fe3a604472768ab512fc472c1ce90fdb37757893ef26f496149fb4c3702a3399781cb9ce2ba91537415fa3502ab2b600e5fa5e7ab7c1866a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC420E23F804925e5c36Dc8B6cd9A08DC6B0e9aa2",
        "signature": "0x7ce9955f81bd505d40fd5747853875569189b3fa5397793c9f4664d6b4156e210a341774ebbbcd4a921f052452a4103cb401bf9d9bec9bc44a0454d48a1c81161c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA75d2923cCf4FB442869566602b43AD92076B8A1",
        "signature": "0xbc19da511006e255ad5cd2486ea19b226f46f6f0ef8e84e2c7368baaa7ab54db53207b1ff9326d360e83274a227f9aaf4e8fe4d547247525295ddb73ef86704d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x17C6C36ce1F48C1ba61E1668279e79bbEB6d65d5",
        "signature": "0xbca1c861faae34ea6865efa428d5403de1a166b95716a9336980ddecb31cab226796b337b8870c035caf400a89a0acbf048475174036124e767936c5472c032e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1015f2bFFA520803bAB19c6BA53e749d4B30Ea88",
        "signature": "0x7edf78565c832fc82921d47b8d8f351145f83028dd84aba4b74c713a7264b8392014c91c49ecc2af70b3f87adc6ec665a55ea7dd47689798f522f3a293715dba1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x93780428FB8767b31403Bd7f66150400e560beE2",
        "signature": "0x7cafb0360d6fab7476dec2610d220a13faad29d2632f688bbeb0cc4a6e7ae7a717384008964eb049879dea74e3eff073d8d307c42f3fc7d074022072c3ecca0a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x93b61743aAc6D4278EBD27591bcCad8048AeBaa0",
        "signature": "0xcf5f5122f36edbd57adeaf21dec96e9590451442998d6978217215504b68ee960ccca1e883e80151a0f09167a21168dc07d8d59b54f2e1e5f8f68a8e33276aff1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x70C2B4f4923208123572671580BBc218479D90e4",
        "signature": "0xaf5fe4eb5a86116acb5b01a0e59a756a8eeedf8beffc51c2b4d0897f041a35d7131116b45abcd7025b1374daf67127f4f690cbe19b210423981b82eebe47ff401b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x286DD8223A25723eD1c95D2276085a0C8D57701c",
        "signature": "0x5df4af0f72815940d8b597f3bc88444fbb80bef93ea59b016e6a4484cce0ecd3743061343a4b1ea7cbe1e58316ff2d4044417b26054fbce4d0ccc41a336d10e31c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x71914e4BBF30B5B408818043bA670F3b11980909",
        "signature": "0x9be1c268291253f1508f378bb36106224cbf38e2c6bd3f550f14bd1c61d2e7da5b0edca4575fb4cb51c2750655410bf7c737da2c671368ae654c0e24920ec82a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x28ae7B4d971139F067aFb3bb41ceC0705afc947A",
        "signature": "0x5323f236d3acb67165a18e06e9d7e577baf82a2ca5a55230439b87e6ee4b74e369d6350480e5501fd8919eee6fc07fc952978b56ef21539899646d7ea5a11a3a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7bb6B88a5BaE0983248CC813387Ff42EEfb6229A",
        "signature": "0x5431a798c0c20de024babbcde05d52051ab39f6c9eca0855770c64acd3a92b8c7626a94b959e1d493997317522c5dd04158a23751d3478aff79e02fff7436dfe1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xcF3A3847D1845333aF5dB00Cc3A4C90C11bCaC50",
        "signature": "0x549475708c9bfaaabcfef8c3a91f5b9cfc0dc4c83ba2bfd64d9dbc9c6c00077f0a6c253c326adab7868d492ee54c79679c477844e67dd20f4188faa9b0f750251b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x63AC3C3ceFfa95C0A7e43d40A06f4Ec3b3DDA478",
        "signature": "0xc5385b347d84971e9a5b9da7817de34e51a99000779afc939b5b4d14556be2c563289e5219134f683be2e7cb1d915bb5c9df5fabc90338c61f21751a60042d371c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE41306Bd435361C348857C06ED26c1BE3e2Bd761",
        "signature": "0xc2e5fe0683892c478e4557b73b31aec015185e64a5448ee3d34a9fd30a77b8830c3afadc0136e7e61214c601d721f05cee1efc82e89172391ad6faba434eb2691b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xa44e125a945d9eb098F7c6cba6e2C18670172163",
        "signature": "0x3820e9ddad5a593e4dc048d48e95804d51d8e52388faff72ca682934f4341ed62e990b483a18e424bcb96b87b8c84c252f5541114ed19a2df5ac70a7de7d056c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x449b28a44D999524716209c63a9b30818a29A4fC",
        "signature": "0x384cd156865c03028d9cc1d873fcdae63b4ec923b3c17aff27a564296c6d5e79064a6205a382945f4ebb2d8a13510c839362ba90eeb437b760d7a25be5c2a0da1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xFD43739430441a0D68e754da83c1CCD61df3ED72",
        "signature": "0x023a683fc262e117eeab859a03b42bb43f0290206f4eb8c4d77f2a7501b03fbe56334d7264816ee717d70e62819d49fda10a1734e7fec9da43fb55c6441903ff1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9831d74a3d7B18493B32b38F76c5c0d729E96509",
        "signature": "0x7d1a267451f3beee94400d577dfb73320b9e24a8de426686d83e3aad97095790564d7afa76d67f6d49a3df0a09875126a5c50019e8f24dac6db6758f1ca5d27e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x251cE7578d7EEdf84Fe64E2161eFa62Bb2726574",
        "signature": "0xac77e7cbe9104609b708156944885b0cbd70753bdea4b536687843213d466cd965f0b5cfcdac5a8cc7bae8368911cd44a1cfa927201fa5e4f6a2763e2f2a1e4e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA8C7eA30b882259782AF11f7D330e8A5bB90993c",
        "signature": "0xba7db25e631018a9e75566c5ca58bc5f78b532611fc0051b6f259e7746d94cd1267adc55bddbbe3384c944475cddec373149bad4c6431811d4cd1483196a90b31c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x066973c346731C93197C37363199301Ec7e10247",
        "signature": "0x50a6f712be5644e176df9bcb3dd2c171f6af928c5c85aa335133f2a1a2765123670b8603818ec40d4994681e98b1cd26dc2da755c90c38c4344c5c4dbfdadcf71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0A76785d5E0D557D32b3941C65C45339eB790da8",
        "signature": "0xa39f633e1dca7e6d6cce5396a3ab2e5776efc97276b54cd8384374c98dcc59e441efc10ecc317f7fd15c40e2c634f30d6c12c1a3be90daa977b1311a5d72324d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xcd25C069908C3865d420A2DC160a5Bebc197378c",
        "signature": "0x89a6f3db2f48f81b7791105a8080c9060c0f10594c5c3cf81d0a3524779353473430cb0c190e1538e4251091ef64b3c922d09398247242d44dab4aad52ed6ff11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x338629b7deB6A6622324B7A84006558BAD179C82",
        "signature": "0x5f4d43c7caaa3103c59e212c95d6aea7ae8782148f085ab9a1e062995e2c4623485e7b83a09b57d29f6da91852e57984ba5d24135738919b6d737e8362a45efe1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x221f48E3ef8721d9Dd89E472a4E87d7230643d4d",
        "signature": "0x837572c71eb83730caa9e8a7410c3705c541f5571079914a7a87e1249957e31335d7b883e5985b7e4f6f73bec563a01ae346644c9b92af9ed38b55d8c3a4dd271c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2e9F7fa8259Cc4d6867d39240d0271b4faa0FdB8",
        "signature": "0x81f66e179268c5f63cff493dde1761b845183a8523f3f11333900022cbb4d1f5288d8b396dcf7978f7478f6fccb7602dd41c3abe1e0ba6d7e1477baf3f49995f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x975B8ECC584DbC7769aEba1f3771e87f6f227935",
        "signature": "0xdd3e42350b28cd6c185acf2d4cedadd3913c34765c3546c2ad5177fe855e692c6c253ed8894b0525c4a175d12483448b6a460a476e4ab20e668d82b7e835cc491c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x246A426Ee65C6ec7678ED9E15fafC8088AFf4bEC",
        "signature": "0xaf4b40ea99e0b0b499350f07dfb471f2d739204774e596a590e2defe31a9dee64ecc3a07d4525d2040776a0917fea98788bb76b5abdd38085273e84bbfd12cdf1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0CCD47285e21EA146D4a5B47fFE941793426a7e5",
        "signature": "0x16e50439c85dbfbc0eddb83a2472ccdfa079b7b6d44f7d1e1409f63f534714af2cb0eaf8c6570476671db81a837ba9c9a74b92aa131c05914057e17e025291461c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB10faB884df0943D4C6ee59652ad7112F2660db3",
        "signature": "0xeef71c4115373ca85e9febaf605293641ed526bf6564a5a9f714309a707d0fff6875bec513ff12892ede8a872357ac96b6cf68b9f64ffcad3a7725d7eade570e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0fFe8E147f8A7A6C32Ac127390FD4D00B0D66d7e",
        "signature": "0x91b4d3397acfaa7c029710acc3a9649a86d6cacec5c37d7bc036887514cdc60b7a752b6c4e57eccbbe778be53e1e46b4381d3a4e2a0c18b72e3bdc11b1887b5b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4538c1a837Bc93212CDa165bcB196804A66B01c5",
        "signature": "0xf84a3dd59d74764ef4d27f5aa25a6a9903ee1b4b3b44c76b677111ce9f95372c7338a92e766dc7ee1cb6fda3e769c4060cdbdd718109b84a0024f494887df6fc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x331EBC1437d178dfCBF712386D6A6E11E107EdA7",
        "signature": "0xc475c55e6b9cb46bfdba63f4a4733ab6aa8e1331eed9dc284bc4dbfbba2945260586758ba678b0bcd540c5992f9eb68a0dd61f2903cacc967921f24622d3b3291c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            0,
            0,
            0
        ],
        "address": "0x12a5f348EAb3C59654a6Cbdc56673ec11A5cc42C",
        "signature": "0x1b926553c029af645dedcade422d607e1085cb62f25d0d0e9a218ba94ee152f2608fa0753e32927b9f014357aa481642bae72e8d2345abb1233964c5e0dea5731b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x55aF2cD30Dd1c43DA194B8121adbd1A359996b6F",
        "signature": "0x5197d88d1c7d566ea18834c606297222f639582065feba35a79dd6697a8b4c1a290f385dc50a11ea871feca9284f1940cacd87038b50788955e09e9703c542971b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x779a834558E83bf73DE6f0018D555E9ddb8FE7bE",
        "signature": "0xb4162de4e5073d02030698c536c2bf71d2543e54481e95fa30fc9f623607c06a6c5e0187761bdff70985724f69eddf0ceadaab0b542db0da301bdf63b1d76e991c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA2C9cC129922747E2cf7Fc00e1F5aC3771C6FC8B",
        "signature": "0xf5ab274284cfc3cc3ca746b930635d32b517c4eeaeeea5c2e308367eb0629a8166b6a6847498e70962f9857904682fa8b9ad9676cf48826767f75e78f7594f1b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x82b9b9c27cEFa46a65ce0F803bf8dF5daca72c5a",
        "signature": "0x63843d5ce7fe4abeae40299d7f01bcc78a67053018f1317c94a59cf2aa18b1da2a6f412d0b41ac9fdc6c0bc0931a4952874ecb40204da1262910e31fc978c9f51c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2Bd266df368F804C57ED76DaD4C5A62eFB5aABd1",
        "signature": "0x4f5fa962723767287aff47f79729588c35983e370069f62ad8edde75b8dd631e172d19f7b40d361d024c6062bc0826fcab2c0b51d4f4962a9366179472e329741b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb3FECc0909B410B01E3c25E6f131bf31173532E8",
        "signature": "0xa81d34a22b0846bcf8feb6c76ab1a294d9b3097ec7af639e23b8ae2b8306d17f7c01ff67620bac9083432fc1cd10749c3f320e236b8d5695f4a0e0c06055b72b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x27fE707956f8b21AEb62cF7F31D8093649baF832",
        "signature": "0x326dfd8adf1053a7045e01f8ee88b866abd9d34f8285cd07ab439d213fad7fdf19e429a623bcad321beb23e62dc8ca3a999ef4fb54484fe0ba608fa6f550347e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            3,
            0,
            0,
            0
        ],
        "address": "0x074d45E597379A2C69bc4A9EFCdFCD41bC6D4728",
        "signature": "0xf337d349fb721f633a15196f1d75dc19d9122daa69f544b4e2583b343fb73887750c44e57157165aa9fd57cbd2e5983294960d728be1126b1e1288112e20b1e41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9D4783C781464B139Fbf1f0dC23a8Aa1D72fC363",
        "signature": "0x0e29fd18b8cf741315415abe94cb493bfe5b01cd4bd28b8778141bb51c1b490a6f3acd78a04a258aa792b1429380001b5e64a95438681dade17ecf43bb16e0391c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5DE53140740Cc7A0d514d75e093Aa88Ab1Cb8d06",
        "signature": "0x96c2d93878953a73042ce5d8780ef24dafbcd390be740ac3ba2088490d5ae75a550a4e6c9c7a457e4c7aa898353ab69f9b4fec014b87a838f6468f62946998ce1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3f9DebFEE7e1cf5eA0dF7F6957553b0c87780623",
        "signature": "0xbec93fdfeb51329bcfc86770b1b1e9e24a4919004242789df4c2839cf64aeaa07bf9db02f95fc75608410bbde8cfdfcff0fd9b928f18e08eb3e9979ae9c17cdc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0f4597CF8d9DC4c1f4EA69188700d3DAd4d77583",
        "signature": "0x4f30580e9d89c44645d3594fded03ac3b1b767c90092e5101ea04865be743c7a05f12d356888a7fc128e15849a82bdc6bda4d9766ce4049c99a1e311d20b10881b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xEd1c848b44A671494a7882767883C8502C12B160",
        "signature": "0x68bf2232545b1f782718ee7ec426db705da5b1abf8b7c201765abc9b74bb60da2041a2e5003049c3a6f448741b0f17c4685eb05323421466ee28a14014e3c5211c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x63D00811D5FFEfb997e077702aDDBD884d9001B4",
        "signature": "0x60e06a3cd4e05fca436b9fadf2be6a1af6656f1586c6aa79c845d2a376ca590a100f7786955527759d85b361f8d4e6a9747434de0bff75dcf8989e452fae3b8e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x35F03a6314DE181262E4b18d5aA9b6aD12720e3F",
        "signature": "0x20c6035bdd6998a1594fa948c69cdb81f63288a9472c59141408eee24388437c0963d8a60e7ea13295a5019438482c0e0f36e869bfae4b8b4209c4977786b06e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x19f3521BE37caC75F9c001C8c0Af78F13E245593",
        "signature": "0x6a38f2cf7463cbf9ceed59591a5d558dcec5db52b92d2e32a296a3d0461fbc487720ab0befbf884324d33aa2db5d380cd9c3a6fa2f711f045ceb1ea7cf0cde6e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            4,
            0,
            0,
            0
        ],
        "address": "0xAC67D7e5becD56FFD73cFb45e1cf0b75913C2a3a",
        "signature": "0x512e2598849bbe2a44e400478d3b804ca1d4a6f5f2a377495141c597c724c91e350bae0222fa9800e91315d42438cce9eeb971d1e8ab9a05a5252d57da191a881b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBCb392466E8ca68c680088290e75C51e28fcdd9D",
        "signature": "0xf0131cb3c6ab3d358586be8544ddc34ec4f967014433206f665235e5afaafaed2666fed0133653034d09a29e3d5ddf4e812b6f46e8d8a685796489215b203c9d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0cB1bdf1D0E18c919c6FC39E684280Dd103b122F",
        "signature": "0x7cedd97877446ff82dd461a7ce4d0b08d33324e100591ce506b13ee0c612935c035673509f8c873c0ca220e36cb2b1400b0003816f49f726a2faa9b3a48b2ea81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb92414d5364C3c4CCac57DA155dC95A2Cbc1f31A",
        "signature": "0x037f407661f909159eed5cf1ec97abcbf31997d1ea16303c7c68b6e7debc6bda7aabc18bffdb97de39d9aee5e77285ffdd50f97ba2f679185bd43906147fb05c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD99402606074E685162242dC5Cfe5396927627C0",
        "signature": "0x8f42f1ec7c53ea63366665982497bf451c3dcc2b4a014601e48bde064a24af4126cb7110f2fb6741c3ab8004ab1151a6d79fdddcdcea603ae1c0261459f620ad1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0e4bf2a1211fe91Dd3e9dB17668D4fD9d0902f43",
        "signature": "0x5105464c1699254db80f74ee2d98ec7ff12c10651d0b3e2098b9ac78fffd87070607a4948d1b303bd930a8750996569fb0c93c424c966307ea028d795e07f1181c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x415B7144F8FA2aa95e034487749d3d72A31d6C43",
        "signature": "0x3c146bf3f8eb0467ba7dd11a06592f37137617fd8f0f20fb042fdb60e64db788330dfbcbcb8367bd84c718300d93c98b4cd7e95315fcb0dbcc291d1ed47087df1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfC5355a1A7B82e47fb15a95dFdEB93a2add5cfae",
        "signature": "0x5ec4dd7b81f68e46355c03672bdf8de4830f25ab06f19db19890f30dce86baed294bfdb6733d6aecba9d1256718dca64665efbc9cc14fc53f979f7535f7b17ef1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8A41Db8Ae5c1ccc3b08aD4f7e90908eB8C0CB459",
        "signature": "0xe87fb1ccd93a09554d9eb11542f045255d53af8757133eb76485f84757eddd7b374cfd53e433515030312c12d9a0145f54dff01c5bb5e53734830786b747c5a51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA7303EDe31070CEad5a3942a96F61D879c21C031",
        "signature": "0x73e8b0477525865339d8a3f2582770ba7ea425c083c0a670bd3134a61889f5ff4b88d5694e8f2918fcfac493c1b5735f485ccb79b6780a544559ec57e8f157721c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd6a984153aCB6c9E2d788f08C2465a1358BB89A7",
        "signature": "0xf38bc4a37237f8c564acfacc537e44b15dc59aaae9199f4b944eabc4eb995ad1575459c9f6565dacf15e5afc36fb7f0a9329f1bba0587578e736fb38922e125d1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x54F3a60530Ee4E56c84b83AbA145765396F1BE35",
        "signature": "0xb4d9447ffd235109bb857ebab61e35c50728285fc72bdeef5bf3122bcad92b3246f5727dea2e46efefb3d490201db4d82ccb48f233faeea6027f5df6d66fea891b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE1fbc4fCa1e402b7FDEd7b50993e94d93106Ef9a",
        "signature": "0x5be91fa4dde459c56b373879553053462b2cc206520f0c58f02e581f14a5cd3670b78965c4315ee45dd5ca9b935f41ab3e6f60fb0d4b396daea2cb9a2a96485a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5cb64518C1B779eE0fA194b4C5eB4f95Cd87A590",
        "signature": "0x17970b1e0a778784419a1d1a64f17fff20455af253138713ad3b1213bb54e21e3af175ec2f32bfb371ec532aadee07b349244fff4165dc4faa9baa2c283f6e2c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x87953Bbb101E63A862721Da57f139199c57BAb4a",
        "signature": "0x1cc6860547e92a0041d921400526dc081fe853e35d837bac421c7f105113135f09289b5ea118c34f4618b51b4d7cbf081f8e98f8000955f7a59d3066647185271b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x54fbf43F7c86d97A69976D509C1965F5bfdCA4E6",
        "signature": "0x7ccc2ff23072384ae5fd8164743b2d7de15d5824943cbf007f59a8d23f6daa2e0e0bdf76ffca7a18074874f89383055302c29d02c565ecbddcd7ab13603c271d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD70d1008feF4768210c517076a927b86Be1cdD00",
        "signature": "0xf926c86873524bf745af5b57829021ae515f8b56a4395206819e77ba386161a82a3291fbece98f8069e6b5dcf1bb87825642f79ffb39565a8cdc0ba5ccfdd51f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1Bdee3a03d5945978A473fe4b1200D9f356BBBE4",
        "signature": "0x26e159ce2cdd89ed5efaaac86c3bd15b2115ae208af3f35cf7a651cb68090bbf4404b59eac6dadd4e4c7d6cb36010a071ade82e400afa64da2f2db40dac627771b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xEaDf9D8AaB80D89a2fcb08275760a81D5579a5Fe",
        "signature": "0xb21c0c74915c84df73fdfa2942d166dd7e0c389dbcd0eba0904437c40993b58206dd15d1ef675af02d423f5d25249125c89cd3325596af786a2313518944627a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6a48Ff779487Dc04eA106Cf3d81BB32364c09199",
        "signature": "0x54ca02eb367b50e2fbed3d0606cdd7d76cd0188844575115a9132b69014612bc7810db49afe4676b560f6fda239e79ebb40e8c1dd79579f4cd53e98d9664a3a81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x538e7C91C402e4A318109B392220F34ff3c2D1FE",
        "signature": "0x5571ad406665702a17237eb7928edb8d1b610a8df1ba701e7c56b7abe2d52e24274260b1f00955d0a58689272264d7d88e8396e0e798c4cd585624ed98035bea1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb215fe0A644FAc7e8879f3F63459d55906b4a57F",
        "signature": "0xc477835fe66e432019172dd5174801956e0b859cfd3294bdc1339a22025cc33628fa1d83f34ca19e4729ea9bc58b4e063419e586e509ff00031cece2f2fc5dd81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6cC2033806b9392052B083a22d9088765B0dd9A2",
        "signature": "0x14ee900a7181c21b4e254fd56ad2d6bd677d2411d679f78ee7255af08282aa4a5f56c13718295485e8a7a98165a9fa61ed14c0d260febd6ec332643dd813d5ef1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf202aB8F9E369A6E47720a807Fc9F048E5b4CF69",
        "signature": "0xce3ae06ff6f8374ced7bbb2a094887e56f77c33becbb95eb8e1da3d99da9c55706c5c59da23e6fac5d695e0fe5d475e54f34621c142ee97e4f7e672d8d4a5c1b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x39Fe4DDC439B4aa3dE46A1817d05a5f56480e1b6",
        "signature": "0xce5da2abba58cd4a66e73a0343052740010cfad2f020677c0e30575a82fce1b36dc56ca897c786dac3b9bc9b7353b6a90cd39b5112ac3051ad119645d7917c981c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC4a1B3B51e3E84DED0966a987d8025E090E51e8e",
        "signature": "0x85b3884f52a6e47c7ab95cac281380ac279a78256168e6f4ee5da6caf6d00cf44de702fa0b5f37936c821dcafcc07b30db5396c469781d3918f0511fe6e792a01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc83D6c349FBd45B096376B04026711e2d2b00379",
        "signature": "0xe2a2eb95ec8b999bd03f0aee4e61573642bfd635fc598771b76270ca91f17a534df0ee24ef55755abf5591935e38b9af9576bc9b5752f1955065f3ebf7faf3011c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x06F9CB43196717F24A8ABb3A0E07D1C4B5D20EBB",
        "signature": "0x890756e11b17c492527002a2cb345d4fbd0c8996674c093be640c439f75dac794347aa1843e0035238e054b22dc593019adecd2df43905ca088739dcfdb3cdb81b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x4678E1233e5834a6b85f2fbFA2db1c65Eec0dfDc",
        "signature": "0xaf1eb7222051851080bba8ed3042b35a14d86544a6d655d63e07685c67fa9cb20c200d2170be349ced41c842e4a225a21d69d7e1d7ab02cc0718144df9cd472e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1cd780253d4Fc8e961588a2068a2CFeBd45aBf3B",
        "signature": "0xde40ac4f41514ae42f32d1d8b1f1d945d55b3303b5c9d1e4325dcf56250dbc4178f2a436984e642c2f3efe779853b7af153086a808254618e6fb70ed2c864d151b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBf1d2AEc63eDBa7439b7c36f8f535c7983F11e04",
        "signature": "0xde6112617bb30990fc64e0af7d3ead548083b863a25184e676af250d9b21e38f3545917d31d3d0e42e9bea70605b356a9d8eeb21e854b9eb0d7211a544733e3e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x37b0B95587f5a8A89670d04F83E81858dE3B9237",
        "signature": "0xb24f9dab413f8f999d21aa290bba1bdd547fdf5811245e2593f4377a2a57271975110dae55509cd3b65e3929ecab7bc267151545fe11a9af337123e18741cd9d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6247425A01B592b5a96C41B0bB1E6Dd59064251b",
        "signature": "0xa89b01932e434dd3d3ff2035cfae726b17a96b273cc773a558fd93d415cb948222060601a2a3f381f8d0eb1c948462ca1faa4d9a525e0685ef4fb1c328b3fd911c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5154907dDD93199a0bdcab7179f4F4D957454490",
        "signature": "0x665edddb552868a83a29f886356076112afad862047beb769dd1529bcca5bdfd1d1d8a11f651998e53ad5f81cc8001b6b17605d7e041075c9000c1c740e526a21c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC652e67016Aee525b905cb051D89dac1Ab3f0b15",
        "signature": "0xa5fab0bfcb55a25c4a8af0ab9f05ef3d4cd2d6407fb1889f5ac29000dc966aa10e7790ee015c017daa6b3378cb191413447d2c4dd3fa0e0b76e5927a9e391a3b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5bE56Eb8b232B2b62dcbAf1e900e36470421254B",
        "signature": "0xb8a855d8619ed38f9fa40733014176940124826b8ec769a53b7ebb7a7b80e94d5185d65d9f58e2059a6f0515d7e24351e4901cc410373e1cbc6e7153bdc1a06c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x624B09D27520bB0F4d453CC94607F8157fbDEed7",
        "signature": "0x9e224c1018aa4eb62f7bb256588b4c80687b9b751d6163d7611104c0c56e5b1a2e99ab31a57b4025d092285f9fb86148e1ebb7d8777d13363b4a3a95d37cc1e71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x33e773Bb5C7ceE2B056304Dc3aDc40Dc5903ba67",
        "signature": "0x6cb589c6d98dd383e0d66f7a9fdc9a2943f6c70be874b006b91618ea2031543f5b448c2a4ca151d9261186db86667654100d36559bf6c5b29ddb41662e9174041c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xaA5Bc6A355089899D82CEB417f914022Fc0FA9cb",
        "signature": "0xdea1b3742f3fa03b0b26e363f1bcecaa96d1a5b2f0fcffe4a9e1ec6e5e1609e07e981176ee48cb04d183fddfe06a7201c4f2a676be5678ee8ca70565ecb247b11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x32023D7f53391BE873d8096B19D55A41b9eC6330",
        "signature": "0x1259b2f576489c2684df582eb0887713ebf6117b1b49553e5ee8a78152ce365226f2214b6ef1891fe3657d5d45343673ca2369ed813e2c7c8472c371fd592ca11c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x797c258664f1780241F2876b04355DA3Ce7e0E80",
        "signature": "0x2951f6e9502b61e79a622b337a88effdcc9dc0a49765d0886428bdc12dee08b24fb28191e57637ad8de0f5e0f9748b7f1505a3817a6323b264e953864837d7931c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x371ad2ecEFA2Ec46B3CACEd276F59959d02C6243",
        "signature": "0x8aadedcb4bb9b89761e9ae858c71aa75f35fae19a3e7329afc301d2f0f96021806183daf7711338812935b7a1c9b6e574fa3fa948e992d24f36d3e43559deea41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb375C5de1E949568b8376c20c75Ff2ef1137A5E8",
        "signature": "0x36e773f8c44a3d675bda0cbf7c24ffc95585e0dc5157307b9a3a2f4e303fb1fb152f83f1206d0ccc6e339fc1c6b16f6f4744b79563f5d1d5a85468e2cecf820c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            5,
            0,
            0,
            0
        ],
        "address": "0x23F83025cb8bdeF0426D44dfD840C9eB865D7418",
        "signature": "0x021fe2d1dd784e58eebe48c2751de2ced26d6fba3965c0d4565d293de2d4065f59e0333384ad54e678f6923752c528bfe48400bad9d7bb40ba55215e54f117d21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe0B500E5Da871d362faF0B36aA22BdC66ea285Da",
        "signature": "0x2aaee1fc24cf3adb50e358be4ceee5c5e4028cdc47d1a0ff554dc95458fbc41f6bc84470a9c8e7c3770f645469d80b467896adc16f23b393dd38e1988d4609e71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8F60817449Ac79eF442F204b542Fa30De22e5b4c",
        "signature": "0xa9d85f281735cb400de3c0b4cf613f2d53c44bd4253ca14c66912e4d3e2ad3c4675a4cdd4390ca3f045ee2cc057f718724c2d53780c4345c01d8135989735e421c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0dC84bD988cf22AF2Dd1C624d4f36B9B65F7736c",
        "signature": "0xdeeff572e340210b7d81c419fcab274bc82b4bc04386ab77b6a4b66f8096312d5c17b91fee5db71a1bb004c7ec731dbc00153eacb63948366972160589a8d4801c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8459E412941f1ee85D1FbF0B435B89F27210F951",
        "signature": "0x99ff947d0b661293b6d5c8e455ac086adb747f72ade3f52a1620ade26e6ea5fd5ef93ade33957f38c33deffd8f076b84263b9af235f9b4a24bb0b83a1bd495961b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbE8E6C1DfaAbb579c8E034A30a9142eDB2af4FaF",
        "signature": "0xec0cd1737ad1846ae4340292d51993450316ba016a42be0f4b4273c46c231af762efb0a46c37d413c636e646513809a93bde12e3fbe6a2f25398f69e488303371c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x63710eB8d841f26fF63D567B86eC00157Eb2ce21",
        "signature": "0x039ccba53ebede6c7d58b1b09f67ecdf45f479a51e089a98997f70872901a6f06c9ea7462f6ff9a59377f6fc3b0676238306ee9055489c5422d6bb68601746361c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC70a9DD5a4668399D7de7e6960f7702830ac736a",
        "signature": "0x2afbd83a397f9894adab62fe638aef55edfa2b7e3e4aaa9ff2be8b31c08366eb54a83d949ddeedd55132584a73f3b0ae006e405b71549a695450212f0a8797371c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x95A0761507De71a6a6D6b82847D939d583E36D63",
        "signature": "0x854327c34531f3423d587dd518104b24aab168d07c1835b3998c89241cb6ff83131b2e9c2074a0d0899180cfbc2388c4cbe48c59581bb779973f5adabe0365181b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6088Ae9A4EEB2fD944A9Ea352B55ccb9dfBd8b6f",
        "signature": "0xeb469aca0a2a692e44f7c5628eb71653d4e3974a2b26bfaa1c9fc78c3a5c683e0b97e4d305d50038cf7c850426adf8ceaea61327045b3ab6edfa1f480c2eca131c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xFCa6438CdA9836A8D62d802164Cd4cfA9639d1Df",
        "signature": "0xfb094d6ae108b24f9ad0735e665fd3b6422b24af3ce605729c4ae03e386d3dd329010b4a5caf3329051f0001eb4975580b12b18bdf5193369454de5364f486a31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1F163b5aab1264Ad409A367d6D1E7e15Ed7Af884",
        "signature": "0xdfe998bd2fceef518675127a1a576afe7a3871f478786125ebc0c25a3c806f1f5e79aa4b4bd512d64cde93288496fe27523214a46c1ad1ebbe7a4688cc7e3ad51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2F2e72b422716438dFf6712E4D069A574f7B15af",
        "signature": "0xb00e26a8eabcdcef0fc8f397a824ddb67e544aa9d49e9668536f9e99aafaa9de20c5f08732053fad196c50dbd7d92fe5df5c510e935e0a232a24093cdb9efb151c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0033059d6C58953F2E38bF7fa59D64c03B3cEfC3",
        "signature": "0x3a0d3c8360afe5289418ad78e8f24d3d86873a19e34716097166e2067bf619b87229316276a79aa1f69a01347d439fe56087447cc00e71a09221842a2238ece21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xacB30288990222173B011bc7410b1B066897bee2",
        "signature": "0xe8895c04fd746b5dfc1746c161a1436d92479ecb35ae09258a3b340b4af4353e305b6d7accb6f5e663f57e86bbe21ee201c0bd35389bdab47f0ed2fcb94fc8df1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA1D528F09488320CaC33D0C6fCd4FF2854BbF43A",
        "signature": "0x9535735907af8763bff1fb9bcfbf0fff52f361af28005d8f9fad597988ceaff83ee1835df23dc56546c9d202c9521f78e7562045127b344d140adf32de5643161b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x95a01C05bd08Ba492DF594828B4aF3ad789f7c33",
        "signature": "0x192368d2045bcea76e6f2a0cc4b092243dca1396aab4cb529f8afe2d3903f6e934ec432d8df35e18aa8b38a8c7d1889bf5508e08a6ad8613dd430c7d13a4db7e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x233b75f42960d51c4B21d2fA31448CB27987f1b0",
        "signature": "0x642c85994ee982f8c0c70168400135e9f57a2a58f583a21afdb4488c1c38ef652cc0e3264df65095994378aec7418dda08c9e972ec7149c9ac12c44e232016781c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB08d6d0B06d3eDe0bC68Ab5f4c881a2370C341d7",
        "signature": "0x6490951f115bc794a9e9f942a42d83c1a793a612a5abf0d12b3480d5da14de34154ddfb13520fa26c7cb244b801f64600531397bc1f3035e58153118497d297e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x04e2D5DFC1AB526A2C1c50fbAEfe162f76bbBA6f",
        "signature": "0xc9e289640ba90315014351d5876bd71097715705ddab97fe81fbba188fc335101157b6984dbf79319378f179483d1d4c73d376ada01f23a6decbaf4fe67dce071c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x49e58b756CA124cb9eA7054Aa30dF0AcbF45395e",
        "signature": "0xd7714586d443c549a5773ccf0ec12021aa7c15e8bc0828251f95e3f2a341743871a0137051d8998597ed96f966bcc4214e566e8919ae798f1d544acf3b6b9d3c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x998baADafDdFb6BE016057aD33e282Ef30939Fc1",
        "signature": "0xde94c6d5c23894d11e8823c9ef0c0875613d14fef5bff67a3362bc236d39e52a2bfc56f33263b0ce4fac66861d2f05b73a9de533251461b0dc6434a79d6b64511b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x692eBFD368225466a46863edF2da9F7A3A31876D",
        "signature": "0x5326d85913ff9e30b30628d9cf71f38a7484ca39c3ace3c59eca0b136f1dba1e4106335712b9370d980ae33a285b408b974583c7d41b2f871e12a39c3f2df9681b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2B3147A215630ec9F22344CA19944A9ec5Cd4158",
        "signature": "0x81a0a5ccb4278500ba62f6289d4885e25381457b0c4ec1b38265b7f294d417f8754fe4f1efb3d2e4d14b7f712b665bee05f49fe1284853d00fd31a95063ec2591c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1295591e3b90503998624AaEea0B712F512CFb1A",
        "signature": "0x04752a40dcd4b0aa7878331f257f110ff3f33f17d3cec344c047846f0a1b4b6368c6483d9899724868dda835695451a0d684874863f054a1bbf565df282ad2dd1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x23B2dB97a311F69e1caf7e684b4ca9Ca86f1eF22",
        "signature": "0xed5ea227af48efed28c1ddf84546ab6be971459ea1001cb03b7a001b0358624310c9bc2ebf5052b532e6939edc012827e2d000c6f6a9ec1c6827b26b8ace63331c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xFF7eFafEef45d0Dd8a71E82a3607D9484B7DB41d",
        "signature": "0x109f6e26b19dfe56f32478813fcfc6d345f4066180e0ef38be69a23ff3e5bbdc1e51c64504f6442a4417f5f5bd4a30c53dc36540fe1bf7d435e195f2c05413881c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5f914043081d7F65490B95654a619111568824c5",
        "signature": "0x47da489d4dabebef5816cc31b819d46f9dc30555e474550a930ab7e56f964a2a2ce1c15a5d015f4cff0e71852d9adc0244f1a2e19c91edb292e7bf2377c9c5df1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x35ad18Af51d1d0efceA7b71461b497ca83167BA9",
        "signature": "0x78ddfa22c3d3ecf291c3859f05e70f919f3b75e1a73b1782a8eecd6a7e56a9cb31fc4ec94ab0f17418809d57bf15b533c3cfed74e12e2fc118f13f7c50d9e21b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x74B6811fF026d108ba3864f092DAbB026228e3b3",
        "signature": "0x4c73f5a1328a381dd193efd3c7f69b5bb506500a937171ffba9da49538b51e3d16c1a48da4f50d800ccfba96a31b55c562c2d87d232ce78148220797bc37da3b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x95Ea5888AF3c7b31f64388182Bea0946a7351b7a",
        "signature": "0xa95bd2380b0e63a727448ba23de60574313927aa832c0270ab0a6647316c7dc375b55df6654b905214e323c0e4acb62e6c91c3913f4ac89ef5191b6ba8d6c2f61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1A62b88EA0C40E22f8621Ef55C78e285A59ffA25",
        "signature": "0xbff5b1a8ec7a27d80b46d3948074610c1aa1e9b0000cd50e6228115418c5cfc56afffd4427070620eb5f355ae2a145b721aaa87fb6f0c1a4ca934c7e41d8eca21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7cD23942d2f965e83189148735b3d5227B7Cb3fC",
        "signature": "0x557a4551f14446ac323eb6ab8707107dca24e1c79a8f25890f8325ab3a92112419756f700fe069b4fac033e5e68f361b8cfe0c98e88cf1e46335e7a9f0f1df1c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x40615AdAd65099389dEc3812A3761d40F881FC65",
        "signature": "0x88419619e1bb8cf2f7ebf7bcd5e2906dedec7398a16ece6d7f4b0fa0743fb2fc5f9bb9ff2788b39abe91128e355ce6d39bc0cdfdb5acc87d0c068c2795d14b641c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd90393500B11B1c77fE6Ff068FbdCABB7408BC0c",
        "signature": "0x8021281921fe6ccec102862c8ff982cbde1685691c20452e5dffd3c4303632935766850c425dc2c9b6dc398531dbbe42f9a5f39c17bb76de99f05b3e5867aa0b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x00C5A010890ac216C3A9E5bd3595bC82763f55F8",
        "signature": "0x0e28330b74dcb99db21b0b49776d9ec2c5af0412fd6a07747c1d6dabd8c2acc751e48c33c087e306a339556703b0b91d1edddb8abc11afe5bae7cc19c7b58b671c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0fb7f9eb8E9bEE4DD70Dc334B94Dee2621a32FB3",
        "signature": "0x5c0f5d30c1d8c22c9c981f9cd4549c1eeaf559b15066705f775c382b11a89869667ce041e8f381fb0e739c6fb2935a72b2e66d16414683bd0a6f45d1873349491b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf223AfcaB2707aFD21BD1690B2459A737859A3c4",
        "signature": "0x7e9d7180065b4bf34725e473d4e4ef63d642395914125748366f5bea218c456822190c854cf86fef987a290b84a7bd0067a514b2eddfaa28aacf661f73e16d8b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x838E6632956CDfa7Bd5d34797bb5F2f023A21D3e",
        "signature": "0x8f5069a051545654d26889999f6ded48b51e758214ffbe6074819248c9c5fcc84f4028798cfcc038e8409f425209f60a5a2f0c7e78404ed1750d926db886fd781c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x92e4e6B041EEcE7333c899b2D9E3BcDde15e1483",
        "signature": "0x8ccd21314e6dbbc80ff506d9e251109724fce195e972b7a7d4763c3728639f10344e98a03fe1f7751bb431c7410e0390817d3cd68fa25c54360a049787734d851c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x66688588Bcf4733e784484dD2543b026B24A760b",
        "signature": "0x23a96714baf5d447c134f9c5cdf1cdcbe8ee0dd93cda9b2b0b1c267fb4919afe21de4180d4abc2f0a1e03eb059da8eaace957a132502ee43a2a9cb3dcb222be91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF786f76Acb23019Dd1B5e5a4AC2F1F3069179582",
        "signature": "0x91f8d2431583f2ea1e0affb2403dadc440afbcdde74157beda5c263cbff0ea8a12cde3c06fcb0daae3b9bab777e68622c07567d732f2b118ed8cb4f19e4d06811b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDb8f118Ea457Ee10e484a8628239AC0B890C8de2",
        "signature": "0x88c8a87536d30475f4e1a5e21ecc7545155d2295063d3bae1f87c7f6d38e96ea06dee4308faabe20201f032ce57bd128039ae9dfa7e415e739ce33b0c468139b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2E36e6a657556c2fd841DbE09De2a91694399BD4",
        "signature": "0xd45c55758a9df67f70f601c582e24053fe0eaf07763c5320af2ab09aac5c519b2853c3f1a6e897fb923870b9d3ff64afddd44b67f2a6d31c4be7945c41bb5a911c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x84679C195239c58A2dC9068f67A74B5d334A2B87",
        "signature": "0xc9563eb42e3c66b66d812c1d9b136628246b04fc67a1409bc06b649ebaac44792b7ee737d51658f7d48248898137ffceef2c2c48a8cc17e8fcacbc58d977384e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x09564716E12eB2ca51f64d07d76AA88b7CDC0283",
        "signature": "0x25ab851cbe89719b63ea9a0e421ae1427b990d595e5fb7d7abf110857ff8af8462dbc2e42f621b37a82cbcaae6901444f28d6e4852de484338f3dbd7eb0eff2d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF990e533C8D87d2f1E803B4D6D045898CeF0D15f",
        "signature": "0xc96e65599b395e159ae6c3da21c9036f6433c89af3cdf082ffaf1cf0b0f61b9b5319203d4f55a8bf6222b1044ca1c7fbb5b56d627dd46f97da8eafa45059de691b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA1B683BFaC080C3791b561C4dEF51CE18D8Df335",
        "signature": "0xe8096c8f4e083cf18af6d468a193c0f4e57b02784378c016273b6c69b7073c7a52ce57544a2956ef10f679ce9b0605dac96a0c7f69842623e9f8bd31d30d47471b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x81C504aef6A2bdF0501953B187599DFFC22f7d0c",
        "signature": "0xe17b5677311b9f8e0c9a331dbe242a667ef75baa5067f75330e41aae508bb1b023fedaafe2ba6f96e0aa2f10ffcd74ab5de57b43dd17ac3ec3f1834cdc0587371c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7a59B14a970D3472C00a427ac8fBD01f566e028b",
        "signature": "0x315a9c4035474e1b2d7bc4eb404e8a9ccb6c29474196c7e3d37430d82b4d47d258d423de345dc4cdd9f1c8d3ae92049784adb371a104eead288e1a80f9478d231c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x082639c1EC982e75b758b1475CA27D397187c579",
        "signature": "0x7776d0c462d0f992661fdf82794ea9845393af5596d0379bd0eed6f1f42efc547804ea3ce44370dacc63c5655a81846a0c2f7eace7c2a9ec47f0c2aba56c0a6b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC99997B78d661279BaFdBC8183e66A590E3b62b3",
        "signature": "0x5561c53325e9712d016df290448f1aee3a6351b0ac66e0fc0076610cf1b310957bae2e4464ed9db305caad2ef3d3f5fa8dd16b0151ad0fb72d59d5d15ddc74cb1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x167fD04f4E0d7273D0308d0248Ac5228587CBc56",
        "signature": "0xac20a2d9e48f7f1993daa2db4f326f1f2344ecb27a4ed2310fd62d04410aa6b7182da7e5c4bd472eaad1112836cc600e0bafa50af7f3cbe3568df9c17878cc291b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9f5547228c842171356a3CE1D97A98686f58a43E",
        "signature": "0xdf3e1b3846e01067a72c3105c20130541779bb06a027658631c92b770838ad171329d85c57218abca676937377bd3de4c3d30c88e5d69866e8699652b07c1aac1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5D73bD3edd5aa9D66B41108eE0F9d565a66d8ec3",
        "signature": "0xbc01c2ab7a51316be70f3cbc8d5cb2a6b79c6e15c3b2663dd942deb59be579802d6d70f2221d00698c4a14d550d84d02f1d5d3f92fe5740e04e5317028f8dd761b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd574C76cbe3f52daf64939DA79689AeDF517c11b",
        "signature": "0xabc51bd2d2ee3d5e18e618a73762170011c289c35675b6186486fe32da42580477d13d136d8d0e13f5145c64336a0ba88a33331689fd315e975bfc78d9b6af651c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x936374E301C92E0C9A05B8b4dAF06fAC2adC10b0",
        "signature": "0xb3673bec6bb9f731697cb4549e801a0a743fde4ce96ce338cb0354b256dfa0177ac2105185fd0605a82c8bf38c0f1451f778b6f839f9215b242319a56b8ca1d01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2A69Cf9CA3Ad553330d5A0ba412fF74F7FC8372e",
        "signature": "0xfd5a368856706b1ba196eaf9e622f59648f82d2815b38189399deb8dc21e7f960e3b33477a62dce9f7786ad604a7be967b0cc35d4038fb31c36a8e930a3675b01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd42c2D9d5e514f088620C670B90d56E7Fb6D2211",
        "signature": "0xc6c1f7e51ad0be0e4f8396ef3b4ad1f77544520289c1ed0fa097ea676632fbb5727494af7a2979829aef634ea4efa1fa77bf4a5a546775c732771892288fe3231b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x47b98E6479324b8eaff456714F3a45cAD547966D",
        "signature": "0xaf887cf73f4897953e0c1c5cce3196dbd8908dc7f434050cab0e772e7e4351d07b07afef4c53d2dc1fe72d2b3e7a4175e543a85dc1954b7f08ceac81f78404061c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xCE63899D1D6a8BE7fA65eb9eEa9b5a61B10A1cCD",
        "signature": "0xdb0bfe787b20045be08c50fec07b15ed18de4373944ac6a9b5aedbbb80a19540459548745020280c098f9c16e4120c5bcb8ea97c465ff44fcbc2567e2eea28931c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3eed3E4d517bE644E4E362cA724244c14B48a264",
        "signature": "0x4d62c946db6ff1d64d7792ff8d6c8632a831a06455dfa3919b5b66733483983a00016192c353dc17e640caa22fafa0292c5e5ee3bb93c5b5bd23847074a4ca131c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB347130C15c7CE8c889EaBBFad435dceE82F5b05",
        "signature": "0x3e5f2500005ea030337bc7b6ac89ae426cdc059c6477a816c4036730cd3f2aba273903c661607e835860165072355c2ecbb214dec3c48254699b8c0828b712011b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1B044c8740c690294C4Bc986A191d8192A5518FB",
        "signature": "0xd6581016ae83e68f2d4f577ece2a26ba950cf53d46479250e9081b088c1781b8627b0c892fb5399765a1699db2b269f2ec2a78ef4ff79e09b196de1bcde66a021b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x87f8063AF1bB5F0323Facbf0cA6D25a8A75544a8",
        "signature": "0x3d5e05e4d81d26f158a2cb1572b5795216be24bb33a34cc4362c570e594d2f6b21fdca0e399c3eaf4f5443d1c4bf94cf370066fcfdf4c6bf20603f0d35167ae41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3d356cb4B31A3dd066b67B413EbEF1a26786DC7a",
        "signature": "0xd591f0131cb2c34543ed35a6fe6e76777a4a20995892c5790769818bce5648d92885c4f2e1e53abc0817923f003d27c78a72187355ccd828e0d22a69f59e86d11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x27Dba55fC6b69914a3DA132249b6F3521A74fed8",
        "signature": "0x34e5c7a644275f425a5a7a54390e868f26d6ed26ea11e81e34094ba5a72586ba69d6429a9fe3046ec5f08eb01025c5b5c55db3f5e5887ce86c48d2f3f29432af1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x816B76b9da4f049F2E53dd345711869CcB459CCe",
        "signature": "0x1cd7afaf31810806548c4030a5bfd5429b263081301d30aba8a5af878cf6601f49eb63be7121a046e864ddf6a68d32a2de502c53e6f939a012dd046c090d8b601c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbCf3006EA5f3db359982bD2368cAa6173f4804c1",
        "signature": "0x34348947345d61f7c84413b6f7a3bcbc41d7da119158a70916cae29590ee879827a683ec306fc0f23bf7b2c6f28c3f6b789474e85bbeeb3d6c3699eeac621c961c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x66d3039Ea9319494a4439CC78C5f722f8F470A64",
        "signature": "0x7015f65d91b2aa2d2c9d7c25bd740de7b05aa825ba81e2bffbeed393513c86ed656c0e9de777004abfef2f63e0bc1a30e7c383377a946834cb46f4088f333ac21c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x61D6b0eaa00b2F5D8418bc3857cF097c7e04f221",
        "signature": "0xfd6cb4d40067b98452f3d12840b6d78861561aa0ffc0cce563111300b0a869a232b86c4853d86c8e6a1bb6e09b985588a02129bd29581ddef68ef1fc460dbc7c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB5AB21dF2A1178d417EA43a2A5ec8b376386bE3B",
        "signature": "0x3478313da65fde17e12d51c7aa53afa727ca83bddf60f65e1689bdff12db7835458c6c6c4de45527a49714a97ea2029e1242adbb0de951d24d5a829c05733d6b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF752Ab77f2de85Db8D5c59EB0e2289623E9E7884",
        "signature": "0x04baf1efaad621c4e27f8b1c2d870fe0a2a12ef550e8ed2429e3b344b5cb7d15460b8c0a6f0dee795d6e6aadc429adefe9225e6eae48200c448a8f0ff716f83f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3217721Fa081466497Aaa6f7178b928804C9ee2F",
        "signature": "0xe20b275272df9f40e15d9f1d295dff936f8c785a9d1c7b5c38bf03f50281ec6373f27621aaf55735d0623cc3ab438c6be7266a0897334664f9b76df1ebdc27de1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x09e87b4a7f11eB470196bE76dfc34f01989f906e",
        "signature": "0x763eeef44d4c0545f8399bf029f5296c263a1c88b8f886408933d214dffeb3594e466eec638137d0b2679a765caa280c9985f20f2785a4ff5ae5625127d168341b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xDF6B27a3700e4333796d96bd271D19fDFcD3106B",
        "signature": "0x99a5ea3a2420262299fb2844e949fc9df4312bbfdf210c82eb6062d84defd6a960a75d1769e2e660e761234f79ea3d2e1269e6ceb040de3e2671be9e525e4d5f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBD69b2851d03832dB2aC269a9E0cA56d8dc8AE87",
        "signature": "0x891950bb2ce41d460a355badf826ce0228514622a095928476ccfb18852efcd71e85f33564e38234bd2ab1315585d143eab5c7cc076b5e41a03913c550c0a73e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5fa91d43388C0fbe1714306535A06adfd27dA0D1",
        "signature": "0x204d78c9ccca186966d6a594cd44ba7e140ce48064353f08b55838af627da4f54cdeb4653368b24d23f3694234d336474394315fec1339401876cdd90758c3db1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6d30BFA2e47d479a33e8B365F18a9ecCa6520e30",
        "signature": "0x745ca090796b0fcc023410871edda4e19c944b7d2d1545c11624da8caeeaae67303b9181d04cdfda2a7b82304fe76d59024887e5f72b1912a311f2f73b5da8db1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6efAA78765aEe714d8d2FC1f03a99F0258a5E8AE",
        "signature": "0x682f455861c5a2f64fee8bdba6df468374b9fbb2157c73e0e3bdd0362212f1743ad0b5f2292d63112d3c9d5d233d015a0fa429b22453b6a6fa5e042457a1bb211b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x837B6B3c5da2128f6563A7ABF2F4FD6E20Ce1536",
        "signature": "0xda7bf89e99ac7a1b01c655ec2f04f2c8dab07c76d9668e290361a73fd2b77d7c4686e143e7f9ceb9dcd5b43b5974555be48e285c40ce9d8bfc6522e6f7c7cfa21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0204d7247CCa739F4B8d566DFC39b7f345a24c5C",
        "signature": "0x63265ca46660e95d3bf43a086bfb8950efa8f8034c7f678d3c89547f8b1ec48d11d02dc2a1a0a4fccd61f758f654db604d9baf79da1c27055c7c8905e43953491c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE316cB8Dbb22D55590D47ee6672EEec47a727E53",
        "signature": "0xa59b61700637b8a48208a33208e1663c82c12c6d43129f41c3d22efd239d93fb532e2888ad783884b5d67bb2c0bac6e704816f57e335a1e739b0f5e9fb1c586b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            2,
            0,
            0,
            0
        ],
        "address": "0xbF48d90c5F96586C250392B84636796ec15F9E6a",
        "signature": "0xea958e86185f0dfed9b593fd5d5bc19a710c69df8581982fdb9f8755f8ec1ea31a8666ddfe942b8ca69bd976db642d9990d8b14b4e7a8b5f37a92e0713d603081c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4D1Def3d32A152eDF7A389dc81e2777cb70241E8",
        "signature": "0x5cc0bc1cdc393f490c1fe74493f22e89405ebf728e8452128b6a0f221febc6ee47dc8bb4a1be4a710d6c8cf84e86d84e13936ae821fb82b9de506a67bd4b3d281b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x294a608977b2a78F489d2405299Ba4e440a51477",
        "signature": "0xb69e2cdb70d78f7bcfb6c7d83b97a7c240004df3c50c7447ccea9f2b455ca91547346c75f8be78d1aea078078e8d8952d949d6bc74f9c6ad54f5df6c7a22ec591c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE21DC18513e3e68a52F9fcDaCfD56948d43a11c6",
        "signature": "0x236f0a9c3b6a69eb6e1c34cbcb0f4c29318aa3d664211deac24b4058b2372f94796ccb5c5c8b7b8f62c160ba66cbd4fc106901718c63cbe98421ab8ccc2743b71b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x53a14473bd5E3fa5901Bc50B60B50aA0aa2e2297",
        "signature": "0xe9881c0f3ad2f651b224199a1fcfd6410fcb44febe011e58680e25a78d43386d2fa2dc291656983f5ec938369d06450faec35f61078aed20bbc53eba3de236e01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb0f5E755ba909A6e113Ca5c6b200c5093FE51208",
        "signature": "0xc0cb6cb39a378ef7d2dc5c4926a6df003f1183f00c796541f6d2865f916fd8974efee880a818e3e904d657a4d94aa2460895244dacd4fcedcc9f180b1611f6611c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x351836B70969CDBf0c4099F9132F047c3B055275",
        "signature": "0x325681b649225f34dd46ae0b64a93b99657086dc630b0de657102732b3c36e3e23877e4eab97c003aeae09a8072535c7e0c454650daabefbe019fae524fd4f3f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4e3C07f4632f07B9822ED8D1d220a15C7e02F3f0",
        "signature": "0x04e6ba2937fc6306aa7adc6e72eb502d246e8e40f57a3fde580970e1d77a86ad7e9b340dc29e19fed59e7f1dc1249b0f0c8f17ba9a74187fbd942cf43920cff91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0A526B6089cE249f24e4CB6EDc5e748fc3Be8752",
        "signature": "0x5a5206ea3608851c8a3ef94e61408b20452cc9da443b975878c0e67eff38de8b29d5b9fbe5a32bb34c70b4cb386861a406034b952ec92f3bfc057227f7b1a2731c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9b0aD5f28D54ffFc5ce74872cEE95FAfF85e0F89",
        "signature": "0x8d5a224cd188ba635b01c18501e7dc9e3dec4b9712e69b2b91d4976f335d2dc3248e3c2c115f520dfbad574cbfc56390a1121b02e6cc156ea1d6b4311c84ae291b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe85064fe1b1Ed77dC6c68a8E2223cBeeFBe7F2a5",
        "signature": "0xc767181ce926abeebf833ae296d658057284088df862ff28c495c45b4d1194193e2aeb967dcbc5023eac63e8a6b1b9b0e2266aad5f315287bd3a0507fd89e0511c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            6,
            0,
            0,
            0
        ],
        "address": "0xeC1b4BD23dd625f6D586b1e7E97935C4Bd5047ec",
        "signature": "0xc858d9b8d3c9bc936588691f57f9174fbf01b6d55ea69ef9f7dd65f4eb80f2286b770eded3ea32bf608d533924c7d95af75a6b6056e546c702df7c6337fbefac1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB899142291bA27C0c5A555F10389838262Ad2685",
        "signature": "0x8f0ef32702f6db626a51a023872e4e21a7787a63d055094eb3408ba01d5e9be32e8e57b33d9f584329d77c4e11e6733eefeda13ac16636045b5370c16c7cadfc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc9C76646606867b10a903A7b0E51e5e0166e211d",
        "signature": "0x3cdb119e87d8002e383c21fedb022b9bc6f3aa438ecc56bda5300fdf83bca53b5cddb787345162ca6cfff096a8b76450dfe15c7c8060ddb86c5d74981e150a1b1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdcB2b81480f2b63a37aCE42CF9227ca358a31bF8",
        "signature": "0x85cdc520f8383ecee6617c3fe60d8f4611ff8db60d562f4a0039dcd63760c5af647bbe465afeedd3d88408eb1da9673dd12608614139089f40d7d501eced7dc41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x185F2BA0288D00e8bc728B5fcBec186C48ADC046",
        "signature": "0xd5f5fb8ab5f03b6f2307aa85ba4cf2bcf9a71a97cacbbaa22fcf6d8cad2f46ef3ce7e6b52070e9e60f0645c16da5bad2d9a2c521cbb9c8321a7b7a4bb87af9fa1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7FE9b3073DD6cC6Fd1ecAd0655CCC892903D163b",
        "signature": "0xcc4bdb22b6eeeace81220ac5a2ceb9885d2a0239ada4224c8d81e630933ba6b070d968b796da9afef545f0d44719b95e8b232e4993cb6427014d3142901f4b4a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x21427FC897d0E1b0CE3331304d0770B11363F3f8",
        "signature": "0x8dadb756b5068c4a42fe444a6a22354825fb2e80132f5a08be21796b17aa00de1ecdb1349ee95d75e96c56b77a919497f2d02c55b16c14457bc02cf6966d49951b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE856359F43b046F5AE1A239Ed9DCFcB2E5667aa1",
        "signature": "0x2d66a02ae28de678644cdb281d33d27bce8efcc32eaeffa3a2b8f8b17b803fdc5e1ed8ca49b7782590995549cc4e21b989cb1532de0b22351f55423bfc5969461c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe373d0C2D5B17fd9aF015967A79b4ba95397744F",
        "signature": "0xd90a6a22135da654f5f31ada393a2390ccb5fb670f621f119863b5d1313ff58f2552f18d4e86dc69538e0856029567d2d2096421e9dcb90342c017a920a11b341b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF0B3a7d262483b5F89A4fe568DbC78EBFAf5F688",
        "signature": "0xe721d66a09b6cf4ec6ebd57bfe2299c9cf2963db4bd74fe29629333bb4f9a41b483ff3380927a6c9dd0d1a283efa6296d6ba1df96d119f81803bf7caed84b8601b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xeD88bA781fdf9D8412cbbC817b6B780e5649c85B",
        "signature": "0x8692c08724d8d8423d4d12b938c53976c00e6f81a82f979d41ebd6748347d4ed7f23191ac969ab9e858cababda1ec1cbb8a9928d5e1621edc65a862325b1dfe01b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8633f3068F65599891E2D815E99A49c758323232",
        "signature": "0x5ac94a50098690a5b2aba78e5330098e39421e2d3dee76dcbb12d2ac02e2e98d0bbb18f07e2f011c687b9bbf1bd6157e7587faff214b8e14372885c4bb5103481c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF0b83F1E549BDd85c8aB87303341EF74d5748caC",
        "signature": "0xc49145453788bf722d3702bb6981f8250b9957495b493bb9d21af74a6cf3b14e10ac8c320c1c896cdf81d3f3496ed1aff0e23a16175a334bcd2355588c83a0f31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8D59775e9b73E2eD1e9beD834818D8A3caA2740E",
        "signature": "0xa12b710a9c6e7b9bd9ee69e3bc0ddff44bd30678214d9784e2c8f84d023be2f80f8a6d2b3d5137b2102955e0761deeba0e1134d0478c63363168489fd6dcbe701c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0B5e8D60C4E3DC69d9D5B531afd1b4245F8bb87B",
        "signature": "0x171455f1f23709b16eda52bc7d71f56171e1917947ed2b2644d406c09fd4c6dc78c5678940e121b465976af306b415cc68cea2a9ab28cffc68094f4beb6a80b51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4F016596434aC199bD5D0D462383890c1473141d",
        "signature": "0x4daf993899310c501acc499958eb8f774b2280581c170a46f9ee7f238d198e5f266b5248b15c96c4fa3034a0125a70addd7ea8f5dbfc3aab9b085c1e9a7c37291b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbF229844e1ce38da07ebAAdcB6aFA8A0BAB011BC",
        "signature": "0x21c3c5fa3c3f7a8576cc5c48bd0d9b2689ed9883c2f1810005cd9dbee398ef6b011ac813db00f9d1d7126c5c0caf6b3d58f5ae45344469c0c120609fb735819f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x36067202dbd58383a4712cf38968aDB387f6DcB9",
        "signature": "0xc05d7389f6d80c3bc623e821fa2633ad16cd7711d9241c16b3a99f37d6f7ab29407c74bbf54e71a3c87602ac47cbb0724d204b03fb9b439a3bf5f654a5d2e36a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0x32d4a49219d995e3371b2695B35FF43b7Ee064CF",
        "signature": "0x6eeab03a7df91af1f46621d774152f7bef679cd2ae554faf1bcc35486024906369125cb39c847ef669a6ac60df66e7980787b563cff5dff9b11f396b6c2725461b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x725B42596383B4cfD590b70D70808E4e345C6fC7",
        "signature": "0x9eea4602ae2724932e13475c4a37b0a41da36382841c2c3b23900327d66cc3e852d627df8d8e6c13daca900c3bf7be72b914e0dd1172e6f16df7f2d0ecb9bd721b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4E613D6Ab29892cD14544Dc600b5Cc301F371E20",
        "signature": "0xbdae69ae3a44249a63ccc1fec039bacee25874b808326bb73e5476a3eae60ec625a04e19edfc9c827fadb1819646af4dff5d3a293f1820758ce17d8bf58e90191b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            0,
            0
        ],
        "address": "0xCcE5a757F68b702B7e1a11D27A901381a551097D",
        "signature": "0x8ac58dcef8dbc71c84e9e09eec41f30365e9ec71dfbc86f6219b5e45d6e4f2c933b4fb9e06388abc91fd566bbd6d2e68d36539cfb1f054d0ff385f07e6f5550b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2fa21718a246d20888dcf6a75220923f6b695859",
        "signature": "0x0b0e01a726460a4f915ad5e5c001cb846eae9427714169e066a0a56070ebb23c35e0e0877d0803dff7517608be5d8785643706981f5ca5793a1e896294a489371b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x02099324B78479A70E7DF394710fea6c374080bb",
        "signature": "0x9ef4a97d501e38d464af8666a5359b234c5f9813ddd7bdfeb42e4bf3a8a488dd60852fc8a2d160ef8f41a38be705cccad39b176090a13126b4c6612db9add8e21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1f89d8F49AfbBc7d9eD5Bf4863E76f218FFc92f1",
        "signature": "0x92e90252925a110b3fc805a88defd0e67fc7708031a5bccfc94dd56d20abfe1e58e2e24c46a6efad1a410425519aa258e5bffb9755cec23ad79892da145283b81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x78430233AE408Cf7eDcaaC8aE3919CBDC4c831ad",
        "signature": "0x446098b5d698cfff665f370574b1c1b8d7d5072462b530bc8c18c091ae85626b78c05f212bd340884adc93b3b2ff06cc9b3447fd15412d8df96dc8cbe8d212de1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x39f4d4aB3353a775e0a174ab4Bc61D441Dc72B08",
        "signature": "0xc7584667d83c52b44140cda0f2fdf8bd2ee5ebf9a741b3a4bcb78aad1eefd6f51da184c2d9b9be38b1f3de59ed8f45e25165ecab6e10983b578665e46be5cc5c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3eB46eb775B8d28dba6cd8196eadB894EbCB4284",
        "signature": "0x75dfae211c68008f79ca7dcb14cc7dd1a130864b617c6f1b3e686aab02ef00e45d0b82e804c8e820e7055d3e48437bdbd083d0f0075a1a1a7717e253d5d6d8f11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0509CD40B6ca5B3ff2fD186fcA1D97772135e1Dd",
        "signature": "0x0a6850eb1aee2fed6a36e4cc89a2aeceb492203a44c7ae1bb8b5e0c715a962037dfabd82d37253833682200be863d84a7355430a5bba1e4986c2a984cc9f7dcd1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC1c4ef1E686275ED1fD2dfD368B3d31e810424f0",
        "signature": "0x872ed9de524c1d73c6760a7ed4f7edc806275057df5dd8488e2ae94a7d2b5cb7794dbc42bd203aeb49671fd7053fa25b864ca8840fe58b005f12672d44d58c851c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB67A73B69A13B26d079af5EEFAA40F8Ad0bA7adC",
        "signature": "0xd65077257b517f1be03c27a310d1400f01eb39f0796aa0a729f60da1c5df4c016454db56b1f233c5db363dc0a48ac499a3a8193c6d832b51db04f94e40a132851c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4327d58C0d892cbEcFC0A90935844eEF31aA8409",
        "signature": "0x40a5d1f3d8e05faaafe08406a197d7be12601e17b3fafd235c73bac559451d967c0b7ed867ff75134246749b3d8dfa24c895fb68118ce0533cf859fe9cbbf74c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdB25BcEbd5b2eB0AF2736b6Acb7E94896231f907",
        "signature": "0x6b599cc2062adba7b829c5938f7b8c366e03aad43f09608a8ef4fb4911afd3702d006c064a3489455f2cae3e65015769ec5749adb48381560fe4803159883b721b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x99b7b9052073A938D4D54E2fBf53baDCA876070E",
        "signature": "0xdab35d4b3bd3df56f90c467b20369bb3a7b6c4fdd9929a100b737a181726892a6f091aa1a82ef03cede75dfdd2eb6dfad3051d8ca31692d60f11ccdab9df8c701c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xba4D704b24aeB2446b6Dca2123D06f15Ef998E17",
        "signature": "0x4e98ffb905f191dd0105c932aa82e512bdd91a4cd4be81938cb1545302e212bd264aa219f5618781a0a83c9d231bbc695bcba614b5c7467a5f26090da077a0df1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x533702eE3E322d2F5E2619A24e6ef46255f51c1b",
        "signature": "0xec594c7a54c476d14cf2a2038497a92901a3516857e41afaa887c1430241fc63355c95b2027ba813593a4fc3d9544bc71b8e48111ec503e711eed4861b1a69d41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x00aAb4Ed51ADcb851f3bC4Cbd47107e534206ba7",
        "signature": "0x480020cc6159f46a3fcc50fd75b2477ca42e11fd451e64fb751a0b653326cb607b7b70dadd6b2af8bb59eaeeb2c246b1d0a245a1173ea9e7a5749debf3c2a3401b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA6A89F4E75F91E6Fe6C07227FCC5186620ABB319",
        "signature": "0xc83b957de12523349cc1683530f3ba96fd1d5e821822008483091e1aaed9ad925812b4ff64625cf7c1ac716cd3b76ee3eefdabb4e33af2bc82751781299cf21f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7606CbD8F3aCDae088b1481234b180580a54382B",
        "signature": "0x052a0cd0150e5cefb3b28764d81323e2c32b7ecf0af712905de8e6c3c41fc702062ec768481dfaf9fcd00f0e17e5f2877daf64b2e7dca556ffb5075d8842b3f11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xA6635563d274d5627A1df858167611Af1B116Ce1",
        "signature": "0x8bac5ff0970f6ad88d09760bed28f93f9162fb87ad831a77c91a3c8ab8cd337e4963a963fcfc8bab2e6745b1798647f0d21ef692486376530e34473a0cbd4ad61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1ce2d17CB3D3659f84F6D8b0114E87A757075b53",
        "signature": "0x1f7460ee91294ea60a9bf695be83ee7acf5b8b82b7b5e5ff0f1d7f5b6a01db364335771899bcca8c4134c4ec3d89d01337fb618dfd7a400c4d632c364aef58e91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2474882334c81bA397a1caEf329b5F1177A146d2",
        "signature": "0x9e1a93f100f6f5b7d5e292213e8e127ba0d39869dc26988f04852ec84db93c1b00c2da82845f6ef945ea20b28da62a49270af8d8a8989b550c46bdf9257039081c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB68982F7E7Bfc28434573f6DD808A4606c4c4593",
        "signature": "0xeeb1c6cf7f2a5fa056d4b8f5ea33141d904c9980c40e7a0b1f2b8c26a38e27af09bb52b6aec68f88885728f006e051fb46e74ef89ddcd6ef7a55a46bbf68b47a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0AD641d57f67e5F4DaB21b21952e9D5Cb72F80c4",
        "signature": "0x4a795d24f533571e562790b5596296d17e3f0cc3ca06aab445b2c6274638d5461dcc5777fbb49b212c300b1069cd9205bf149b0deb0a82acdf6a2bf384d9b5df1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8A983D4d4A49d79A13047D27C87dDB4FD7A161bE",
        "signature": "0xc79744423b77c16194691bede5b33ce6f00e9b31fb23e032670e7eca1f29f5920e949c7de2dd6f1919b5a5fd67cd27600fc6112b680663c3218e2eacee30c86c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2F45f6Ae5e415ec5E3aDC8B1d19EefAf1E72cBE8",
        "signature": "0x36af5ab625aa37efb783d64703d7a9cc4277149591e1ee4c6180c8201d1b06be5f94523d940aea5e0cb078f53c54e2d1d90e79178109f83fe1e7fa43e85e515e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x09fC3B71Ba6EeeE2A997a636E2a84F277B87C576",
        "signature": "0x53b004ff6a597e4bb61378bfd1c9af179279a00e2cd10811710cfa4189752884018a61c219dc76dc45722d5791d1ffbf83f6cadbb289cc37beb3acf55b2e31bc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbc32A28d3AaD003da1579e48C8913D41c441027f",
        "signature": "0x625d25380c1535221f5eb934d418f68dd3a518e26b5414d49cb066639e501785597066a9511572fd0f0d5ca44de14586dde66f357dfe3467e24b40bb40e59a7f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1510b13De7968b0204716716E3b4C00B98671b5a",
        "signature": "0x612e44bda958187c1bf946f2679d9c541644428f08eb05e516fa6159377c221e3e79e6e8663e0ee916c63488af73386d49abba0d8ccce786976ac32ac45c5cdb1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0e168F6C8ce381FfD012911962a0ab7410BF8350",
        "signature": "0xb0cf6a260e16329d8f258814eae807cd2e01a3bd5b1e6bd837a43a224fb6c4157216412f92ea7e9b6e6d7dd404b862dd458c3eb3ed18cf96a00fda8734fdac8d1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1b948558e188b55953f7E67eCB7990da12426f0c",
        "signature": "0x3211d94f8f65568278749a9d855ddfa183e31942b2a4007db0f8f6d8538618d65fecab316d61a3fc79623d70574cc8a22a49a8cceba51d7227fe0bfb16ed58ac1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd6363950f7A1d25A06b2B5AD20a58Db329023F1F",
        "signature": "0xce9e71927c8119d64c716b642e66a23f9f9b5f9df153ee234cfa5d81acc37a5a10d5dc19722973d50a0164396fe15c7125a6088a622fa6e0981d92f3c08064321c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3a26b7c977Af9fD8d35af9d54b11e05c4d598c1a",
        "signature": "0xb7b24c902d81e8eec41a750eede6aed90d1834f69025c13a4c08943b5dfd642a253ab989fdc9ceb1685c9ae8027821594c69bd87929481907760f2f830f291901b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8F140a8d47c4a29E4e2F99DCac705559D9C5340F",
        "signature": "0x375977cb629ee1092bfe6487018bde7367a63e64f956b89752bc6c2258fc18df4260addd0b5e73c033c2003830290e758e99ac83d08e71c9427aa47e8f79e5b21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB8A0F2425587DCa0364fEedb023Bc2FFbBf51637",
        "signature": "0x2121078767b42232e5c8e2cee2c374f4486a9cffda46771d61ca5c0a790242656ec8ebe744f7feaefbd6d6cb683b19298f6022c8e5684db96d83074696c031961b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x395e6F662734b620b406C516d7D3dB4b03845206",
        "signature": "0x68b7f1629f63691a75be6ff51f3cef337ecb68a1da284125b891919ff50180dd36f1cabc81a3e91b805e6242d94c6ecb1e61b32bdffd1aacbbdb6a1e1e172eb81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3111b4d24D7c12B330f6A49160263C41c1d50E62",
        "signature": "0x2ef86411df59a36daf788cc27f44f0178a4f2f4cc9c021cd99f2c264d36bdb620c0d21b4943f4ef9a1f0501eaec87531122ce3a8262797fec7c583c7d3f4df971b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3ae550cb3fC709a5206c269398330A3c8236214B",
        "signature": "0x0731a98457bd9e3387909cb79d60d44a85067ff0d366198d0d68198b944ffbaa51f83b129fda88aa4b5b515faa9e1c9a75dd7dabd3fd62016c19d2bcd347e53a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x60d94147b38953d1D97A74d3E9D45c8b067C00f6",
        "signature": "0xe53a2afef06bf38909029eb91a30a9327f758f5645f83ca8b68c1a82687fa4063bb7e0dcf7abfca4bf7a8b1384cac9b1561d4744f9b5b8e611bff08b6d04e9411b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xbA8beCCAE309f6B68CcE47D7e7821a8cbe2E3D14",
        "signature": "0xc5c4a2d00dcd5d0902271c364518c155bf4b862f289c961d03b205770d05faf52b8fa4bb455da2aec141f30971ac7101644fe76c04e08e396d44c715140ddce41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x63F265c2C427Cdc286e8cE94A94Cf7A5972d0d4d",
        "signature": "0x54e3739542a8d9098c4eaf6dd8bf1e3916759fcacbb03b307948f8b1b9846a832851021b6643194be77a456bc03548646e3853536241294102fada7bb9d17e221b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1C14D262730DB360b80aD877135DC76dBd5Cbd5B",
        "signature": "0x1af953fc47cbe9749a67fa7db5ef29083d0e9229e12f2d77795e5d6d99faba71141283cdf268934e04af19342cbd8dd452cafdd942ea4d3fa5d0407c07cb23ad1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf174A42042Ba013c535EB95c00dFF805f281cAC7",
        "signature": "0xcebb64669786849f6beb659b507eaf68a15362f8b913832f54b56b0a6c296f451748805fdc9a554d311865a4bfbe2e39e1a542f7f2166f2f9e9c19db9da6ecd31c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xAF93a436bea2E8C80a986497bFB34Cf94d1c5d4E",
        "signature": "0x1df7af6f59526f0db978b95e2f638f01b0fd5a4765d273616755ced095bb2f8a75a1105136977d140032f19b6d6b686a3c2cec3c1f125e20e7e149048bd7c9e61b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x71749B6833892294FD34aC0820cFD248aBd8890b",
        "signature": "0xbcf76e775066b1310f1a49f376229ca4c41b5ae236d45120cc5f1b16bced0b6e01a94511486d3967b55e30fa3f10541758989ef5db64c981a499dc95c9aa4ab91c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8CDA054c36562f4a0a3A77a7fb20B9d333D245b0",
        "signature": "0x3871b6e1e2bf8e9d6b80b2b819c02712e6ce98c0385701773b9e80b375dd8f2e4c7b630e080465488a760efd729e16fbe4b1bd9cfa3334fad8a4a4fbe29e838f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF1B9ffEE64536cE32BEA1DD2bCfF5c0978CD3341",
        "signature": "0x3a714df27dce0e406af01fc21ae1f748d90ddf5a53091e83efeef94e866a1a89615ea67700f4c17e2d3e8961f6272ddd353a42a5a3f8bd916689536971890a4d1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x554f3a1eb4F7AfBf58F0B3ef0D2e3C45Ad2C34f0",
        "signature": "0x93a1a7f6bdd97c235b8f3b6cda6caf5c743c97506818af8233bbfa1d5439ef9b6df3f79c37aa0647b4b83b60abf305292a21713c23fa65da21c0c98832d7988c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2d5112114AF641d8f5F057EDC5EB0F2A3Bc68d02",
        "signature": "0x6b5cc0c4f0e8bf2c98fff284025bc458fb049b3f831945b3dd8c6bef5073e8846985cb1d9499092a37ea1ec65d4abd8fb8fff25362360bf265719a6bf754df861c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xB208cFd2cB09aEC7BF5cdf2bCF40197712B8524F",
        "signature": "0x2960ab5f403362744ba3492647f19ad8d3f63490b3bf128fb9bdb5d3d4b897ba4ac4ae7a56406daa52a9af73184573d1653cc90e1ce1ffedac1ba2ebf7d8361a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7374804C4BbCf5f02f3066aF70e3e4b7D9aace17",
        "signature": "0x6ee34a129f5a2ef4c5b6b6b5a1c04ac3f96591b00dbdf8914207268eaf85156656d68143b57ce52debab0747104c48729b280728cbc39582a432fb64573b54f61c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd8d4fB960d7e0197cdc217D2A407722BC5Ea5136",
        "signature": "0x2ec3b7cc7ae1da19ed8d3d921916fc17bc1e9d08612445d1a59b90eeb330eb9331159c5c3e4856464eef7d5346a959319a38ce22881d5c5fe6bbe0ff6f39ad711b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xeb091CD2459Ac537FDe521eC43d18Cfa6a4158e5",
        "signature": "0x5b13bc488359afc0dc1e5400c84785bd64a815756489d1a747bb2bdd2990ba220bf862f103436175c0a3c22df61c9f31e8e8bcb65aa86bb6f50354e055d42f401c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE222da95Ef4E46846B30e10994CB47C4eB04A966",
        "signature": "0x17fa38484ab6eb3cc43dd9d0250c62093b50c12bdf1af64aa46a90de4d527a9a3da8d0ea85122ceccab65af08596b8f739d379d0b1720181fb66d60e62a041381c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2e9335c0999493A08231B1dcDCC8D468a292779F",
        "signature": "0x9b0fcd8d3960acb49d632ef5502ee82b955f705944769f713afa61236ed188112de6e7ed92cdbfe7e02d0c04e835bc7d5c9504c275ee05fb8e513fff7dd06ef31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc895B456ec3A05E04cD261fEF38Afc2f7d16C011",
        "signature": "0xd9a20c555b5d95da37dfe69bf408d4cde6b209088616b4cf700779c2a72f88e2575e1a2dc954e3ce22f41bc464a9eb083b2774ff80af1fdd5163bf359be88c311b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x82ac02EEd280035362D296E4e0256F913c45b1d0",
        "signature": "0xbd32aecd5b3f679cbf3f6419405f9f465bde906ba0cc69b8166664365f2245ee53d913416cd99e8f2365c3ec3e2189b03b99ee12ccc5f8f8b415143a2649c5461b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6D608ea4dE61F9A331D725749B7e283fbE7c534e",
        "signature": "0x810c020093e68722b8e73bee6935aff2ba236bffacb91f05de1d3fc2ca2f1fe822ea8f1f8eb4c48cf979707a9545f08c812a576ae8e83d2070d4e5fdb7371eb11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5307Bb0FF9749BC0d461d6D289eEC2edf9A86533",
        "signature": "0x6150036d5b630ae0c76a8767d079de3b24bc4d04717fbb00e66384e36d0aaba62d26f1364cc0cec8fbc8162e6d18c2a9404826c0eb757540e6a1e2bbfbaef3bc1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8eBeEE1d1dfd39a6DD4c3e49e875Eb37c43C5259",
        "signature": "0x227a661e39464cfd720f195b03d77d1742a5ea1b71c6e3a47f0e373d537946ac08e1939df6b130f4d5d06c7538042d5875b68c37b861186d81dbd2bfbce053f51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x68FDa55f4bafDd0617329A4fa6b3085077082337",
        "signature": "0x7d8ffd60731536963af834ba727d6b65a8f60a6cfa2aa130436ff8d553048555519ed780f42d9e0da44aa3ecc127e93ec31e91f17da940755b8011e619114ad51c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x903DcA3440408bDD00daFC72A48b773F69b9A2f8",
        "signature": "0x15005f04bc1c34b7924c42f67f0cce940a43b02878d2ffa4ac376cbcc2777b9576df550564509a6b4de799d2d9f307b92d17daff1bcbad5bc6559dffc6f772351b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfF5Dff3a7072b7FeCd60D1b406121707AC2B5Fa6",
        "signature": "0x276f2c910b824714ab5950830e583d3c4269a37d8c61248b9c6103ac6b09323e20d52edb2cfc2c43f85010afd226a4a2083e01bad01dabbda6b9db9fcafb5ee41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x29B1C184e93AB87768615F3f0ADa32fe9e855863",
        "signature": "0x59e5d72a6b048aea96228bc1815e5070a920535c786ab7637813838d5a79b5283b8d8dd0698122736efff292ff142607fadf5301b0f8918850294a67fd2580b91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe4938523A5fB5e0667724466cDFe5C4CD15B8Cfc",
        "signature": "0x6373e0b483fba7a277a96cf3635d6178eb012261777c2e474ffb1bea6265d7de2e02fea3f314d1238538d288c8e2eeb0814720b5d766a852ba877962e976b5fe1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x97FE10cf0Ad4eba030DB9D5f959D57270fE8D4d3",
        "signature": "0xd220ac69a089716f7ea6bb4710225f1844b7b7a9c95cb376ac6c6601996f30ce2b07a65dd82913e4175fa7808445c1eea2c603083189bbacf5a2b1c39ca379a91c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x14F1842AAB0219A3108BB40Da0E4F568Da871a0A",
        "signature": "0xb0d1e548435c70db2989e4dc6a69ded80611a4ada11c0e2484dc1c61914a7f0919dc6e8b820593416e8b7bcebf7ee20066178dad42a79da82687980362e58a651c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xb0224823197C30b8e3AEF158Be9f7c2f0155425E",
        "signature": "0x407ecd95b41bc8b37933c1678326ee05a3b12ea3110cc23640d52a86cb137ce420df471e3165add05b27f5ccdf106f125dea4182fdfa7afc713a054e6a4cbe0d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd1d40b85B97140B0860c121a83A7A03f394b41a9",
        "signature": "0xe46084f6750a5de4466ff3bca0734c241a4834b88f1c0d9d4a3ca0bcf9d939f01d86e9b8b557ca2c3a699d1411434e967ca50df8f5ec1c3c06992f9683306ad51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe3e3E34Ca7eFB7B6bd33A5B4408Fe6Eef3114d63",
        "signature": "0x5ae77ceaee533fb10bb42093ad6fe3530085642723ef3724667401705213857342d2139bee44e926e9e59b4dc4cabde75b79a3c5ea15cb878c61906dd1f425e31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xaB50DfA0f6cF8776Fab7a93025fb9AA93F831F29",
        "signature": "0xf0091bfd2b61f3b99c8c99fa709436e1871ff8d623d0cf80d5229c74e41af4ca2978fdac7a3d6d4772f2e87421c93ec4bdf33226b40f9bfb49588681abf44f6f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0c9dB09e94C16eEcF0E325b54cBBbAE647Ffc94a",
        "signature": "0x9b4add5a6fbfef86cd20ea299999e3e60d4a2a616d0cd836eb0aaad02afe98396671c449cd7f88b3d131d9b22b970dc390fa49d84e24012538300a06b672ed3e1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2b58e780F408b1cbA2b38Aa020Ad0Fcb2bF48e98",
        "signature": "0xd51cb40ac2fe68a664625ea7069d343b86c94b81acf766cfb9aba6803ddcbaf1367f2432b4c88596c2ec3fd6d8f654cec3d56a3d7e4994afc0a07df21859e6581b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            3,
            0,
            0,
            0
        ],
        "address": "0xCeCfe64E27DEA7F337dC2fc963eEd21d51730fAe",
        "signature": "0x6bb08e0c8359783060f3c930049c68b01c32013faa1413fc2f73ab7ca24af23b1b45121b3eb3faad798692c165005a404a108c02488b556cdfe84d0a6ba14db41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3e9f068Beb82A65DfE660c1161E4Eb5FFe75F807",
        "signature": "0x8bacf0c7475d25d56b39c4fa760484edaceabac448f15f3f799023c189a2b7e65f2a4e4c978f1e9e29ccba958fd37adcdba7eba5a7f792a189e208b533e6734e1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x41bf572ad11733cE1e0aA146535B2b4509A14081",
        "signature": "0x4b87c1f49da5163fbeb7806009c59665e900608ef07311160bd908417825bc5d07b33f56e0c68eca9d3cf8f2690c579d7c4cc38891cb157b3557b3c7cd59befa1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x2A0E201F1C275FACAc3C6D3bca4167bDE41BE908",
        "signature": "0x8dfcb72abfdd676db3ae65685e17f193db55d05cdba7a95c047b5fa8af3c1c2a47696fecfb79efe9206b8644085d2ff5e2b1695f3311ae726abc51e1b8bf42151b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xC40bf0B4a3a17cF78e34b37ad2aeC19bc9fD8375",
        "signature": "0x720566ae67c3880a648a5be094c2af560888ad10afceb5e7e99f48cd05ac9217141ed2a5982e30fe7920e53a30ba5e39703430776267a09fff1d664d3b7888281b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfc9825F6880339D8a2733c552Ea401AD9ef7B70A",
        "signature": "0xf4eb5800b08586388eabf5b3aac970e32da0e71a895155c3a9c65d258ee2de114ff44baaf4a4f9d424521278f32fb15e9cff156743b618fb761db0a818a0157a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x229104Ade4b771eAb6bED4b82aeFfD4853d9FaB8",
        "signature": "0x5e36c54751ff0741a0fc50d8fc5b7a927c9b2c6147d9590871d50cea2db5940d21e4459317801837ddf2d9575ae9638784e3398d828fb3c41c93a798eb20dc821c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe6104F0cCF388e2260715E15334b99DD245A2d2A",
        "signature": "0x00b4bd8f3b8e677020115d0a337e7cf8282c763d13bc5e5d052cad509c03e8c93511bcfaaa3bef33dd489ae7563ac882788b4610f9d303fd6d4f18a1421289a61b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8d6E88d2c873EB8641150d0Ea3228895CeA60D25",
        "signature": "0x4f15432a8d33f85cea08502b6388e7847edee23c65d255feea01c066ebd135262db0e35e33e0a6b4f450c530bb01cf44a68fe5012f90c4adcacb61a17c76623f1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xAC6Eb29EC516d11aa35b734D188B745D4EBbB719",
        "signature": "0x19b0bcf3d0ff8923fc54ec027ffdebe73619a3484e7674d1150b0d3855229fd36241a36fef73b02afaaf1bf424a7e33998ae173dbc5d4876ff05ef10f368d0311c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1A1124916A349F282625f7C580d106F237A42461",
        "signature": "0x59f9c1cb1ff98f62353b11579c22c2b96dded1fe0f9b52e8ef7509ecf88528020e84e04c97e83cb00f27e7aeb95f60f12538320ffc074d44d8c323dd285852f11b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF84A225d22fc0fBC63898EEeA81F429ECF366B2C",
        "signature": "0x01a6f801affbc0c8117da96498a09bc012b08394b51604d942fe041da0bd549f64f58741170a2d36d3f4b929ec69372c70cedb568df296060b53e546b0a9ffca1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7D861C27C146C4fc5B7Cd5D2553Cc9BDFa7BaC9f",
        "signature": "0xe41e2b48a3d1d0c965fae54d8e50dab8a30a28bdb4dbbf863f4041750deb799d163a33642d50c31b0d6b3a6f65db4c8fa86626db454b7d5247393853fa0c974b1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xdb51A64b77dA137c72582fd9b4b437778b3cDa20",
        "signature": "0x28e963c80539d6bd8779d92f854c4f5a044fe58dc0963d8524194505aecd375a7831eaacf66ce0bcaebbe581d37086e7d22bd36995b7fd79c952191e3b7fda091b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            4,
            0,
            0,
            0
        ],
        "address": "0x1e3411D2bf319ddbB20F86964a2511f40F3cBD1F",
        "signature": "0x0b0ed8cfa2f0a31cf9b3d0ef1543cf972cb00b79f024a983b82b3221d39850a9467ec1a3180d7ecf4cf2c6f2103f4c84d12a069dfe5421000cd050fac37104361b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x9A051A7fA7de5F66B8d345b5eB3bFC1580b0F5fA",
        "signature": "0xe4a9788b87f904c250673b1457b37684ca3e3f6b5ddd4008d1aaf02fcf9d838a67565a775b0c6da48aa7128889b4cb1fe299e9d765e428363e0fee9ee911deaf1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xc0f9c4C5D1Fae84FBD12B8CBb7B12A4557fB2004",
        "signature": "0xb69fc91d42222d02c02e116f7402108495b608b6609d27a82659955df96c15c52c74805a94d8b99361c3becea3cbbd2565233d3f63214e5d46656539c7acb62a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7852274f00D706d079EE44c843400fF5f4C5BDC1",
        "signature": "0xa0dfe5c82abc2214a10acef0dfc7ae8608fc8df6da2e2611d72e7cd9af02b04600f6a6d4a16c2d0c9beb8367099b338b1c30f01f31fa4456c3622b3f34f6dafe1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD0ca11d34bFEe7DF5d6dB65cAE6aF91d7f6F093e",
        "signature": "0xe1b02b119fd3469f4695b5afd27c3c55edc15c1fd5081acf95aa6c8e818129bd6d61c7bbcd9132aead9eecf0fa9bc89c1edc2e716895b8b330f94a84af7d219c1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf78D79e2b03a16b33FeF367A7f6FA5B52cFf0Bfe",
        "signature": "0x750a6d4f67bc11657836bbe760954164057a4ab5fda46daa2496feecb3c1e25e69a7483a2a0afda69f3a591f39302de95617f1f607c5d91c5b8953d4dfdc50a71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe01B4d6cB62261eA6FEBD0800a9C0666309E1dbD",
        "signature": "0x8d9fb1efcffae6204eb19801c1533c87a58f86b5124d4d7c1222e5ce8c5db82d69b25006699e0a528db84ece00fbb27582b805dfe411af04e3cc826bb47cf6c91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8392f70a336f0FA50fdE7498866eEb049862C219",
        "signature": "0x1e9a8204593ce9e8fea17bfb2681e3fe4b58291008eee2d3a2af20d6d6d119b61a2152f9c50700a669d52eb106a5a212d72330c08de79e4a65fa6320d773f5e91b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x7C405362d8917ED09430758eACB378707abc7a12",
        "signature": "0xe4d5fd5d1210e00765df416a718ce99a4487c64072a01a3a1cfbf476cd67fd6837970355018aa6f41b763793741bbddaeee1769c0169e41b2e2e8ce504bd8da41c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x4bC0865903506470B7ecadEFfaCDcA3c9e43dB22",
        "signature": "0x0f18af8ae8333c714b875e65888515c9f6d4216073b35c613a6484ac2eb80e6133b0368356f4578b521c6684a4ce247857397f73f1f219daa952e977d6c1469f1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x8Ef8b4dc3E23ffD69162FF09ED086Aa71b137392",
        "signature": "0x3b43ee89b61c9cbaae8e098246fffb0e58fc5f6f4b20cb1d2f009c8b434b9250293b9f8517f9112a3af9ff8a47777723e1c20e69124acc074be651de3375bda81c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe7819667ce5992DAD686D2A2D7CFeCeDbA73bB15",
        "signature": "0x34dde65b3a02586932da39a7b7077aa81cdcedb05550b2c7114bcec53e48c0e36f4f3b25fc12e91629a62859c5ce10fcf0657791ac3450bceb081112692c6c4c1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xa1e0002d47F5Ea429Ca3cD3cB125Fc969c6c73E5",
        "signature": "0x12e39478c06a6fc3ee07fa73461e190bd9cd77f5036832ee941ae8024061a3fa15e24736cca6b9be8f1f4b1b94662c93e0c6ac48d14fe93c7a5a8af0f291a5181c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x6D4480ad7c61Ec6D91bCfeDb193dB97208009BF5",
        "signature": "0xb858e852682a43453d9b56dfe4b7b50d9593c3bd6fabb36652d01ae6bfbd3f5449e606277626f76361664df59ea4afcecb7564919e31514de8ef7471cbdd26de1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xAe769ab6ACe7d4Ad7EB73E86A8AC6C42997d2DeE",
        "signature": "0xf9af9213760a09f2fecf2452f850d47d86677e7f1ca4ed72eda02ca42f4b2dc76b2a32c4761846d53caa265ed59adcb59433279965dab55b3bfac3e63fbc96621b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF8dfc8E2A22DeD374C2CC240B0b3FdEDBEAbe831",
        "signature": "0x96ad45446ff745138dd26732ab9d8fccd46bcfea3d5ba1443a13ec6b1814d01058c183b5142cdd4088df7522626ba03878bf51149c9f4d797bb67bf9a4e9a7481b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xAC733E991276310723F096c0573E5ae7b655F79a",
        "signature": "0x1e83d75d004889bbc138660e77724b51d632fec2ca7ec412f907ed49f3b5d20d75de7837e4ecb5b4cfd146445e6d5975e915955153539c8c87e86e7f7d8e2c021b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xa15EdF6F445896Cffa4873C8aa6FA24dB71a0756",
        "signature": "0x0f0b1f70963398ff3f3513c8e58958c5e48c188fb851fc155b2428da63bdb69f2fd4c2372f05b790749fb76de5199bc09d4f72f049e9f93069918ce35e5c2d491b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x488B47eFe49a857CE3453b6C18fa16BF823DF461",
        "signature": "0xc18e4d632848847d102204b6f00c1a1d704ec6ca92f86210ae3b656a6be4e6346ce1bc9baa74421ed8280bcd3d6cd5b8d39ac5face75b9be8e929103f26f01281c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xf1b1a843095300EF4b254E13f370229AF402F019",
        "signature": "0x81808d3d4ee69c8eeb96943d1bae475e197efb91d60375e9401d7276d7bbfe6651206f59ad0da3823b4ed70809fb372955baba3bd8f7f5ae5d87f9d0c03ab45a1c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x770385df7d9c9b4faCdE1ec8D149A45614aaA3FA",
        "signature": "0xb1d7c2ca0ca534cef05a3c4a3e803095416d0e1367444c5c71b582a792608667432e6d78cf6fda0898949e1f97d055db8e3316d22a1eca586859e18701964de51b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x789f880566F901ebc83d5C34817B9952AA8afb68",
        "signature": "0xf15a384af5e9a842c002e3be3b2a8cbb58c1fc847ef81c7747f120d07e13b2992984fcbe3e5b9651f7ad77263960d1e5b3b812ed3b230421d7aa9b09f0827ef41b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xfd0ac4B8e80E6A5B335aA5154b0D14CfEC32938b",
        "signature": "0x708dcdf30cf4c12f8edc3ea5f26bcbb4914a30e5785591f2e72f528d0bd5f145330b8c8553d5f527e2b66cb9d183cf00be82ce246aa03cfe77cbd5b6755e95551c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x17026Cc070D856f1c2F9Ae4761c9b069eA2b318B",
        "signature": "0xe28c483843edff8b1d19fc689d380c8660301329c10eec07f203c6392fec66275b3733fb749b2095f0873645e68b82f3604cdb9056319b19ff2ea4d46455db751c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xd1Ef0AB48828D2381cbdB2A953D54Cf3D0F28165",
        "signature": "0x073fe63a1a66952e67e653830a7d0efc67028ae43aa653e4ebcaeb1a2bb5ced17546450ffb32056d1cb9252b306b97c4a0952349d0624ad2a93deb5cb11d6ee31b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1Ca6CF2445a0a39151cd2fDBcd55a0e3ea5F343d",
        "signature": "0x6c80558cd2b6ee3ba38900f3cd26936a5fdef84ec4619fe6096cc6af469920d700ea119a4df33ea717f8086b91c743528581f6b3794bd7399179a188e59830541b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5ea4F0219d97628A71e85A163936e499479b9e06",
        "signature": "0x7895483154e2f98036be81be2e546d9cead72dcc93398def1b8a44d816dce56748c12394ea2078aabffd6e04eaa39ad7dc7a06f7fa6117c48d05f885b975f2481c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xE0fDAB21BDB7A60C178E05aF33Ce3D31da8775E8",
        "signature": "0x54700efd3dcd44ad29d690a5b9c156f7211ad116306e6bada798da70b9abe0c63e47328a21b15ec7c2e0b8d13bdbe702f9a2ee373b40a3669af45881dab1c2791c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x0966E6C8b28Eeb2dE766f0204b12E6A92F4844EF",
        "signature": "0x3c3f58126ada96d2b097c42387d03718422f81c7fdbbf5e208b8a3429399a026159d401efddea619ace1bd7ffe20b4b751eb874a0c62d09651519bd31f4995571b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xF0a1ABeAb8078d5f8239d856CEC993e02Ae624e3",
        "signature": "0xf159508402dd0a8fffbde5e28e5c5077b0c1389f1874682a5183d202c488153f6a5d9be8849ffb5dbf118abe4a9818f69366c110dcde03d8d170524c9c4ce82a1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x5eE42438d0D8fc399C94ef3543665E993e847b49",
        "signature": "0xf3795b88fcac6297c8bbaed61c4b30e127f7d2efa73e5d13549dbaaf7f4ed53246a77760303319eaad9195bf9c3dddf988bc297aa6179539e33bfbb9f1198d681b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xeC80EBeFd12FB8f4FD3398D0458b1A1663FB8857",
        "signature": "0x87290de3343b612af71edf69dc3da666477ea0b59b61b532e69e4fd952d9396d490f44a5b404c6d29d1970530809aacd168fbbf19f9db11c0439501423ee9bd31c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3bc0769EAC9e45017FaBFD8e353Cd68447969D9c",
        "signature": "0x2c1459bb069f9cf815e012913cb440171d6e9f8bd58b8b4684e07e18216b4293463688944fe1b1ea549cc51309a5106a93b654bd935eab321fa29ce1d32e63c01c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x1f644eCfd214AFbF2E4900a305825D7272ec6629",
        "signature": "0x2a503505ad5db7b8d90952614d26926d5224a9f55bf8ce9fd90f59a56ea6a039513a2c731a5acefe4db34b05fcf8e322a68ce770c72b4c8cbd2fc91095e896e31c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xD9C66893cdaa97fF5De4CF2549fe86C07DC5055C",
        "signature": "0x395ab8a8a8a92fca234f30ba871b59a0c45539f90918325421f3c4f1e2b811c064712ac4f389835b1862c18d33721fa1dc8df0f17350bf1bb5db255616e1944d1b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x169985A23CEac4ABcE2db001E78a9c5FD0F4cc54",
        "signature": "0x50e7b56a99daa727d416e4de9000982d2354256f0820c18a76bdffdcc286d9234820aea8ca91f8ae344b34cb3fb3accf85b4f9b76d1ebb01a33175a480158a391b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xcaBD2646e69F29c0781acc0680CCc873421259Ae",
        "signature": "0x363760c182a8f19293f210bb7e54603afc27eb09fa195140d6691a3654dc3b2a7a8eb69070282c80fae34972db8ea341e58d5cad45f57f731c1b4931ec5060c71c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xBC6771319d8Fa5242d22a1ee8992173Cad3cf3B9",
        "signature": "0x63bbb66b64e39da1cd509a9039416f193bfb77f51388902e4a197c5d37d5ec383bf04c66686c499302251dba29c6d307d7768fb33711717bd495c700f42382531c"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xe8C7cd3Bdd906df4d87cd7ffaa232F1FEB433121",
        "signature": "0x4f0afbe3fab72ec0fab672d85b7a578921d69885c1fd19aeb6e143c87b7a765a61c12353ffbcac790ac475421a72ebcd0adcb01ec1e1af5d963677bcb8b73e351b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0xba316cB6f1588bdBF36BFBD6859D923D94C7880A",
        "signature": "0xd15bcd354810842e3396022281cc7e61672cd98a9d5df17d31510dcb47c930af5de2b6082c94c6d7edc1500cb45285127230af89387450182564fd5c3c853e231b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            0,
            0,
            0
        ],
        "address": "0x3A2aA948517E265D63eaBb55dCa52e4FD83C25EF",
        "signature": "0x49f7a78f7fcc3fdf52d8e572952735ab35a22d34e31a37e144871d61a3a5520a61a10c33c3a5bf20a9289734f100c34f1df9a009609202e4c3f9d57ebeed8ca21b"
    },
    {
        "serumIds": [
            0,
            1,
            2,
            3
        ],
        "claimAmounts": [
            1,
            1,
            1,
            1
        ],
        "address": "0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266",
        "signature": "0x7cd130b31b094abb1fe7488bbce3cfa8f6c5462463e24139571a22d3a35ff23252a1afc7651bef46321c40483129d9f98d41206d25fac2b63700c5d773e3b9f81b"
    }
]

export default signatures;